var xi = Object.defineProperty;
var yi = (r, t, e) => t in r ? xi(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var $e = (r, t, e) => (yi(r, typeof t != "symbol" ? t + "" : t, e), e);
const wi = "0.51.2", pi = "1.23.0", bi = {
  "-32700": "ParseError",
  "-32600": "InvalidRequest",
  "-32601": "MethodNotFound",
  "-32602": "InvalidParams",
  "-32603": "InternalError"
};
class Ss extends Error {
}
class Bs extends Ss {
  constructor(t, e) {
    super(t), this.code = e, this.type = bi[e] ?? "ServerError";
  }
}
class mi extends Ss {
  constructor(t, e, s) {
    super(t), this.status = e, this.statusText = s;
  }
}
var Un = (r, t, e) => {
  if (!t.has(r))
    throw TypeError("Cannot " + e);
}, Ot = (r, t, e) => (Un(r, t, "read from private field"), e ? e.call(r) : t.get(r)), Be = (r, t, e) => {
  if (t.has(r))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(r) : t.set(r, e);
}, We = (r, t, e, s) => (Un(r, t, "write to private field"), s ? s.call(r, e) : t.set(r, e), e), Ei = (r, t, e, s) => ({
  set _(o) {
    We(r, t, o, e);
  },
  get _() {
    return Ot(r, t, s);
  }
}), _s = (r, t, e) => (Un(r, t, "access private method"), e), Ce, gr, Ee, qe, wr, Fe, yn, As, kn, Ts;
function vi(r) {
  const t = new URL(r);
  return t.protocol = t.protocol.replace("http", "ws"), t.toString();
}
const Si = {
  // We fudge the typing because we also check for undefined in the constructor:
  WebSocketConstructor: typeof WebSocket < "u" ? WebSocket : void 0,
  callTimeout: 3e4,
  reconnectTimeout: 3e3,
  maxReconnects: 5
};
class Bi {
  constructor(t, e = {}) {
    if (Be(this, yn), Be(this, kn), Be(this, Ce, 0), Be(this, gr, 0), Be(this, Ee, null), Be(this, qe, null), Be(this, wr, /* @__PURE__ */ new Set()), Be(this, Fe, /* @__PURE__ */ new Map()), this.endpoint = t, this.options = { ...Si, ...e }, !this.options.WebSocketConstructor)
      throw new Error("Missing WebSocket constructor");
    this.endpoint.startsWith("http") && (this.endpoint = vi(this.endpoint));
  }
  async makeRequest(t, e) {
    const s = await _s(this, yn, As).call(this);
    return new Promise((o, u) => {
      We(this, Ce, Ot(this, Ce) + 1), Ot(this, Fe).set(Ot(this, Ce), {
        resolve: o,
        reject: u,
        timeout: setTimeout(() => {
          Ot(this, Fe).delete(Ot(this, Ce)), u(new Error(`Request timeout: ${t}`));
        }, this.options.callTimeout)
      }), s.send(JSON.stringify({ jsonrpc: "2.0", id: Ot(this, Ce), method: t, params: e }));
    }).then(({ error: o, result: u }) => {
      if (o)
        throw new Bs(o.message, o.code);
      return u;
    });
  }
  async subscribe(t) {
    const e = new _i(t);
    return Ot(this, wr).add(e), await e.subscribe(this), () => e.unsubscribe(this);
  }
}
Ce = /* @__PURE__ */ new WeakMap();
gr = /* @__PURE__ */ new WeakMap();
Ee = /* @__PURE__ */ new WeakMap();
qe = /* @__PURE__ */ new WeakMap();
wr = /* @__PURE__ */ new WeakMap();
Fe = /* @__PURE__ */ new WeakMap();
yn = /* @__PURE__ */ new WeakSet();
As = function() {
  return Ot(this, qe) ? Ot(this, qe) : (We(this, qe, new Promise((r) => {
    var t;
    (t = Ot(this, Ee)) == null || t.close(), We(this, Ee, new this.options.WebSocketConstructor(this.endpoint)), Ot(this, Ee).addEventListener("open", () => {
      We(this, gr, 0), r(Ot(this, Ee));
    }), Ot(this, Ee).addEventListener("close", () => {
      Ei(this, gr)._++, Ot(this, gr) <= this.options.maxReconnects && setTimeout(() => {
        _s(this, kn, Ts).call(this);
      }, this.options.reconnectTimeout);
    }), Ot(this, Ee).addEventListener("message", ({ data: e }) => {
      let s;
      try {
        s = JSON.parse(e);
      } catch (o) {
        console.error(new Error(`Failed to parse RPC message: ${e}`, { cause: o }));
        return;
      }
      if ("id" in s && s.id != null && Ot(this, Fe).has(s.id)) {
        const { resolve: o, timeout: u } = Ot(this, Fe).get(s.id);
        clearTimeout(u), o(s);
      } else if ("params" in s) {
        const { params: o } = s;
        Ot(this, wr).forEach((u) => {
          u.subscriptionId === o.subscription && o.subscription === u.subscriptionId && u.onMessage(o.result);
        });
      }
    });
  })), Ot(this, qe));
};
kn = /* @__PURE__ */ new WeakSet();
Ts = async function() {
  var r;
  return (r = Ot(this, Ee)) == null || r.close(), We(this, qe, null), Promise.allSettled(
    [...Ot(this, wr)].map((t) => t.subscribe(this))
  );
};
class _i {
  constructor(t) {
    this.subscriptionId = null, this.subscribed = !1, this.input = t;
  }
  onMessage(t) {
    this.subscribed && this.input.onMessage(t);
  }
  async unsubscribe(t) {
    const { subscriptionId: e } = this;
    return this.subscribed = !1, e == null ? !1 : (this.subscriptionId = null, t.makeRequest(this.input.unsubscribe, [e]));
  }
  async subscribe(t) {
    this.subscriptionId = null, this.subscribed = !0;
    const e = await t.makeRequest(
      this.input.method,
      this.input.params
    );
    this.subscribed && (this.subscriptionId = e);
  }
}
var On = (r, t, e) => {
  if (!t.has(r))
    throw TypeError("Cannot " + e);
}, ne = (r, t, e) => (On(r, t, "read from private field"), e ? e.call(r) : t.get(r)), Nr = (r, t, e) => {
  if (t.has(r))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(r) : t.set(r, e);
}, wn = (r, t, e, s) => (On(r, t, "write to private field"), s ? s.call(r, e) : t.set(r, e), e), Ai = (r, t, e) => (On(r, t, "access private method"), e), hr, ue, xr, pn, Is;
class Ti {
  constructor(t) {
    Nr(this, pn), Nr(this, hr, 0), Nr(this, ue, void 0), Nr(this, xr, void 0), wn(this, ue, t);
  }
  fetch(t, e) {
    const s = ne(this, ue).fetch ?? globalThis.fetch;
    if (!s)
      throw new Error(
        "The current environment does not support fetch, you can provide a fetch implementation in the options for SuiHTTPTransport."
      );
    return s(t, e);
  }
  async request(t) {
    var o, u;
    wn(this, hr, ne(this, hr) + 1);
    const e = await this.fetch(((o = ne(this, ue).rpc) == null ? void 0 : o.url) ?? ne(this, ue).url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Client-Sdk-Type": "typescript",
        "Client-Sdk-Version": wi,
        "Client-Target-Api-Version": pi,
        ...(u = ne(this, ue).rpc) == null ? void 0 : u.headers
      },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: ne(this, hr),
        method: t.method,
        params: t.params
      })
    });
    if (!e.ok)
      throw new mi(
        `Unexpected status code: ${e.status}`,
        e.status,
        e.statusText
      );
    const s = await e.json();
    if ("error" in s && s.error != null)
      throw new Bs(s.error.message, s.error.code);
    return s.result;
  }
  async subscribe(t) {
    const e = await Ai(this, pn, Is).call(this).subscribe(t);
    return async () => !!await e();
  }
}
hr = /* @__PURE__ */ new WeakMap();
ue = /* @__PURE__ */ new WeakMap();
xr = /* @__PURE__ */ new WeakMap();
pn = /* @__PURE__ */ new WeakSet();
Is = function() {
  var r;
  if (!ne(this, xr)) {
    const t = ne(this, ue).WebSocketConstructor ?? globalThis.WebSocket;
    if (!t)
      throw new Error(
        "The current environment does not support WebSocket, you can provide a WebSocketConstructor in the options for SuiHTTPTransport."
      );
    wn(this, xr, new Bi(
      ((r = ne(this, ue).websocket) == null ? void 0 : r.url) ?? ne(this, ue).url,
      {
        WebSocketConstructor: t,
        ...ne(this, ue).websocket
      }
    ));
  }
  return ne(this, xr);
};
function Ii(r) {
  switch (r) {
    case "mainnet":
      return "https://fullnode.mainnet.sui.io:443";
    case "testnet":
      return "https://fullnode.testnet.sui.io:443";
    case "devnet":
      return "https://fullnode.devnet.sui.io:443";
    case "localnet":
      return "http://127.0.0.1:9000";
    default:
      throw new Error(`Unknown network: ${r}`);
  }
}
function Us(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Ui(r) {
  if (r.__esModule)
    return r;
  var t = r.default;
  if (typeof t == "function") {
    var e = function s() {
      return this instanceof s ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else
    e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(r).forEach(function(s) {
    var o = Object.getOwnPropertyDescriptor(r, s);
    Object.defineProperty(e, s, o.get ? o : {
      enumerable: !0,
      get: function() {
        return r[s];
      }
    });
  }), e;
}
function ki(r) {
  if (r.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), e = 0; e < t.length; e++)
    t[e] = 255;
  for (var s = 0; s < r.length; s++) {
    var o = r.charAt(s), u = o.charCodeAt(0);
    if (t[u] !== 255)
      throw new TypeError(o + " is ambiguous");
    t[u] = s;
  }
  var g = r.length, h = r.charAt(0), l = Math.log(g) / Math.log(256), y = Math.log(256) / Math.log(g);
  function S(I) {
    if (I instanceof Uint8Array || (ArrayBuffer.isView(I) ? I = new Uint8Array(I.buffer, I.byteOffset, I.byteLength) : Array.isArray(I) && (I = Uint8Array.from(I))), !(I instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (I.length === 0)
      return "";
    for (var U = 0, E = 0, k = 0, L = I.length; k !== L && I[k] === 0; )
      k++, U++;
    for (var H = (L - k) * y + 1 >>> 0, W = new Uint8Array(H); k !== L; ) {
      for (var nt = I[k], J = 0, j = H - 1; (nt !== 0 || J < E) && j !== -1; j--, J++)
        nt += 256 * W[j] >>> 0, W[j] = nt % g >>> 0, nt = nt / g >>> 0;
      if (nt !== 0)
        throw new Error("Non-zero carry");
      E = J, k++;
    }
    for (var F = H - E; F !== H && W[F] === 0; )
      F++;
    for (var it = h.repeat(U); F < H; ++F)
      it += r.charAt(W[F]);
    return it;
  }
  function p(I) {
    if (typeof I != "string")
      throw new TypeError("Expected String");
    if (I.length === 0)
      return new Uint8Array();
    for (var U = 0, E = 0, k = 0; I[U] === h; )
      E++, U++;
    for (var L = (I.length - U) * l + 1 >>> 0, H = new Uint8Array(L); I[U]; ) {
      var W = t[I.charCodeAt(U)];
      if (W === 255)
        return;
      for (var nt = 0, J = L - 1; (W !== 0 || nt < k) && J !== -1; J--, nt++)
        W += g * H[J] >>> 0, H[J] = W % 256 >>> 0, W = W / 256 >>> 0;
      if (W !== 0)
        throw new Error("Non-zero carry");
      k = nt, U++;
    }
    for (var j = L - k; j !== L && H[j] === 0; )
      j++;
    for (var F = new Uint8Array(E + (L - j)), it = E; j !== L; )
      F[it++] = H[j++];
    return F;
  }
  function N(I) {
    var U = p(I);
    if (U)
      return U;
    throw new Error("Non-base" + g + " character");
  }
  return {
    encode: S,
    decodeUnsafe: p,
    decode: N
  };
}
var Oi = ki;
const Mi = Oi, Ni = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var Li = Mi(Ni);
const ks = /* @__PURE__ */ Us(Li), Dr = (r) => ks.encode(r), mr = (r) => ks.decode(r);
function ge(r) {
  return Uint8Array.from(atob(r), (t) => t.charCodeAt(0));
}
const on = 8192;
function se(r) {
  if (r.length < on)
    return btoa(String.fromCharCode(...r));
  let t = "";
  for (var e = 0; e < r.length; e += on) {
    const s = r.slice(e, e + on);
    t += String.fromCharCode(...s);
  }
  return btoa(t);
}
function Hr(r) {
  var o;
  const t = r.startsWith("0x") ? r.slice(2) : r, s = ((o = (t.length % 2 === 0 ? t : `0${t}}`).match(/.{2}/g)) == null ? void 0 : o.map((u) => parseInt(u, 16))) ?? [];
  return Uint8Array.from(s);
}
function nr(r) {
  return r.reduce((t, e) => t + e.toString(16).padStart(2, "0"), "");
}
function Mn(r) {
  let t = [], e = 0;
  if (r === 0)
    return [0];
  for (; r > 0; )
    t[e] = r & 127, (r >>= 7) && (t[e] |= 128), e += 1;
  return t;
}
function $i(r) {
  let t = 0, e = 0, s = 0;
  for (; ; ) {
    let o = r[s];
    if (s += 1, t |= (o & 127) << e, !(o & 128))
      break;
    e += 7;
  }
  return {
    value: t,
    length: s
  };
}
class Os {
  /**
   * @param {Uint8Array} data Data to use as a buffer.
   */
  constructor(t) {
    this.bytePosition = 0, this.dataView = new DataView(t.buffer);
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(t) {
    return this.bytePosition += t, this;
  }
  /**
   * Read U8 value from the buffer and shift cursor by 1.
   * @returns
   */
  read8() {
    let t = this.dataView.getUint8(this.bytePosition);
    return this.shift(1), t;
  }
  /**
   * Read U16 value from the buffer and shift cursor by 2.
   * @returns
   */
  read16() {
    let t = this.dataView.getUint16(this.bytePosition, !0);
    return this.shift(2), t;
  }
  /**
   * Read U32 value from the buffer and shift cursor by 4.
   * @returns
   */
  read32() {
    let t = this.dataView.getUint32(this.bytePosition, !0);
    return this.shift(4), t;
  }
  /**
   * Read U64 value from the buffer and shift cursor by 8.
   * @returns
   */
  read64() {
    let t = this.read32(), s = this.read32().toString(16) + t.toString(16).padStart(8, "0");
    return BigInt("0x" + s).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 16.
   */
  read128() {
    let t = BigInt(this.read64()), s = BigInt(this.read64()).toString(16) + t.toString(16).padStart(16, "0");
    return BigInt("0x" + s).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 32.
   * @returns
   */
  read256() {
    let t = BigInt(this.read128()), s = BigInt(this.read128()).toString(16) + t.toString(16).padStart(32, "0");
    return BigInt("0x" + s).toString(10);
  }
  /**
   * Read `num` number of bytes from the buffer and shift cursor by `num`.
   * @param num Number of bytes to read.
   */
  readBytes(t) {
    let e = this.bytePosition + this.dataView.byteOffset, s = new Uint8Array(this.dataView.buffer, e, t);
    return this.shift(t), s;
  }
  /**
   * Read ULEB value - an integer of varying size. Used for enum indexes and
   * vector lengths.
   * @returns {Number} The ULEB value.
   */
  readULEB() {
    let t = this.bytePosition + this.dataView.byteOffset, e = new Uint8Array(this.dataView.buffer, t), { value: s, length: o } = $i(e);
    return this.shift(o), s;
  }
  /**
   * Read a BCS vector: read a length and then apply function `cb` X times
   * where X is the length of the vector, defined as ULEB in BCS bytes.
   * @param cb Callback to process elements of vector.
   * @returns {Array<Any>} Array of the resulting values, returned by callback.
   */
  readVec(t) {
    let e = this.readULEB(), s = [];
    for (let o = 0; o < e; o++)
      s.push(t(this, o, e));
    return s;
  }
}
function Ci(r, t) {
  switch (t) {
    case "base58":
      return Dr(r);
    case "base64":
      return se(r);
    case "hex":
      return nr(r);
    default:
      throw new Error("Unsupported encoding, supported values are: base64, hex");
  }
}
function Ri(r, t) {
  switch (t) {
    case "base58":
      return mr(r);
    case "base64":
      return ge(r);
    case "hex":
      return Hr(r);
    default:
      throw new Error("Unsupported encoding, supported values are: base64, hex");
  }
}
function Ms(r, t = ["<", ">"]) {
  const [e, s] = t, o = [];
  let u = "", g = 0;
  for (let h = 0; h < r.length; h++) {
    const l = r[h];
    if (l === e && g++, l === s && g--, g === 0 && l === ",") {
      o.push(u.trim()), u = "";
      continue;
    }
    u += l;
  }
  return o.push(u.trim()), o;
}
class Ns {
  constructor({ size: t = 1024, maxSize: e, allocateSize: s = 1024 } = {}) {
    this.bytePosition = 0, this.size = t, this.maxSize = e || t, this.allocateSize = s, this.dataView = new DataView(new ArrayBuffer(t));
  }
  ensureSizeOrGrow(t) {
    const e = this.bytePosition + t;
    if (e > this.size) {
      const s = Math.min(this.maxSize, this.size + this.allocateSize);
      if (e > s)
        throw new Error(
          `Attempting to serialize to BCS, but buffer does not have enough size. Allocated size: ${this.size}, Max size: ${this.maxSize}, Required size: ${e}`
        );
      this.size = s;
      const o = new ArrayBuffer(this.size);
      new Uint8Array(o).set(new Uint8Array(this.dataView.buffer)), this.dataView = new DataView(o);
    }
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(t) {
    return this.bytePosition += t, this;
  }
  /**
   * Write a U8 value into a buffer and shift cursor position by 1.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write8(t) {
    return this.ensureSizeOrGrow(1), this.dataView.setUint8(this.bytePosition, Number(t)), this.shift(1);
  }
  /**
   * Write a U16 value into a buffer and shift cursor position by 2.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write16(t) {
    return this.ensureSizeOrGrow(2), this.dataView.setUint16(this.bytePosition, Number(t), !0), this.shift(2);
  }
  /**
   * Write a U32 value into a buffer and shift cursor position by 4.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write32(t) {
    return this.ensureSizeOrGrow(4), this.dataView.setUint32(this.bytePosition, Number(t), !0), this.shift(4);
  }
  /**
   * Write a U64 value into a buffer and shift cursor position by 8.
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write64(t) {
    return an(BigInt(t), 8).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a U128 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write128(t) {
    return an(BigInt(t), 16).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a U256 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write256(t) {
    return an(BigInt(t), 32).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a ULEB value into a buffer and shift cursor position by number of bytes
   * written.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  writeULEB(t) {
    return Mn(t).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a vector into a buffer by first writing the vector length and then calling
   * a callback on each passed value.
   *
   * @param {Array<Any>} vector Array of elements to write.
   * @param {WriteVecCb} cb Callback to call on each element of the vector.
   * @returns {this}
   */
  writeVec(t, e) {
    return this.writeULEB(t.length), Array.from(t).forEach((s, o) => e(this, s, o, t.length)), this;
  }
  /**
   * Adds support for iterations over the object.
   * @returns {Uint8Array}
   */
  *[Symbol.iterator]() {
    for (let t = 0; t < this.bytePosition; t++)
      yield this.dataView.getUint8(t);
    return this.toBytes();
  }
  /**
   * Get underlying buffer taking only value bytes (in case initial buffer size was bigger).
   * @returns {Uint8Array} Resulting bcs.
   */
  toBytes() {
    return new Uint8Array(this.dataView.buffer.slice(0, this.bytePosition));
  }
  /**
   * Represent data as 'hex' or 'base64'
   * @param encoding Encoding to use: 'base64' or 'hex'
   */
  toString(t) {
    return Ci(this.toBytes(), t);
  }
}
function an(r, t) {
  let e = new Uint8Array(t), s = 0;
  for (; r > 0; )
    e[s] = Number(r % BigInt(256)), r = r / BigInt(256), s += 1;
  return e;
}
var Ls = (r, t, e) => {
  if (!t.has(r))
    throw TypeError("Cannot " + e);
}, he = (r, t, e) => (Ls(r, t, "read from private field"), e ? e.call(r) : t.get(r)), Pr = (r, t, e) => {
  if (t.has(r))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(r) : t.set(r, e);
}, zr = (r, t, e, s) => (Ls(r, t, "write to private field"), s ? s.call(r, e) : t.set(r, e), e), Ye, lr, Rr, Ue;
const $s = class {
  constructor(r) {
    Pr(this, Ye, void 0), Pr(this, lr, void 0), this.name = r.name, this.read = r.read, this.serializedSize = r.serializedSize ?? (() => null), zr(this, Ye, r.write), zr(this, lr, r.serialize ?? ((t, e) => {
      const s = new Ns({ size: this.serializedSize(t) ?? void 0, ...e });
      return he(this, Ye).call(this, t, s), s.toBytes();
    })), this.validate = r.validate ?? (() => {
    });
  }
  write(r, t) {
    this.validate(r), he(this, Ye).call(this, r, t);
  }
  serialize(r, t) {
    return this.validate(r), new zi(this, he(this, lr).call(this, r, t));
  }
  parse(r) {
    const t = new Os(r);
    return this.read(t);
  }
  transform({
    name: r,
    input: t,
    output: e
  }) {
    return new $s({
      name: r ?? this.name,
      read: (s) => e(this.read(s)),
      write: (s, o) => he(this, Ye).call(this, t(s), o),
      serializedSize: (s) => this.serializedSize(t(s)),
      serialize: (s, o) => he(this, lr).call(this, t(s), o),
      validate: (s) => this.validate(t(s))
    });
  }
};
let le = $s;
Ye = /* @__PURE__ */ new WeakMap();
lr = /* @__PURE__ */ new WeakMap();
const Pi = Symbol.for("@mysten/serialized-bcs");
class zi {
  constructor(t, e) {
    Pr(this, Rr, void 0), Pr(this, Ue, void 0), zr(this, Rr, t), zr(this, Ue, e);
  }
  // Used to brand SerializedBcs so that they can be identified, even between multiple copies
  // of the @mysten/bcs package are installed
  get [Pi]() {
    return !0;
  }
  toBytes() {
    return he(this, Ue);
  }
  toHex() {
    return nr(he(this, Ue));
  }
  toBase64() {
    return se(he(this, Ue));
  }
  toBase58() {
    return Dr(he(this, Ue));
  }
  parse() {
    return he(this, Rr).parse(he(this, Ue));
  }
}
Rr = /* @__PURE__ */ new WeakMap();
Ue = /* @__PURE__ */ new WeakMap();
function qr({
  size: r,
  ...t
}) {
  return new le({
    ...t,
    serializedSize: () => r
  });
}
function fn({
  readMethod: r,
  writeMethod: t,
  ...e
}) {
  return qr({
    ...e,
    read: (s) => s[r](),
    write: (s, o) => o[t](s),
    validate: (s) => {
      var o;
      if (s < 0 || s > e.maxValue)
        throw new TypeError(
          `Invalid ${e.name} value: ${s}. Expected value in range 0-${e.maxValue}`
        );
      (o = e.validate) == null || o.call(e, s);
    }
  });
}
function cn({
  readMethod: r,
  writeMethod: t,
  ...e
}) {
  return qr({
    ...e,
    read: (s) => s[r](),
    write: (s, o) => o[t](BigInt(s)),
    validate: (s) => {
      var u;
      const o = BigInt(s);
      if (o < 0 || o > e.maxValue)
        throw new TypeError(
          `Invalid ${e.name} value: ${o}. Expected value in range 0-${e.maxValue}`
        );
      (u = e.validate) == null || u.call(e, o);
    }
  });
}
function qi({
  serialize: r,
  ...t
}) {
  const e = new le({
    ...t,
    serialize: r,
    write: (s, o) => {
      for (const u of e.serialize(s).toBytes())
        o.write8(u);
    }
  });
  return e;
}
function ji({
  toBytes: r,
  fromBytes: t,
  ...e
}) {
  return new le({
    ...e,
    read: (s) => {
      const o = s.readULEB(), u = s.readBytes(o);
      return t(u);
    },
    write: (s, o) => {
      const u = r(s);
      o.writeULEB(u.length);
      for (let g = 0; g < u.length; g++)
        o.write8(u[g]);
    },
    serialize: (s) => {
      const o = r(s), u = Mn(o.length), g = new Uint8Array(u.length + o.length);
      return g.set(u, 0), g.set(o, u.length), g;
    },
    validate: (s) => {
      var o;
      if (typeof s != "string")
        throw new TypeError(`Invalid ${e.name} value: ${s}. Expected string`);
      (o = e.validate) == null || o.call(e, s);
    }
  });
}
function Vi(r) {
  let t = null;
  function e() {
    return t || (t = r()), t;
  }
  return new le({
    name: "lazy",
    read: (s) => e().read(s),
    serializedSize: (s) => e().serializedSize(s),
    write: (s, o) => e().write(s, o),
    serialize: (s, o) => e().serialize(s, o).toBytes()
  });
}
const v = {
  /**
   * Creates a BcsType that can be used to read and write an 8-bit unsigned integer.
   * @example
   * bcs.u8().serialize(255).toBytes() // Uint8Array [ 255 ]
   */
  u8(r) {
    return fn({
      name: "u8",
      readMethod: "read8",
      writeMethod: "write8",
      size: 1,
      maxValue: 2 ** 8 - 1,
      ...r
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 16-bit unsigned integer.
   * @example
   * bcs.u16().serialize(65535).toBytes() // Uint8Array [ 255, 255 ]
   */
  u16(r) {
    return fn({
      name: "u16",
      readMethod: "read16",
      writeMethod: "write16",
      size: 2,
      maxValue: 2 ** 16 - 1,
      ...r
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 32-bit unsigned integer.
   * @example
   * bcs.u32().serialize(4294967295).toBytes() // Uint8Array [ 255, 255, 255, 255 ]
   */
  u32(r) {
    return fn({
      name: "u32",
      readMethod: "read32",
      writeMethod: "write32",
      size: 4,
      maxValue: 2 ** 32 - 1,
      ...r
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 64-bit unsigned integer.
   * @example
   * bcs.u64().serialize(1).toBytes() // Uint8Array [ 1, 0, 0, 0, 0, 0, 0, 0 ]
   */
  u64(r) {
    return cn({
      name: "u64",
      readMethod: "read64",
      writeMethod: "write64",
      size: 8,
      maxValue: 2n ** 64n - 1n,
      ...r
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 128-bit unsigned integer.
   * @example
   * bcs.u128().serialize(1).toBytes() // Uint8Array [ 1, ..., 0 ]
   */
  u128(r) {
    return cn({
      name: "u128",
      readMethod: "read128",
      writeMethod: "write128",
      size: 16,
      maxValue: 2n ** 128n - 1n,
      ...r
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 256-bit unsigned integer.
   * @example
   * bcs.u256().serialize(1).toBytes() // Uint8Array [ 1, ..., 0 ]
   */
  u256(r) {
    return cn({
      name: "u256",
      readMethod: "read256",
      writeMethod: "write256",
      size: 32,
      maxValue: 2n ** 256n - 1n,
      ...r
    });
  },
  /**
   * Creates a BcsType that can be used to read and write boolean values.
   * @example
   * bcs.bool().serialize(true).toBytes() // Uint8Array [ 1 ]
   */
  bool(r) {
    return qr({
      name: "bool",
      size: 1,
      read: (t) => t.read8() === 1,
      write: (t, e) => e.write8(t ? 1 : 0),
      ...r,
      validate: (t) => {
        var e;
        if ((e = r == null ? void 0 : r.validate) == null || e.call(r, t), typeof t != "boolean")
          throw new TypeError(`Expected boolean, found ${typeof t}`);
      }
    });
  },
  /**
   * Creates a BcsType that can be used to read and write unsigned LEB encoded integers
   * @example
   *
   */
  uleb128(r) {
    return qi({
      name: "uleb128",
      read: (t) => t.readULEB(),
      serialize: (t) => Uint8Array.from(Mn(t)),
      ...r
    });
  },
  /**
   * Creates a BcsType representing a fixed length byte array
   * @param size The number of bytes this types represents
   * @example
   * bcs.bytes(3).serialize(new Uint8Array([1, 2, 3])).toBytes() // Uint8Array [1, 2, 3]
   */
  bytes(r, t) {
    return qr({
      name: `bytes[${r}]`,
      size: r,
      read: (e) => e.readBytes(r),
      write: (e, s) => {
        for (let o = 0; o < r; o++)
          s.write8(e[o] ?? 0);
      },
      ...t,
      validate: (e) => {
        var s;
        if ((s = t == null ? void 0 : t.validate) == null || s.call(t, e), !("length" in e))
          throw new TypeError(`Expected array, found ${typeof e}`);
        if (e.length !== r)
          throw new TypeError(`Expected array of length ${r}, found ${e.length}`);
      }
    });
  },
  /**
   * Creates a BcsType that can ser/de string values.  Strings will be UTF-8 encoded
   * @example
   * bcs.string().serialize('a').toBytes() // Uint8Array [ 1, 97 ]
   */
  string(r) {
    return ji({
      name: "string",
      toBytes: (t) => new TextEncoder().encode(t),
      fromBytes: (t) => new TextDecoder().decode(t),
      ...r
    });
  },
  /**
   * Creates a BcsType that represents a fixed length array of a given type
   * @param size The number of elements in the array
   * @param type The BcsType of each element in the array
   * @example
   * bcs.fixedArray(3, bcs.u8()).serialize([1, 2, 3]).toBytes() // Uint8Array [ 1, 2, 3 ]
   */
  fixedArray(r, t, e) {
    return new le({
      name: `${t.name}[${r}]`,
      read: (s) => {
        const o = new Array(r);
        for (let u = 0; u < r; u++)
          o[u] = t.read(s);
        return o;
      },
      write: (s, o) => {
        for (const u of s)
          t.write(u, o);
      },
      ...e,
      validate: (s) => {
        var o;
        if ((o = e == null ? void 0 : e.validate) == null || o.call(e, s), !("length" in s))
          throw new TypeError(`Expected array, found ${typeof s}`);
        if (s.length !== r)
          throw new TypeError(`Expected array of length ${r}, found ${s.length}`);
      }
    });
  },
  /**
   * Creates a BcsType representing an optional value
   * @param type The BcsType of the optional value
   * @example
   * bcs.option(bcs.u8()).serialize(null).toBytes() // Uint8Array [ 0 ]
   * bcs.option(bcs.u8()).serialize(1).toBytes() // Uint8Array [ 1, 1 ]
   */
  option(r) {
    return v.enum(`Option<${r.name}>`, {
      None: null,
      Some: r
    }).transform({
      input: (t) => t == null ? { None: !0 } : { Some: t },
      output: (t) => "Some" in t ? t.Some : null
    });
  },
  /**
   * Creates a BcsType representing a variable length vector of a given type
   * @param type The BcsType of each element in the vector
   *
   * @example
   * bcs.vector(bcs.u8()).toBytes([1, 2, 3]) // Uint8Array [ 3, 1, 2, 3 ]
   */
  vector(r, t) {
    return new le({
      name: `vector<${r.name}>`,
      read: (e) => {
        const s = e.readULEB(), o = new Array(s);
        for (let u = 0; u < s; u++)
          o[u] = r.read(e);
        return o;
      },
      write: (e, s) => {
        s.writeULEB(e.length);
        for (const o of e)
          r.write(o, s);
      },
      ...t,
      validate: (e) => {
        var s;
        if ((s = t == null ? void 0 : t.validate) == null || s.call(t, e), !("length" in e))
          throw new TypeError(`Expected array, found ${typeof e}`);
      }
    });
  },
  /**
   * Creates a BcsType representing a tuple of a given set of types
   * @param types The BcsTypes for each element in the tuple
   *
   * @example
   * const tuple = bcs.tuple([bcs.u8(), bcs.string(), bcs.bool()])
   * tuple.serialize([1, 'a', true]).toBytes() // Uint8Array [ 1, 1, 97, 1 ]
   */
  tuple(r, t) {
    return new le({
      name: `(${r.map((e) => e.name).join(", ")})`,
      serializedSize: (e) => {
        let s = 0;
        for (let o = 0; o < r.length; o++) {
          const u = r[o].serializedSize(e[o]);
          if (u == null)
            return null;
          s += u;
        }
        return s;
      },
      read: (e) => {
        const s = [];
        for (const o of r)
          s.push(o.read(e));
        return s;
      },
      write: (e, s) => {
        for (let o = 0; o < r.length; o++)
          r[o].write(e[o], s);
      },
      ...t,
      validate: (e) => {
        var s;
        if ((s = t == null ? void 0 : t.validate) == null || s.call(t, e), !Array.isArray(e))
          throw new TypeError(`Expected array, found ${typeof e}`);
        if (e.length !== r.length)
          throw new TypeError(`Expected array of length ${r.length}, found ${e.length}`);
      }
    });
  },
  /**
   * Creates a BcsType representing a struct of a given set of fields
   * @param name The name of the struct
   * @param fields The fields of the struct. The order of the fields affects how data is serialized and deserialized
   *
   * @example
   * const struct = bcs.struct('MyStruct', {
   *  a: bcs.u8(),
   *  b: bcs.string(),
   * })
   * struct.serialize({ a: 1, b: 'a' }).toBytes() // Uint8Array [ 1, 1, 97 ]
   */
  struct(r, t, e) {
    const s = Object.entries(t);
    return new le({
      name: r,
      serializedSize: (o) => {
        let u = 0;
        for (const [g, h] of s) {
          const l = h.serializedSize(o[g]);
          if (l == null)
            return null;
          u += l;
        }
        return u;
      },
      read: (o) => {
        const u = {};
        for (const [g, h] of s)
          u[g] = h.read(o);
        return u;
      },
      write: (o, u) => {
        for (const [g, h] of s)
          h.write(o[g], u);
      },
      ...e,
      validate: (o) => {
        var u;
        if ((u = e == null ? void 0 : e.validate) == null || u.call(e, o), typeof o != "object" || o == null)
          throw new TypeError(`Expected object, found ${typeof o}`);
      }
    });
  },
  /**
   * Creates a BcsType representing an enum of a given set of options
   * @param name The name of the enum
   * @param values The values of the enum. The order of the values affects how data is serialized and deserialized.
   * null can be used to represent a variant with no data.
   *
   * @example
   * const enum = bcs.enum('MyEnum', {
   *   A: bcs.u8(),
   *   B: bcs.string(),
   *   C: null,
   * })
   * enum.serialize({ A: 1 }).toBytes() // Uint8Array [ 0, 1 ]
   * enum.serialize({ B: 'a' }).toBytes() // Uint8Array [ 1, 1, 97 ]
   * enum.serialize({ C: true }).toBytes() // Uint8Array [ 2 ]
   */
  enum(r, t, e) {
    const s = Object.entries(t);
    return new le({
      name: r,
      read: (o) => {
        const u = o.readULEB(), [g, h] = s[u];
        return {
          [g]: (h == null ? void 0 : h.read(o)) ?? !0
        };
      },
      write: (o, u) => {
        const [g, h] = Object.entries(o)[0];
        for (let l = 0; l < s.length; l++) {
          const [y, S] = s[l];
          if (y === g) {
            u.writeULEB(l), S == null || S.write(h, u);
            return;
          }
        }
      },
      ...e,
      validate: (o) => {
        var h;
        if ((h = e == null ? void 0 : e.validate) == null || h.call(e, o), typeof o != "object" || o == null)
          throw new TypeError(`Expected object, found ${typeof o}`);
        const u = Object.keys(o);
        if (u.length !== 1)
          throw new TypeError(`Expected object with one key, found ${u.length}`);
        const [g] = u;
        if (!Object.hasOwn(t, g))
          throw new TypeError(`Invalid enum variant ${g}`);
      }
    });
  },
  /**
   * Creates a BcsType representing a map of a given key and value type
   * @param keyType The BcsType of the key
   * @param valueType The BcsType of the value
   * @example
   * const map = bcs.map(bcs.u8(), bcs.string())
   * map.serialize(new Map([[2, 'a']])).toBytes() // Uint8Array [ 1, 2, 1, 97 ]
   */
  map(r, t) {
    return v.vector(v.tuple([r, t])).transform({
      name: `Map<${r.name}, ${t.name}>`,
      input: (e) => [...e.entries()],
      output: (e) => {
        const s = /* @__PURE__ */ new Map();
        for (const [o, u] of e)
          s.set(o, u);
        return s;
      }
    });
  },
  /**
   * @deprecated
   *
   * Generics should be implemented as generic typescript functions instead:
   *
   * ```ts
   * function VecMap<K, V>, (K: BcsType<K>, V: BcsType<V>) {
   *   return bcs.struct('VecMap<K, V>', {
   *     keys: bcs.vector(K),
   *     values: bcs.vector(V),
   *   })
   * }
   * ```
   */
  generic(r, t) {
    return (...e) => t(...e).transform({
      name: `${t.name}<${e.map((s) => s.name).join(", ")}>`,
      input: (s) => s,
      output: (s) => s
    });
  },
  /**
   * Creates a BcsType that wraps another BcsType which is lazily evaluated. This is useful for creating recursive types.
   * @param cb A callback that returns the BcsType
   */
  lazy(r) {
    return Vi(r);
  }
}, Ki = 32, dr = class {
  /**
   * Construct a BCS instance with a prepared schema.
   *
   * @param schema A prepared schema with type definitions
   * @param withPrimitives Whether to register primitive types by default
   */
  constructor(r) {
    if (this.types = /* @__PURE__ */ new Map(), this.counter = 0, r instanceof dr) {
      this.schema = r.schema, this.types = new Map(r.types);
      return;
    }
    if (this.schema = r, this.registerAddressType(dr.ADDRESS, r.addressLength, r.addressEncoding), this.registerVectorType(r.vectorType), r.types && r.types.structs)
      for (let t of Object.keys(r.types.structs))
        this.registerStructType(t, r.types.structs[t]);
    if (r.types && r.types.enums)
      for (let t of Object.keys(r.types.enums))
        this.registerEnumType(t, r.types.enums[t]);
    if (r.types && r.types.aliases)
      for (let t of Object.keys(r.types.aliases))
        this.registerAlias(t, r.types.aliases[t]);
    r.withPrimitives !== !1 && Di(this);
  }
  /**
   * Name of the key to use for temporary struct definitions.
   * Returns a temp key + index (for a case when multiple temp
   * structs are processed).
   */
  tempKey() {
    return `bcs-struct-${++this.counter}`;
  }
  /**
   * Serialize data into bcs.
   *
   * @example
   * bcs.registerVectorType('vector<u8>', 'u8');
   *
   * let serialized = BCS
   *   .set('vector<u8>', [1,2,3,4,5,6])
   *   .toBytes();
   *
   * console.assert(toHex(serialized) === '06010203040506');
   *
   * @param type Name of the type to serialize (must be registered) or a struct type.
   * @param data Data to serialize.
   * @param size Serialization buffer size. Default 1024 = 1KB.
   * @return A BCS reader instance. Usually you'd want to call `.toBytes()`
   */
  ser(r, t, e) {
    if (typeof r == "string" || Array.isArray(r)) {
      const { name: s, params: o } = this.parseTypeName(r);
      return this.getTypeInterface(s).encode(this, t, e, o);
    }
    if (typeof r == "object") {
      const s = this.tempKey();
      return new dr(this).registerStructType(s, r).ser(s, t, e);
    }
    throw new Error(`Incorrect type passed into the '.ser()' function. 
${JSON.stringify(r)}`);
  }
  /**
   * Deserialize BCS into a JS type.
   *
   * @example
   * let num = bcs.ser('u64', '4294967295').toString('hex');
   * let deNum = bcs.de('u64', num, 'hex');
   * console.assert(deNum.toString(10) === '4294967295');
   *
   * @param type Name of the type to deserialize (must be registered) or a struct type definition.
   * @param data Data to deserialize.
   * @param encoding Optional - encoding to use if data is of type String
   * @return Deserialized data.
   */
  de(r, t, e) {
    if (typeof t == "string")
      if (e)
        t = Ri(t, e);
      else
        throw new Error("To pass a string to `bcs.de`, specify encoding");
    if (typeof r == "string" || Array.isArray(r)) {
      const { name: s, params: o } = this.parseTypeName(r);
      return this.getTypeInterface(s).decode(this, t, o);
    }
    if (typeof r == "object") {
      const s = new dr(this), o = this.tempKey();
      return s.registerStructType(o, r).de(o, t, e);
    }
    throw new Error(`Incorrect type passed into the '.de()' function. 
${JSON.stringify(r)}`);
  }
  /**
   * Check whether a `TypeInterface` has been loaded for a `type`.
   * @param type Name of the type to check.
   * @returns
   */
  hasType(r) {
    return this.types.has(r);
  }
  /**
   * Create an alias for a type.
   * WARNING: this can potentially lead to recursion
   * @param name Alias to use
   * @param forType Type to reference
   * @returns
   *
   * @example
   * ```
   * let bcs = new BCS(getSuiMoveConfig());
   * bcs.registerAlias('ObjectDigest', BCS.BASE58);
   * let b58_digest = bcs.de('ObjectDigest', '<digest_bytes>', 'base64');
   * ```
   */
  registerAlias(r, t) {
    return this.types.set(r, t), this;
  }
  /**
   * Method to register new types for BCS internal representation.
   * For each registered type 2 callbacks must be specified and one is optional:
   *
   * - encodeCb(writer, data) - write a way to serialize data with BcsWriter;
   * - decodeCb(reader) - write a way to deserialize data with BcsReader;
   * - validateCb(data) - validate data - either return bool or throw an error
   *
   * @example
   * // our type would be a string that consists only of numbers
   * bcs.registerType('number_string',
   *    (writer, data) => writer.writeVec(data, (w, el) => w.write8(el)),
   *    (reader) => reader.readVec((r) => r.read8()).join(''), // read each value as u8
   *    (value) => /[0-9]+/.test(value) // test that it has at least one digit
   * );
   * console.log(Array.from(bcs.ser('number_string', '12345').toBytes()) == [5,1,2,3,4,5]);
   *
   * @param name
   * @param encodeCb Callback to encode a value.
   * @param decodeCb Callback to decode a value.
   * @param validateCb Optional validator Callback to check type before serialization.
   */
  registerType(r, t, e, s = () => !0) {
    const { name: o, params: u } = this.parseTypeName(r);
    return this.types.set(o, {
      encode(g, h, l, y) {
        const S = u.reduce((p, N, I) => Object.assign(p, { [N]: y[I] }), {});
        return this._encodeRaw.call(g, new Ns(l), h, y, S);
      },
      decode(g, h, l) {
        const y = u.reduce((S, p, N) => Object.assign(S, { [p]: l[N] }), {});
        return this._decodeRaw.call(g, new Os(h), l, y);
      },
      // these methods should always be used with caution as they require pre-defined
      // reader and writer and mainly exist to allow multi-field (de)serialization;
      _encodeRaw(g, h, l, y) {
        if (s(h))
          return t.call(this, g, h, l, y);
        throw new Error(`Validation failed for type ${o}, data: ${h}`);
      },
      _decodeRaw(g, h, l) {
        return e.call(this, g, h, l);
      }
    }), this;
  }
  /**
  	 * Method to register BcsType instances to the registry
  	 * Types are registered with a callback that provides BcsType instances for each generic
  	 * passed to the type.
  	 *
  	 * - createType(...generics) - Return a BcsType instance
  	 *
  	 * @example
  	 * // our type would be a string that consists only of numbers
  	 * bcs.registerType('Box<T>', (T) => {
  	 * 		return bcs.struct({
  	 * 			value: T
  	 * 		});
  	 * });
  
  	 * console.log(Array.from(bcs.ser('Box<string>', '12345').toBytes()) == [5,1,2,3,4,5]);
  	 *
  	 * @param name
  	 * @param createType a Callback to create the BcsType with any passed in generics
  	 */
  registerBcsType(r, t) {
    return this.registerType(
      r,
      (e, s, o) => {
        const u = o.map(
          (g) => new le({
            name: String(g),
            write: (h, l) => {
              const { name: y, params: S } = this.parseTypeName(g), p = this.getTypeInterface(y), N = S.reduce((I, U, E) => Object.assign(I, { [U]: o[E] }), {});
              return p._encodeRaw.call(this, l, h, S, N);
            },
            read: () => {
              throw new Error("Not implemented");
            }
          })
        );
        return t(...u).write(s, e), e;
      },
      (e, s) => {
        const o = s.map(
          (u) => new le({
            name: String(u),
            write: (g, h) => {
              throw new Error("Not implemented");
            },
            read: (g) => {
              const { name: h, params: l } = this.parseTypeName(u), y = this.getTypeInterface(h), S = l.reduce((p, N, I) => Object.assign(p, { [N]: s[I] }), {});
              return y._decodeRaw.call(this, g, l, S);
            }
          })
        );
        return t(...o).read(e);
      }
    ), this;
  }
  /**
   * Register an address type which is a sequence of U8s of specified length.
   * @example
   * bcs.registerAddressType('address', SUI_ADDRESS_LENGTH);
   * let addr = bcs.de('address', 'c3aca510c785c7094ac99aeaa1e69d493122444df50bb8a99dfa790c654a79af');
   *
   * @param name Name of the address type.
   * @param length Byte length of the address.
   * @param encoding Encoding to use for the address type
   * @returns
   */
  registerAddressType(r, t, e = "hex") {
    switch (e) {
      case "base64":
        return this.registerType(
          r,
          function(o, u) {
            return ge(u).reduce((g, h) => g.write8(h), o);
          },
          function(o) {
            return se(o.readBytes(t));
          }
        );
      case "hex":
        return this.registerType(
          r,
          function(o, u) {
            return Hr(u).reduce((g, h) => g.write8(h), o);
          },
          function(o) {
            return nr(o.readBytes(t));
          }
        );
      default:
        throw new Error("Unsupported encoding! Use either hex or base64");
    }
  }
  /**
   * Register custom vector type inside the bcs.
   *
   * @example
   * bcs.registerVectorType('vector<T>'); // generic registration
   * let array = bcs.de('vector<u8>', '06010203040506', 'hex'); // [1,2,3,4,5,6];
   * let again = bcs.ser('vector<u8>', [1,2,3,4,5,6]).toString('hex');
   *
   * @param name Name of the type to register
   * @param elementType Optional name of the inner type of the vector
   * @return Returns self for chaining.
   */
  registerVectorType(r) {
    let { name: t, params: e } = this.parseTypeName(r);
    if (e.length > 1)
      throw new Error("Vector can have only one type parameter; got " + t);
    return this.registerType(
      r,
      function(o, u, g, h) {
        return o.writeVec(u, (l, y) => {
          let S = g[0];
          if (!S)
            throw new Error(`Incorrect number of type parameters passed a to vector '${r}'`);
          let { name: p, params: N } = this.parseTypeName(S);
          if (this.hasType(p))
            return this.getTypeInterface(p)._encodeRaw.call(this, l, y, N, h);
          if (!(p in h))
            throw new Error(
              `Unable to find a matching type definition for ${p} in vector; make sure you passed a generic`
            );
          let { name: I, params: U } = this.parseTypeName(h[p]);
          return this.getTypeInterface(I)._encodeRaw.call(
            this,
            l,
            y,
            U,
            h
          );
        });
      },
      function(o, u, g) {
        return o.readVec((h) => {
          let l = u[0];
          if (!l)
            throw new Error(`Incorrect number of type parameters passed to a vector '${r}'`);
          let { name: y, params: S } = this.parseTypeName(l);
          if (this.hasType(y))
            return this.getTypeInterface(y)._decodeRaw.call(this, h, S, g);
          if (!(y in g))
            throw new Error(
              `Unable to find a matching type definition for ${y} in vector; make sure you passed a generic`
            );
          let { name: p, params: N } = this.parseTypeName(g[y]);
          return this.getTypeInterface(p)._decodeRaw.call(
            this,
            h,
            N,
            g
          );
        });
      }
    );
  }
  /**
   * Safe method to register a custom Move struct. The first argument is a name of the
   * struct which is only used on the FrontEnd and has no affect on serialization results,
   * and the second is a struct description passed as an Object.
   *
   * The description object MUST have the same order on all of the platforms (ie in Move
   * or in Rust).
   *
   * @example
   * // Move / Rust struct
   * // struct Coin {
   * //   value: u64,
   * //   owner: vector<u8>, // name // Vec<u8> in Rust
   * //   is_locked: bool,
   * // }
   *
   * bcs.registerStructType('Coin', {
   *   value: bcs.U64,
   *   owner: bcs.STRING,
   *   is_locked: bcs.BOOL
   * });
   *
   * // Created in Rust with diem/bcs
   * // let rust_bcs_str = '80d1b105600000000e4269672057616c6c65742047757900';
   * let rust_bcs_str = [ // using an Array here as BCS works with Uint8Array
   *  128, 209, 177,   5,  96,  0,  0,
   *    0,  14,  66, 105, 103, 32, 87,
   *   97, 108, 108, 101, 116, 32, 71,
   *  117, 121,   0
   * ];
   *
   * // Let's encode the value as well
   * let test_set = bcs.ser('Coin', {
   *   owner: 'Big Wallet Guy',
   *   value: '412412400000',
   *   is_locked: false,
   * });
   *
   * console.assert(Array.from(test_set.toBytes()) === rust_bcs_str, 'Whoopsie, result mismatch');
   *
   * @param name Name of the type to register.
   * @param fields Fields of the struct. Must be in the correct order.
   * @return Returns BCS for chaining.
   */
  registerStructType(r, t) {
    for (let g in t) {
      let h = this.tempKey(), l = t[g];
      !Array.isArray(l) && typeof l != "string" && (t[g] = h, this.registerStructType(h, l));
    }
    let e = Object.freeze(t), s = Object.keys(e), { name: o, params: u } = this.parseTypeName(r);
    return this.registerType(
      r,
      function(h, l, y, S) {
        if (!l || l.constructor !== Object)
          throw new Error(`Expected ${o} to be an Object, got: ${l}`);
        if (y.length !== u.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${u.length}, got: ${y.length}`
          );
        for (let p of s) {
          if (!(p in l))
            throw new Error(`Struct ${o} requires field ${p}:${e[p]}`);
          const { name: N, params: I } = this.parseTypeName(
            e[p]
          );
          if (!u.includes(N))
            this.getTypeInterface(N)._encodeRaw.call(
              this,
              h,
              l[p],
              I,
              S
            );
          else {
            const U = u.indexOf(N);
            let { name: E, params: k } = this.parseTypeName(y[U]);
            if (this.hasType(E)) {
              this.getTypeInterface(E)._encodeRaw.call(
                this,
                h,
                l[p],
                k,
                S
              );
              continue;
            }
            if (!(E in S))
              throw new Error(
                `Unable to find a matching type definition for ${E} in ${o}; make sure you passed a generic`
              );
            let { name: L, params: H } = this.parseTypeName(S[E]);
            this.getTypeInterface(L)._encodeRaw.call(
              this,
              h,
              l[p],
              H,
              S
            );
          }
        }
        return h;
      },
      function(h, l, y) {
        if (l.length !== u.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${u.length}, got: ${l.length}`
          );
        let S = {};
        for (let p of s) {
          const { name: N, params: I } = this.parseTypeName(
            e[p]
          );
          if (!u.includes(N))
            S[p] = this.getTypeInterface(N)._decodeRaw.call(
              this,
              h,
              I,
              y
            );
          else {
            const U = u.indexOf(N);
            let { name: E, params: k } = this.parseTypeName(l[U]);
            if (this.hasType(E)) {
              S[p] = this.getTypeInterface(E)._decodeRaw.call(
                this,
                h,
                k,
                y
              );
              continue;
            }
            if (!(E in y))
              throw new Error(
                `Unable to find a matching type definition for ${E} in ${o}; make sure you passed a generic`
              );
            let { name: L, params: H } = this.parseTypeName(y[E]);
            S[p] = this.getTypeInterface(L)._decodeRaw.call(
              this,
              h,
              H,
              y
            );
          }
        }
        return S;
      }
    );
  }
  /**
   * Safe method to register custom enum type where each invariant holds the value of another type.
   * @example
   * bcs.registerStructType('Coin', { value: 'u64' });
   * bcs.registerEnumType('MyEnum', {
   *  single: 'Coin',
   *  multi: 'vector<Coin>',
   *  empty: null
   * });
   *
   * console.log(
   *  bcs.de('MyEnum', 'AICWmAAAAAAA', 'base64'), // { single: { value: 10000000 } }
   *  bcs.de('MyEnum', 'AQIBAAAAAAAAAAIAAAAAAAAA', 'base64')  // { multi: [ { value: 1 }, { value: 2 } ] }
   * )
   *
   * // and serialization
   * bcs.ser('MyEnum', { single: { value: 10000000 } }).toBytes();
   * bcs.ser('MyEnum', { multi: [ { value: 1 }, { value: 2 } ] });
   *
   * @param name
   * @param variants
   */
  registerEnumType(r, t) {
    for (let g in t) {
      let h = this.tempKey(), l = t[g];
      l !== null && !Array.isArray(l) && typeof l != "string" && (t[g] = h, this.registerStructType(h, l));
    }
    let e = Object.freeze(t), s = Object.keys(e), { name: o, params: u } = this.parseTypeName(r);
    return this.registerType(
      r,
      function(h, l, y, S) {
        if (!l)
          throw new Error(`Unable to write enum "${o}", missing data.
Received: "${l}"`);
        if (typeof l != "object")
          throw new Error(
            `Incorrect data passed into enum "${o}", expected object with properties: "${s.join(
              " | "
            )}".
Received: "${JSON.stringify(l)}"`
          );
        let p = Object.keys(l)[0];
        if (p === void 0)
          throw new Error(`Empty object passed as invariant of the enum "${o}"`);
        let N = s.indexOf(p);
        if (N === -1)
          throw new Error(
            `Unknown invariant of the enum "${o}", allowed values: "${s.join(
              " | "
            )}"; received "${p}"`
          );
        let I = s[N], U = e[I];
        if (h.write8(N), U === null)
          return h;
        let E = u.indexOf(U), k = E === -1 ? U : y[E];
        {
          let { name: L, params: H } = this.parseTypeName(k);
          return this.getTypeInterface(L)._encodeRaw.call(
            this,
            h,
            l[p],
            H,
            S
          );
        }
      },
      function(h, l, y) {
        let S = h.readULEB(), p = s[S], N = e[p];
        if (S === -1)
          throw new Error(
            `Decoding type mismatch, expected enum "${o}" invariant index, received "${S}"`
          );
        if (N === null)
          return { [p]: !0 };
        let I = u.indexOf(N), U = I === -1 ? N : l[I];
        {
          let { name: E, params: k } = this.parseTypeName(U);
          return {
            [p]: this.getTypeInterface(E)._decodeRaw.call(this, h, k, y)
          };
        }
      }
    );
  }
  /**
   * Get a set of encoders/decoders for specific type.
   * Mainly used to define custom type de/serialization logic.
   *
   * @param type
   * @returns {TypeInterface}
   */
  getTypeInterface(r) {
    let t = this.types.get(r);
    if (typeof t == "string") {
      let e = [];
      for (; typeof t == "string"; ) {
        if (e.includes(t))
          throw new Error(`Recursive definition found: ${e.join(" -> ")} -> ${t}`);
        e.push(t), t = this.types.get(t);
      }
    }
    if (t === void 0)
      throw new Error(`Type ${r} is not registered`);
    return t;
  }
  /**
   * Parse a type name and get the type's generics.
   * @example
   * let { typeName, typeParams } = parseTypeName('Option<Coin<SUI>>');
   * // typeName: Option
   * // typeParams: [ 'Coin<SUI>' ]
   *
   * @param name Name of the type to process
   * @returns Object with typeName and typeParams listed as Array
   */
  parseTypeName(r) {
    if (Array.isArray(r)) {
      let [h, ...l] = r;
      return { name: h, params: l };
    }
    if (typeof r != "string")
      throw new Error(`Illegal type passed as a name of the type: ${r}`);
    let [t, e] = this.schema.genericSeparators || ["<", ">"], s = r.indexOf(t), o = Array.from(r).reverse().indexOf(e);
    if (s === -1 && o === -1)
      return { name: r, params: [] };
    if (s === -1 || o === -1)
      throw new Error(`Unclosed generic in name '${r}'`);
    let u = r.slice(0, s), g = Ms(
      r.slice(s + 1, r.length - o - 1),
      this.schema.genericSeparators
    );
    return { name: u, params: g };
  }
};
let At = dr;
At.U8 = "u8";
At.U16 = "u16";
At.U32 = "u32";
At.U64 = "u64";
At.U128 = "u128";
At.U256 = "u256";
At.BOOL = "bool";
At.VECTOR = "vector";
At.ADDRESS = "address";
At.STRING = "string";
At.HEX = "hex-string";
At.BASE58 = "base58-string";
At.BASE64 = "base64-string";
function Di(r) {
  r.registerType(
    At.U8,
    function(t, e) {
      return t.write8(e);
    },
    function(t) {
      return t.read8();
    },
    (t) => t < 256
  ), r.registerType(
    At.U16,
    function(t, e) {
      return t.write16(e);
    },
    function(t) {
      return t.read16();
    },
    (t) => t < 65536
  ), r.registerType(
    At.U32,
    function(t, e) {
      return t.write32(e);
    },
    function(t) {
      return t.read32();
    },
    (t) => t <= 4294967296n
  ), r.registerType(
    At.U64,
    function(t, e) {
      return t.write64(e);
    },
    function(t) {
      return t.read64();
    }
  ), r.registerType(
    At.U128,
    function(t, e) {
      return t.write128(e);
    },
    function(t) {
      return t.read128();
    }
  ), r.registerType(
    At.U256,
    function(t, e) {
      return t.write256(e);
    },
    function(t) {
      return t.read256();
    }
  ), r.registerType(
    At.BOOL,
    function(t, e) {
      return t.write8(e);
    },
    function(t) {
      return t.read8().toString(10) === "1";
    }
  ), r.registerType(
    At.STRING,
    function(t, e) {
      return t.writeVec(Array.from(e), (s, o) => s.write8(o.charCodeAt(0)));
    },
    function(t) {
      return t.readVec((e) => e.read8()).map((e) => String.fromCharCode(Number(e))).join("");
    },
    (t) => !0
  ), r.registerType(
    At.HEX,
    function(t, e) {
      return t.writeVec(Array.from(Hr(e)), (s, o) => s.write8(o));
    },
    function(t) {
      let e = t.readVec((s) => s.read8());
      return nr(new Uint8Array(e));
    }
  ), r.registerType(
    At.BASE58,
    function(t, e) {
      return t.writeVec(Array.from(mr(e)), (s, o) => s.write8(o));
    },
    function(t) {
      let e = t.readVec((s) => s.read8());
      return Dr(new Uint8Array(e));
    }
  ), r.registerType(
    At.BASE64,
    function(t, e) {
      return t.writeVec(Array.from(ge(e)), (s, o) => s.write8(o));
    },
    function(t) {
      let e = t.readVec((s) => s.read8());
      return se(new Uint8Array(e));
    }
  );
}
function Hi() {
  return {
    genericSeparators: ["<", ">"],
    vectorType: "vector",
    addressLength: Ki,
    addressEncoding: "hex"
  };
}
const Gi = 32;
function us(r) {
  try {
    return mr(r).length === Gi;
  } catch {
    return !1;
  }
}
const Er = 32;
function Re(r) {
  return Zi(r) && Yi(r) === Er;
}
function Lr(r) {
  return Re(r);
}
function Xt(r, t = !1) {
  let e = r.toLowerCase();
  return !t && e.startsWith("0x") && (e = e.slice(2)), `0x${e.padStart(Er * 2, "0")}`;
}
function $r(r, t = !1) {
  return Xt(r, t);
}
function Zi(r) {
  return /^(0x|0X)?[a-fA-F0-9]+$/.test(r) && r.length % 2 === 0;
}
function Yi(r) {
  return /^(0x|0X)/.test(r) ? (r.length - 2) / 2 : r.length / 2;
}
const Wi = /^vector<(.+)>$/, Fi = /^([^:]+)::([^:]+)::([^<]+)(<(.+)>)?/;
class ke {
  static parseFromStr(t, e = !1) {
    if (t === "address")
      return { address: null };
    if (t === "bool")
      return { bool: null };
    if (t === "u8")
      return { u8: null };
    if (t === "u16")
      return { u16: null };
    if (t === "u32")
      return { u32: null };
    if (t === "u64")
      return { u64: null };
    if (t === "u128")
      return { u128: null };
    if (t === "u256")
      return { u256: null };
    if (t === "signer")
      return { signer: null };
    const s = t.match(Wi);
    if (s)
      return {
        vector: ke.parseFromStr(s[1], e)
      };
    const o = t.match(Fi);
    if (o)
      return {
        struct: {
          address: e ? Xt(o[1]) : o[1],
          module: o[2],
          name: o[3],
          typeParams: o[5] === void 0 ? [] : ke.parseStructTypeArgs(o[5], e)
        }
      };
    throw new Error(`Encountered unexpected token when parsing type args for ${t}`);
  }
  static parseStructTypeArgs(t, e = !1) {
    return Ms(t).map(
      (s) => ke.parseFromStr(s, e)
    );
  }
  static tagToString(t) {
    if ("bool" in t)
      return "bool";
    if ("u8" in t)
      return "u8";
    if ("u16" in t)
      return "u16";
    if ("u32" in t)
      return "u32";
    if ("u64" in t)
      return "u64";
    if ("u128" in t)
      return "u128";
    if ("u256" in t)
      return "u256";
    if ("address" in t)
      return "address";
    if ("signer" in t)
      return "signer";
    if ("vector" in t)
      return `vector<${ke.tagToString(t.vector)}>`;
    if ("struct" in t) {
      const e = t.struct, s = e.typeParams.map(ke.tagToString).join(", ");
      return `${e.address}::${e.module}::${e.name}${s ? `<${s}>` : ""}`;
    }
    throw new Error("Invalid TypeTag");
  }
}
const _t = new At({
  ...Hi(),
  types: {
    enums: {
      "Option<T>": {
        None: null,
        Some: "T"
      }
    }
  }
});
function Cs(r) {
  return v.u64({
    name: "unsafe_u64",
    ...r
  }).transform({
    input: (t) => t,
    output: (t) => Number(t)
  });
}
function Xi(r) {
  return v.enum("Option", {
    None: null,
    Some: r
  });
}
function Nn(r) {
  return r.transform({
    input: (t) => ({
      [t.kind]: t
    }),
    output: (t) => {
      const e = Object.keys(t)[0];
      return { kind: e, ...t[e] };
    }
  });
}
const de = v.bytes(Er).transform({
  input: (r) => typeof r == "string" ? Hr(Xt(r)) : r,
  output: (r) => Xt(nr(r))
}), Ln = v.vector(v.u8()).transform({
  name: "ObjectDigest",
  input: (r) => mr(r),
  output: (r) => Dr(new Uint8Array(r))
}), pr = v.struct("SuiObjectRef", {
  objectId: de,
  version: v.u64(),
  digest: Ln
}), $n = v.struct("SharedObjectRef", {
  objectId: de,
  initialSharedVersion: v.u64(),
  mutable: v.bool()
}), jr = v.enum("ObjectArg", {
  ImmOrOwned: pr,
  Shared: $n,
  Receiving: pr
}), Cn = v.enum("CallArg", {
  Pure: v.vector(v.u8()),
  Object: jr,
  ObjVec: v.vector(jr)
}), sr = v.enum("TypeTag", {
  bool: null,
  u8: null,
  u64: null,
  u128: null,
  address: null,
  signer: null,
  vector: v.lazy(() => sr),
  struct: v.lazy(() => Vn),
  u16: null,
  u32: null,
  u256: null
}), fe = Nn(
  v.enum("Argument", {
    GasCoin: null,
    Input: v.struct("Input", { index: v.u16() }),
    Result: v.struct("Result", { index: v.u16() }),
    NestedResult: v.struct("NestedResult", { index: v.u16(), resultIndex: v.u16() })
  })
), Rn = v.struct("ProgrammableMoveCall", {
  package: de,
  module: v.string(),
  function: v.string(),
  type_arguments: v.vector(sr),
  arguments: v.vector(fe)
}).transform({
  input: (r) => {
    const [t, e, s] = r.target.split("::"), o = r.typeArguments.map(
      (u) => ke.parseFromStr(u, !0)
    );
    return {
      package: Xt(t),
      module: e,
      function: s,
      type_arguments: o,
      arguments: r.arguments
    };
  },
  output: (r) => ({
    target: [r.package, r.module, r.function].join(
      "::"
    ),
    arguments: r.arguments,
    typeArguments: r.type_arguments.map(ke.tagToString)
  })
}), Pn = Nn(
  v.enum("Transaction", {
    /**
     * A Move Call - any public Move function can be called via
     * this transaction. The results can be used that instant to pass
     * into the next transaction.
     */
    MoveCall: Rn,
    /**
     * Transfer vector of objects to a receiver.
     */
    TransferObjects: v.struct("TransferObjects", {
      objects: v.vector(fe),
      address: fe
    }),
    /**
     * Split `amount` from a `coin`.
     */
    SplitCoins: v.struct("SplitCoins", { coin: fe, amounts: v.vector(fe) }),
    /**
     * Merge Vector of Coins (`sources`) into a `destination`.
     */
    MergeCoins: v.struct("MergeCoins", { destination: fe, sources: v.vector(fe) }),
    /**
     * Publish a Move module.
     */
    Publish: v.struct("Publish", {
      modules: v.vector(v.vector(v.u8())),
      dependencies: v.vector(de)
    }),
    /**
     * Build a vector of objects using the input arguments.
     * It is impossible to construct a `vector<T: key>` otherwise,
     * so this call serves a utility function.
     */
    MakeMoveVec: v.struct("MakeMoveVec", {
      type: Xi(sr),
      objects: v.vector(fe)
    }),
    /**  */
    Upgrade: v.struct("Upgrade", {
      modules: v.vector(v.vector(v.u8())),
      dependencies: v.vector(de),
      packageId: de,
      ticket: fe
    })
  })
), zn = v.struct("ProgrammableTransaction", {
  inputs: v.vector(Cn),
  transactions: v.vector(Pn)
}), qn = v.enum("TransactionKind", {
  ProgrammableTransaction: zn,
  ChangeEpoch: null,
  Genesis: null,
  ConsensusCommitPrologue: null
}), jn = v.enum("TransactionExpiration", {
  None: null,
  Epoch: Cs()
}), Vn = v.struct("StructTag", {
  address: de,
  module: v.string(),
  name: v.string(),
  typeParams: v.vector(sr)
}), Kn = v.struct("GasData", {
  payment: v.vector(pr),
  owner: de,
  price: v.u64(),
  budget: v.u64()
}), Dn = v.struct("TransactionDataV1", {
  kind: qn,
  sender: de,
  gasData: Kn,
  expiration: jn
}), Hn = v.enum("TransactionData", {
  V1: Dn
}), Ji = v.enum("IntentScope", {
  TransactionData: null,
  TransactionEffects: null,
  CheckpointSummary: null,
  PersonalMessage: null
}), Qi = v.enum("IntentVersion", {
  V0: null
}), to = v.enum("AppId", {
  Sui: null
}), eo = v.struct("Intent", {
  scope: Ji,
  version: Qi,
  appId: to
}), ro = v.generic(
  ["T"],
  (r) => v.struct("IntentMessage<T>", {
    intent: eo,
    value: r
  })
), Gn = v.enum("CompressedSignature", {
  ED25519: v.fixedArray(64, v.u8()),
  Secp256k1: v.fixedArray(64, v.u8()),
  Secp256r1: v.fixedArray(64, v.u8()),
  ZkLogin: v.vector(v.u8())
}), Zn = v.enum("PublicKey", {
  ED25519: v.fixedArray(32, v.u8()),
  Secp256k1: v.fixedArray(33, v.u8()),
  Secp256r1: v.fixedArray(33, v.u8()),
  ZkLogin: v.vector(v.u8())
}), Yn = v.struct("MultiSigPkMap", {
  pubKey: Zn,
  weight: v.u8()
}), Wn = v.struct("MultiSigPublicKey", {
  pk_map: v.vector(Yn),
  threshold: v.u16()
}), Rs = v.struct("MultiSig", {
  sigs: v.vector(Gn),
  bitmap: v.u16(),
  multisig_pk: Wn
}), no = v.vector(v.u8()).transform({
  input: (r) => typeof r == "string" ? ge(r) : r,
  output: (r) => se(new Uint8Array(r))
}), Ps = v.struct("SenderSignedTransaction", {
  intentMessage: ro(Hn),
  txSignatures: v.vector(no)
}), zs = v.vector(Ps, {
  name: "SenderSignedData"
}), ye = {
  ...v,
  U8: v.u8(),
  U16: v.u16(),
  U32: v.u32(),
  U64: v.u64(),
  U128: v.u128(),
  U256: v.u256(),
  ULEB128: v.uleb128(),
  Bool: v.bool(),
  String: v.string(),
  Address: de,
  Argument: fe,
  CallArg: Cn,
  CompressedSignature: Gn,
  GasData: Kn,
  MultiSig: Rs,
  MultiSigPkMap: Yn,
  MultiSigPublicKey: Wn,
  ObjectArg: jr,
  ObjectDigest: Ln,
  ProgrammableMoveCall: Rn,
  ProgrammableTransaction: zn,
  PublicKey: Zn,
  SenderSignedData: zs,
  SenderSignedTransaction: Ps,
  SharedObjectRef: $n,
  StructTag: Vn,
  SuiObjectRef: pr,
  Transaction: Pn,
  TransactionData: Hn,
  TransactionDataV1: Dn,
  TransactionExpiration: jn,
  TransactionKind: qn,
  TypeTag: sr,
  // preserve backwards compatibility with old bcs export
  ser: _t.ser.bind(_t),
  de: _t.de.bind(_t),
  getTypeInterface: _t.getTypeInterface.bind(_t),
  hasType: _t.hasType.bind(_t),
  parseTypeName: _t.parseTypeName.bind(_t),
  registerAddressType: _t.registerAddressType.bind(_t),
  registerAlias: _t.registerAlias.bind(_t),
  registerBcsType: _t.registerBcsType.bind(_t),
  registerEnumType: _t.registerEnumType.bind(_t),
  registerStructType: _t.registerStructType.bind(_t),
  registerType: _t.registerType.bind(_t),
  types: _t.types
};
_t.registerBcsType("utf8string", () => v.string({ name: "utf8string" }));
_t.registerBcsType("unsafe_u64", () => Cs());
_t.registerBcsType("enumKind", (r) => Nn(r));
[
  de,
  fe,
  Cn,
  Gn,
  Kn,
  Rs,
  Yn,
  Wn,
  jr,
  Ln,
  Rn,
  zn,
  Zn,
  zs,
  $n,
  Vn,
  pr,
  Pn,
  Hn,
  Dn,
  jn,
  qn,
  sr
].forEach((r) => {
  _t.registerBcsType(r.name, () => r);
});
function yr(r) {
  if (!Number.isSafeInteger(r) || r < 0)
    throw new Error(`positive integer expected, not ${r}`);
}
function so(r) {
  return r instanceof Uint8Array || r != null && typeof r == "object" && r.constructor.name === "Uint8Array";
}
function vr(r, ...t) {
  if (!so(r))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(r.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${r.length}`);
}
function io(r) {
  if (typeof r != "function" || typeof r.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  yr(r.outputLen), yr(r.blockLen);
}
function Xe(r, t = !0) {
  if (r.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && r.finished)
    throw new Error("Hash#digest() has already been called");
}
function qs(r, t) {
  vr(r);
  const e = t.outputLen;
  if (r.length < e)
    throw new Error(`digestInto() expects output buffer of length at least ${e}`);
}
const un = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Vr = (r) => new Uint32Array(r.buffer, r.byteOffset, Math.floor(r.byteLength / 4)), hn = (r) => new DataView(r.buffer, r.byteOffset, r.byteLength), xe = (r, t) => r << 32 - t | r >>> t, Pe = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, js = (r) => r << 24 & 4278190080 | r << 8 & 16711680 | r >>> 8 & 65280 | r >>> 24 & 255, me = Pe ? (r) => r : (r) => js(r);
function Ze(r) {
  for (let t = 0; t < r.length; t++)
    r[t] = js(r[t]);
}
const oo = /* @__PURE__ */ Array.from({ length: 256 }, (r, t) => t.toString(16).padStart(2, "0"));
function Fn(r) {
  vr(r);
  let t = "";
  for (let e = 0; e < r.length; e++)
    t += oo[r[e]];
  return t;
}
const pe = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function hs(r) {
  if (r >= pe._0 && r <= pe._9)
    return r - pe._0;
  if (r >= pe._A && r <= pe._F)
    return r - (pe._A - 10);
  if (r >= pe._a && r <= pe._f)
    return r - (pe._a - 10);
}
function ao(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  const t = r.length, e = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const s = new Uint8Array(e);
  for (let o = 0, u = 0; o < e; o++, u += 2) {
    const g = hs(r.charCodeAt(u)), h = hs(r.charCodeAt(u + 1));
    if (g === void 0 || h === void 0) {
      const l = r[u] + r[u + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + u);
    }
    s[o] = g * 16 + h;
  }
  return s;
}
function fo(r) {
  if (typeof r != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof r}`);
  return new Uint8Array(new TextEncoder().encode(r));
}
function Oe(r) {
  return typeof r == "string" && (r = fo(r)), vr(r), r;
}
function co(...r) {
  let t = 0;
  for (let s = 0; s < r.length; s++) {
    const o = r[s];
    vr(o), t += o.length;
  }
  const e = new Uint8Array(t);
  for (let s = 0, o = 0; s < r.length; s++) {
    const u = r[s];
    e.set(u, o), o += u.length;
  }
  return e;
}
class Xn {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function uo(r) {
  const t = (s) => r().update(Oe(s)).digest(), e = r();
  return t.outputLen = e.outputLen, t.blockLen = e.blockLen, t.create = () => r(), t;
}
function ho(r) {
  const t = (s, o) => r(o).update(Oe(s)).digest(), e = r({});
  return t.outputLen = e.outputLen, t.blockLen = e.blockLen, t.create = (s) => r(s), t;
}
function lo(r = 32) {
  if (un && typeof un.getRandomValues == "function")
    return un.getRandomValues(new Uint8Array(r));
  throw new Error("crypto.getRandomValues must be defined");
}
const go = /* @__PURE__ */ new Uint8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
]);
class xo extends Xn {
  constructor(t, e, s = {}, o, u, g) {
    if (super(), this.blockLen = t, this.outputLen = e, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, yr(t), yr(e), yr(o), e < 0 || e > o)
      throw new Error("outputLen bigger than keyLen");
    if (s.key !== void 0 && (s.key.length < 1 || s.key.length > o))
      throw new Error(`key must be up 1..${o} byte long or undefined`);
    if (s.salt !== void 0 && s.salt.length !== u)
      throw new Error(`salt must be ${u} byte long or undefined`);
    if (s.personalization !== void 0 && s.personalization.length !== g)
      throw new Error(`personalization must be ${g} byte long or undefined`);
    this.buffer32 = Vr(this.buffer = new Uint8Array(t));
  }
  update(t) {
    Xe(this);
    const { blockLen: e, buffer: s, buffer32: o } = this;
    t = Oe(t);
    const u = t.length, g = t.byteOffset, h = t.buffer;
    for (let l = 0; l < u; ) {
      this.pos === e && (Pe || Ze(o), this.compress(o, 0, !1), Pe || Ze(o), this.pos = 0);
      const y = Math.min(e - this.pos, u - l), S = g + l;
      if (y === e && !(S % 4) && l + y < u) {
        const p = new Uint32Array(h, S, Math.floor((u - l) / 4));
        Pe || Ze(p);
        for (let N = 0; l + e < u; N += o.length, l += e)
          this.length += e, this.compress(p, N, !1);
        Pe || Ze(p);
        continue;
      }
      s.set(t.subarray(l, l + y), this.pos), this.pos += y, this.length += y, l += y;
    }
    return this;
  }
  digestInto(t) {
    Xe(this), qs(t, this);
    const { pos: e, buffer32: s } = this;
    this.finished = !0, this.buffer.subarray(e).fill(0), Pe || Ze(s), this.compress(s, 0, !0), Pe || Ze(s);
    const o = Vr(t);
    this.get().forEach((u, g) => o[g] = me(u));
  }
  digest() {
    const { buffer: t, outputLen: e } = this;
    this.digestInto(t);
    const s = t.slice(0, e);
    return this.destroy(), s;
  }
  _cloneInto(t) {
    const { buffer: e, length: s, finished: o, destroyed: u, outputLen: g, pos: h } = this;
    return t || (t = new this.constructor({ dkLen: g })), t.set(...this.get()), t.length = s, t.finished = o, t.destroyed = u, t.outputLen = g, t.buffer.set(e), t.pos = h, t;
  }
}
const Cr = /* @__PURE__ */ BigInt(2 ** 32 - 1), bn = /* @__PURE__ */ BigInt(32);
function Vs(r, t = !1) {
  return t ? { h: Number(r & Cr), l: Number(r >> bn & Cr) } : { h: Number(r >> bn & Cr) | 0, l: Number(r & Cr) | 0 };
}
function yo(r, t = !1) {
  let e = new Uint32Array(r.length), s = new Uint32Array(r.length);
  for (let o = 0; o < r.length; o++) {
    const { h: u, l: g } = Vs(r[o], t);
    [e[o], s[o]] = [u, g];
  }
  return [e, s];
}
const wo = (r, t) => BigInt(r >>> 0) << bn | BigInt(t >>> 0), po = (r, t, e) => r >>> e, bo = (r, t, e) => r << 32 - e | t >>> e, mo = (r, t, e) => r >>> e | t << 32 - e, Eo = (r, t, e) => r << 32 - e | t >>> e, vo = (r, t, e) => r << 64 - e | t >>> e - 32, So = (r, t, e) => r >>> e - 32 | t << 64 - e, Bo = (r, t) => t, _o = (r, t) => r, Ao = (r, t, e) => r << e | t >>> 32 - e, To = (r, t, e) => t << e | r >>> 32 - e, Io = (r, t, e) => t << e - 32 | r >>> 64 - e, Uo = (r, t, e) => r << e - 32 | t >>> 64 - e;
function ko(r, t, e, s) {
  const o = (t >>> 0) + (s >>> 0);
  return { h: r + e + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const Oo = (r, t, e) => (r >>> 0) + (t >>> 0) + (e >>> 0), Mo = (r, t, e, s) => t + e + s + (r / 2 ** 32 | 0) | 0, No = (r, t, e, s) => (r >>> 0) + (t >>> 0) + (e >>> 0) + (s >>> 0), Lo = (r, t, e, s, o) => t + e + s + o + (r / 2 ** 32 | 0) | 0, $o = (r, t, e, s, o) => (r >>> 0) + (t >>> 0) + (e >>> 0) + (s >>> 0) + (o >>> 0), Co = (r, t, e, s, o, u) => t + e + s + o + u + (r / 2 ** 32 | 0) | 0, Yt = {
  fromBig: Vs,
  split: yo,
  toBig: wo,
  shrSH: po,
  shrSL: bo,
  rotrSH: mo,
  rotrSL: Eo,
  rotrBH: vo,
  rotrBL: So,
  rotr32H: Bo,
  rotr32L: _o,
  rotlSH: Ao,
  rotlSL: To,
  rotlBH: Io,
  rotlBL: Uo,
  add: ko,
  add3L: Oo,
  add3H: Mo,
  add4L: No,
  add4H: Lo,
  add5H: Co,
  add5L: $o
}, Rt = /* @__PURE__ */ new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), R = /* @__PURE__ */ new Uint32Array(32);
function _e(r, t, e, s, o, u) {
  const g = o[u], h = o[u + 1];
  let l = R[2 * r], y = R[2 * r + 1], S = R[2 * t], p = R[2 * t + 1], N = R[2 * e], I = R[2 * e + 1], U = R[2 * s], E = R[2 * s + 1], k = Yt.add3L(l, S, g);
  y = Yt.add3H(k, y, p, h), l = k | 0, { Dh: E, Dl: U } = { Dh: E ^ y, Dl: U ^ l }, { Dh: E, Dl: U } = { Dh: Yt.rotr32H(E, U), Dl: Yt.rotr32L(E, U) }, { h: I, l: N } = Yt.add(I, N, E, U), { Bh: p, Bl: S } = { Bh: p ^ I, Bl: S ^ N }, { Bh: p, Bl: S } = { Bh: Yt.rotrSH(p, S, 24), Bl: Yt.rotrSL(p, S, 24) }, R[2 * r] = l, R[2 * r + 1] = y, R[2 * t] = S, R[2 * t + 1] = p, R[2 * e] = N, R[2 * e + 1] = I, R[2 * s] = U, R[2 * s + 1] = E;
}
function Ae(r, t, e, s, o, u) {
  const g = o[u], h = o[u + 1];
  let l = R[2 * r], y = R[2 * r + 1], S = R[2 * t], p = R[2 * t + 1], N = R[2 * e], I = R[2 * e + 1], U = R[2 * s], E = R[2 * s + 1], k = Yt.add3L(l, S, g);
  y = Yt.add3H(k, y, p, h), l = k | 0, { Dh: E, Dl: U } = { Dh: E ^ y, Dl: U ^ l }, { Dh: E, Dl: U } = { Dh: Yt.rotrSH(E, U, 16), Dl: Yt.rotrSL(E, U, 16) }, { h: I, l: N } = Yt.add(I, N, E, U), { Bh: p, Bl: S } = { Bh: p ^ I, Bl: S ^ N }, { Bh: p, Bl: S } = { Bh: Yt.rotrBH(p, S, 63), Bl: Yt.rotrBL(p, S, 63) }, R[2 * r] = l, R[2 * r + 1] = y, R[2 * t] = S, R[2 * t + 1] = p, R[2 * e] = N, R[2 * e + 1] = I, R[2 * s] = U, R[2 * s + 1] = E;
}
class Ro extends xo {
  constructor(t = {}) {
    super(128, t.dkLen === void 0 ? 64 : t.dkLen, t, 64, 16, 16), this.v0l = Rt[0] | 0, this.v0h = Rt[1] | 0, this.v1l = Rt[2] | 0, this.v1h = Rt[3] | 0, this.v2l = Rt[4] | 0, this.v2h = Rt[5] | 0, this.v3l = Rt[6] | 0, this.v3h = Rt[7] | 0, this.v4l = Rt[8] | 0, this.v4h = Rt[9] | 0, this.v5l = Rt[10] | 0, this.v5h = Rt[11] | 0, this.v6l = Rt[12] | 0, this.v6h = Rt[13] | 0, this.v7l = Rt[14] | 0, this.v7h = Rt[15] | 0;
    const e = t.key ? t.key.length : 0;
    if (this.v0l ^= this.outputLen | e << 8 | 65536 | 1 << 24, t.salt) {
      const s = Vr(Oe(t.salt));
      this.v4l ^= me(s[0]), this.v4h ^= me(s[1]), this.v5l ^= me(s[2]), this.v5h ^= me(s[3]);
    }
    if (t.personalization) {
      const s = Vr(Oe(t.personalization));
      this.v6l ^= me(s[0]), this.v6h ^= me(s[1]), this.v7l ^= me(s[2]), this.v7h ^= me(s[3]);
    }
    if (t.key) {
      const s = new Uint8Array(this.blockLen);
      s.set(Oe(t.key)), this.update(s);
    }
  }
  // prettier-ignore
  get() {
    let { v0l: t, v0h: e, v1l: s, v1h: o, v2l: u, v2h: g, v3l: h, v3h: l, v4l: y, v4h: S, v5l: p, v5h: N, v6l: I, v6h: U, v7l: E, v7h: k } = this;
    return [t, e, s, o, u, g, h, l, y, S, p, N, I, U, E, k];
  }
  // prettier-ignore
  set(t, e, s, o, u, g, h, l, y, S, p, N, I, U, E, k) {
    this.v0l = t | 0, this.v0h = e | 0, this.v1l = s | 0, this.v1h = o | 0, this.v2l = u | 0, this.v2h = g | 0, this.v3l = h | 0, this.v3h = l | 0, this.v4l = y | 0, this.v4h = S | 0, this.v5l = p | 0, this.v5h = N | 0, this.v6l = I | 0, this.v6h = U | 0, this.v7l = E | 0, this.v7h = k | 0;
  }
  compress(t, e, s) {
    this.get().forEach((l, y) => R[y] = l), R.set(Rt, 16);
    let { h: o, l: u } = Yt.fromBig(BigInt(this.length));
    R[24] = Rt[8] ^ u, R[25] = Rt[9] ^ o, s && (R[28] = ~R[28], R[29] = ~R[29]);
    let g = 0;
    const h = go;
    for (let l = 0; l < 12; l++)
      _e(0, 4, 8, 12, t, e + 2 * h[g++]), Ae(0, 4, 8, 12, t, e + 2 * h[g++]), _e(1, 5, 9, 13, t, e + 2 * h[g++]), Ae(1, 5, 9, 13, t, e + 2 * h[g++]), _e(2, 6, 10, 14, t, e + 2 * h[g++]), Ae(2, 6, 10, 14, t, e + 2 * h[g++]), _e(3, 7, 11, 15, t, e + 2 * h[g++]), Ae(3, 7, 11, 15, t, e + 2 * h[g++]), _e(0, 5, 10, 15, t, e + 2 * h[g++]), Ae(0, 5, 10, 15, t, e + 2 * h[g++]), _e(1, 6, 11, 12, t, e + 2 * h[g++]), Ae(1, 6, 11, 12, t, e + 2 * h[g++]), _e(2, 7, 8, 13, t, e + 2 * h[g++]), Ae(2, 7, 8, 13, t, e + 2 * h[g++]), _e(3, 4, 9, 14, t, e + 2 * h[g++]), Ae(3, 4, 9, 14, t, e + 2 * h[g++]);
    this.v0l ^= R[0] ^ R[16], this.v0h ^= R[1] ^ R[17], this.v1l ^= R[2] ^ R[18], this.v1h ^= R[3] ^ R[19], this.v2l ^= R[4] ^ R[20], this.v2h ^= R[5] ^ R[21], this.v3l ^= R[6] ^ R[22], this.v3h ^= R[7] ^ R[23], this.v4l ^= R[8] ^ R[24], this.v4h ^= R[9] ^ R[25], this.v5l ^= R[10] ^ R[26], this.v5h ^= R[11] ^ R[27], this.v6l ^= R[12] ^ R[28], this.v6h ^= R[13] ^ R[29], this.v7l ^= R[14] ^ R[30], this.v7h ^= R[15] ^ R[31], R.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const Kr = /* @__PURE__ */ ho((r) => new Ro(r)), Po = Symbol.for("@mysten/transaction");
function zo(r) {
  return !!r && typeof r == "object" && r[Po] === !0;
}
const qo = Symbol.for("@mysten/SuiClient");
class jo {
  get [qo]() {
    return !0;
  }
  /**
   * Establish a connection to a Sui RPC endpoint
   *
   * @param options configuration options for the API Client
   */
  constructor(t) {
    this.transport = t.transport ?? new Ti({ url: t.url });
  }
  async getRpcApiVersion() {
    return (await this.transport.request({
      method: "rpc.discover",
      params: []
    })).info.version;
  }
  /**
   * Get all Coin<`coin_type`> objects owned by an address.
   */
  async getCoins(t) {
    if (!t.owner || !Re(Xt(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getCoins",
      params: [t.owner, t.coinType, t.cursor, t.limit]
    });
  }
  /**
   * Get all Coin objects owned by an address.
   */
  async getAllCoins(t) {
    if (!t.owner || !Re(Xt(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getAllCoins",
      params: [t.owner, t.cursor, t.limit]
    });
  }
  /**
   * Get the total coin balance for one coin type, owned by the address owner.
   */
  async getBalance(t) {
    if (!t.owner || !Re(Xt(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getBalance",
      params: [t.owner, t.coinType]
    });
  }
  /**
   * Get the total coin balance for all coin types, owned by the address owner.
   */
  async getAllBalances(t) {
    if (!t.owner || !Re(Xt(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({ method: "suix_getAllBalances", params: [t.owner] });
  }
  /**
   * Fetch CoinMetadata for a given coin type
   */
  async getCoinMetadata(t) {
    return await this.transport.request({
      method: "suix_getCoinMetadata",
      params: [t.coinType]
    });
  }
  /**
   *  Fetch total supply for a coin
   */
  async getTotalSupply(t) {
    return await this.transport.request({
      method: "suix_getTotalSupply",
      params: [t.coinType]
    });
  }
  /**
   * Invoke any RPC method
   * @param method the method to be invoked
   * @param args the arguments to be passed to the RPC request
   */
  async call(t, e) {
    return await this.transport.request({ method: t, params: e });
  }
  /**
   * Get Move function argument types like read, write and full access
   */
  async getMoveFunctionArgTypes(t) {
    return await this.transport.request({
      method: "sui_getMoveFunctionArgTypes",
      params: [t.package, t.module, t.function]
    });
  }
  /**
   * Get a map from module name to
   * structured representations of Move modules
   */
  async getNormalizedMoveModulesByPackage(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveModulesByPackage",
      params: [t.package]
    });
  }
  /**
   * Get a structured representation of Move module
   */
  async getNormalizedMoveModule(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveModule",
      params: [t.package, t.module]
    });
  }
  /**
   * Get a structured representation of Move function
   */
  async getNormalizedMoveFunction(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveFunction",
      params: [t.package, t.module, t.function]
    });
  }
  /**
   * Get a structured representation of Move struct
   */
  async getNormalizedMoveStruct(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveStruct",
      params: [t.package, t.module, t.struct]
    });
  }
  /**
   * Get all objects owned by an address
   */
  async getOwnedObjects(t) {
    if (!t.owner || !Re(Xt(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getOwnedObjects",
      params: [
        t.owner,
        {
          filter: t.filter,
          options: t.options
        },
        t.cursor,
        t.limit
      ]
    });
  }
  /**
   * Get details about an object
   */
  async getObject(t) {
    if (!t.id || !Lr($r(t.id)))
      throw new Error("Invalid Sui Object id");
    return await this.transport.request({
      method: "sui_getObject",
      params: [t.id, t.options]
    });
  }
  async tryGetPastObject(t) {
    return await this.transport.request({
      method: "sui_tryGetPastObject",
      params: [t.id, t.version, t.options]
    });
  }
  /**
   * Batch get details about a list of objects. If any of the object ids are duplicates the call will fail
   */
  async multiGetObjects(t) {
    if (t.ids.forEach((s) => {
      if (!s || !Lr($r(s)))
        throw new Error(`Invalid Sui Object id ${s}`);
    }), t.ids.length !== new Set(t.ids).size)
      throw new Error(`Duplicate object ids in batch call ${t.ids}`);
    return await this.transport.request({
      method: "sui_multiGetObjects",
      params: [t.ids, t.options]
    });
  }
  /**
   * Get transaction blocks for a given query criteria
   */
  async queryTransactionBlocks(t) {
    return await this.transport.request({
      method: "suix_queryTransactionBlocks",
      params: [
        {
          filter: t.filter,
          options: t.options
        },
        t.cursor,
        t.limit,
        (t.order || "descending") === "descending"
      ]
    });
  }
  async getTransactionBlock(t) {
    if (!us(t.digest))
      throw new Error("Invalid Transaction digest");
    return await this.transport.request({
      method: "sui_getTransactionBlock",
      params: [t.digest, t.options]
    });
  }
  async multiGetTransactionBlocks(t) {
    if (t.digests.forEach((s) => {
      if (!us(s))
        throw new Error(`Invalid Transaction digest ${s}`);
    }), t.digests.length !== new Set(t.digests).size)
      throw new Error(`Duplicate digests in batch call ${t.digests}`);
    return await this.transport.request({
      method: "sui_multiGetTransactionBlocks",
      params: [t.digests, t.options]
    });
  }
  async executeTransactionBlock(t) {
    return await this.transport.request({
      method: "sui_executeTransactionBlock",
      params: [
        typeof t.transactionBlock == "string" ? t.transactionBlock : se(t.transactionBlock),
        Array.isArray(t.signature) ? t.signature : [t.signature],
        t.options,
        t.requestType
      ]
    });
  }
  async signAndExecuteTransactionBlock({
    transactionBlock: t,
    signer: e,
    ...s
  }) {
    let o;
    t instanceof Uint8Array ? o = t : (t.setSenderIfNotSet(e.toSuiAddress()), o = await t.build({ client: this }));
    const { signature: u, bytes: g } = await e.signTransactionBlock(o);
    return this.executeTransactionBlock({
      transactionBlock: g,
      signature: u,
      ...s
    });
  }
  /**
   * Get total number of transactions
   */
  async getTotalTransactionBlocks() {
    const t = await this.transport.request({
      method: "sui_getTotalTransactionBlocks",
      params: []
    });
    return BigInt(t);
  }
  /**
   * Getting the reference gas price for the network
   */
  async getReferenceGasPrice() {
    const t = await this.transport.request({
      method: "suix_getReferenceGasPrice",
      params: []
    });
    return BigInt(t);
  }
  /**
   * Return the delegated stakes for an address
   */
  async getStakes(t) {
    if (!t.owner || !Re(Xt(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({ method: "suix_getStakes", params: [t.owner] });
  }
  /**
   * Return the delegated stakes queried by id.
   */
  async getStakesByIds(t) {
    return t.stakedSuiIds.forEach((e) => {
      if (!e || !Lr($r(e)))
        throw new Error(`Invalid Sui Stake id ${e}`);
    }), await this.transport.request({
      method: "suix_getStakesByIds",
      params: [t.stakedSuiIds]
    });
  }
  /**
   * Return the latest system state content.
   */
  async getLatestSuiSystemState() {
    return await this.transport.request({ method: "suix_getLatestSuiSystemState", params: [] });
  }
  /**
   * Get events for a given query criteria
   */
  async queryEvents(t) {
    return await this.transport.request({
      method: "suix_queryEvents",
      params: [
        t.query,
        t.cursor,
        t.limit,
        (t.order || "descending") === "descending"
      ]
    });
  }
  /**
   * Subscribe to get notifications whenever an event matching the filter occurs
   */
  async subscribeEvent(t) {
    return this.transport.subscribe({
      method: "suix_subscribeEvent",
      unsubscribe: "suix_unsubscribeEvent",
      params: [t.filter],
      onMessage: t.onMessage
    });
  }
  async subscribeTransaction(t) {
    return this.transport.subscribe({
      method: "suix_subscribeTransaction",
      unsubscribe: "suix_unsubscribeTransaction",
      params: [t.filter],
      onMessage: t.onMessage
    });
  }
  /**
   * Runs the transaction block in dev-inspect mode. Which allows for nearly any
   * transaction (or Move call) with any arguments. Detailed results are
   * provided, including both the transaction effects and any return values.
   */
  async devInspectTransactionBlock(t) {
    var s;
    let e;
    if (zo(t.transactionBlock))
      t.transactionBlock.setSenderIfNotSet(t.sender), e = se(
        await t.transactionBlock.build({
          client: this,
          onlyTransactionKind: !0
        })
      );
    else if (typeof t.transactionBlock == "string")
      e = t.transactionBlock;
    else if (t.transactionBlock instanceof Uint8Array)
      e = se(t.transactionBlock);
    else
      throw new Error("Unknown transaction block format.");
    return await this.transport.request({
      method: "sui_devInspectTransactionBlock",
      params: [t.sender, e, (s = t.gasPrice) == null ? void 0 : s.toString(), t.epoch]
    });
  }
  /**
   * Dry run a transaction block and return the result.
   */
  async dryRunTransactionBlock(t) {
    return await this.transport.request({
      method: "sui_dryRunTransactionBlock",
      params: [
        typeof t.transactionBlock == "string" ? t.transactionBlock : se(t.transactionBlock)
      ]
    });
  }
  /**
   * Return the list of dynamic field objects owned by an object
   */
  async getDynamicFields(t) {
    if (!t.parentId || !Lr($r(t.parentId)))
      throw new Error("Invalid Sui Object id");
    return await this.transport.request({
      method: "suix_getDynamicFields",
      params: [t.parentId, t.cursor, t.limit]
    });
  }
  /**
   * Return the dynamic field object information for a specified object
   */
  async getDynamicFieldObject(t) {
    return await this.transport.request({
      method: "suix_getDynamicFieldObject",
      params: [t.parentId, t.name]
    });
  }
  /**
   * Get the sequence number of the latest checkpoint that has been executed
   */
  async getLatestCheckpointSequenceNumber() {
    const t = await this.transport.request({
      method: "sui_getLatestCheckpointSequenceNumber",
      params: []
    });
    return String(t);
  }
  /**
   * Returns information about a given checkpoint
   */
  async getCheckpoint(t) {
    return await this.transport.request({ method: "sui_getCheckpoint", params: [t.id] });
  }
  /**
   * Returns historical checkpoints paginated
   */
  async getCheckpoints(t) {
    return await this.transport.request({
      method: "sui_getCheckpoints",
      params: [t.cursor, t == null ? void 0 : t.limit, t.descendingOrder]
    });
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCommitteeInfo(t) {
    return await this.transport.request({
      method: "suix_getCommitteeInfo",
      params: [t == null ? void 0 : t.epoch]
    });
  }
  async getNetworkMetrics() {
    return await this.transport.request({ method: "suix_getNetworkMetrics", params: [] });
  }
  async getAddressMetrics() {
    return await this.transport.request({ method: "suix_getLatestAddressMetrics", params: [] });
  }
  async getEpochMetrics(t) {
    return await this.transport.request({
      method: "suix_getEpochMetrics",
      params: [t == null ? void 0 : t.cursor, t == null ? void 0 : t.limit, t == null ? void 0 : t.descendingOrder]
    });
  }
  async getAllEpochAddressMetrics(t) {
    return await this.transport.request({
      method: "suix_getAllEpochAddressMetrics",
      params: [t == null ? void 0 : t.descendingOrder]
    });
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getEpochs(t) {
    return await this.transport.request({
      method: "suix_getEpochs",
      params: [t == null ? void 0 : t.cursor, t == null ? void 0 : t.limit, t == null ? void 0 : t.descendingOrder]
    });
  }
  /**
   * Returns list of top move calls by usage
   */
  async getMoveCallMetrics() {
    return await this.transport.request({ method: "suix_getMoveCallMetrics", params: [] });
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCurrentEpoch() {
    return await this.transport.request({ method: "suix_getCurrentEpoch", params: [] });
  }
  /**
   * Return the Validators APYs
   */
  async getValidatorsApy() {
    return await this.transport.request({ method: "suix_getValidatorsApy", params: [] });
  }
  // TODO: Migrate this to `sui_getChainIdentifier` once it is widely available.
  async getChainIdentifier() {
    const t = await this.getCheckpoint({ id: "0" }), e = mr(t.digest);
    return nr(e.slice(0, 4));
  }
  async resolveNameServiceAddress(t) {
    return await this.transport.request({
      method: "suix_resolveNameServiceAddress",
      params: [t.name]
    });
  }
  async resolveNameServiceNames(t) {
    return await this.transport.request({
      method: "suix_resolveNameServiceNames",
      params: [t.address, t.cursor, t.limit]
    });
  }
  async getProtocolConfig(t) {
    return await this.transport.request({
      method: "sui_getProtocolConfig",
      params: [t == null ? void 0 : t.version]
    });
  }
  /**
   * Wait for a transaction block result to be available over the API.
   * This can be used in conjunction with `executeTransactionBlock` to wait for the transaction to
   * be available via the API.
   * This currently polls the `getTransactionBlock` API to check for the transaction.
   */
  async waitForTransactionBlock({
    signal: t,
    timeout: e = 60 * 1e3,
    pollInterval: s = 2 * 1e3,
    ...o
  }) {
    const u = AbortSignal.timeout(e), g = new Promise((h, l) => {
      u.addEventListener("abort", () => l(u.reason));
    });
    for (g.catch(() => {
    }); !u.aborted; ) {
      t == null || t.throwIfAborted();
      try {
        return await this.getTransactionBlock(o);
      } catch {
        await Promise.race([
          new Promise((l) => setTimeout(l, s)),
          g
        ]);
      }
    }
    throw u.throwIfAborted(), new Error("Unexpected error while waiting for transaction block.");
  }
}
const Me = {
  ED25519: 0,
  Secp256k1: 1,
  Secp256r1: 2,
  MultiSig: 3,
  ZkLogin: 5
}, Vo = {
  ED25519: 32,
  Secp256k1: 33,
  Secp256r1: 33
}, Ks = {
  0: "ED25519",
  1: "Secp256k1",
  2: "Secp256r1",
  3: "MultiSig",
  5: "ZkLogin"
};
function Ko(r) {
  for (let t = 0; t < r.length; t++)
    if (r[t] !== 0)
      return t;
  return -1;
}
function Ds(r, t) {
  const e = r.toString(16);
  return ao(e.padStart(t * 2, "0").slice(-t * 2));
}
function Do(r, t) {
  const e = Ds(r, t), s = Ko(e);
  return s === -1 ? new Uint8Array([0]) : e.slice(s);
}
function Ho(r, t) {
  const e = Do(r, 32);
  t === "accounts.google.com" && (t = "https://accounts.google.com");
  const s = new TextEncoder().encode(t), o = new Uint8Array(2 + e.length + s.length);
  return o.set([Me.ZkLogin]), o.set([s.length], 1), o.set(s, 2), o.set(e, 2 + s.length), Xt(
    Fn(Kr(o, { dkLen: 32 })).slice(0, Er * 2)
  );
}
function Go(r) {
  if (r.length !== 1)
    throw new Error("Invalid base64Url character: " + r);
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_".indexOf(r);
  if (e === -1)
    throw new Error("Invalid base64Url character: " + r);
  const s = e.toString(2).padStart(6, "0");
  return Array.from(s).map(Number);
}
function Zo(r) {
  let t = [];
  for (let e = 0; e < r.length; e++) {
    const s = r.charAt(e), o = Go(s);
    t = t.concat(o);
  }
  return t;
}
function Yo(r, t) {
  if (r.length < 2)
    throw new Error(`Input (s = ${r}) is not tightly packed because s.length < 2`);
  let e = Zo(r);
  const s = t % 4;
  if (s !== 0)
    if (s === 1)
      e = e.slice(2);
    else if (s === 2)
      e = e.slice(4);
    else
      throw new Error(`Input (s = ${r}) is not tightly packed because i%4 = 3 (i = ${t}))`);
  const o = (t + r.length - 1) % 4;
  if (o !== 3)
    if (o === 2)
      e = e.slice(0, e.length - 2);
    else if (o === 1)
      e = e.slice(0, e.length - 4);
    else
      throw new Error(
        `Input (s = ${r}) is not tightly packed because (i + s.length - 1)%4 = 0 (i = ${t}))`
      );
  if (e.length % 8 !== 0)
    throw new Error("We should never reach here...");
  const u = new Uint8Array(Math.floor(e.length / 8));
  let g = 0;
  for (let h = 0; h < e.length; h += 8) {
    const l = e.slice(h, h + 8), y = parseInt(l.join(""), 2);
    u[g++] = y;
  }
  return new TextDecoder().decode(u);
}
function Wo(r) {
  if (!(r.slice(-1) === "}" || r.slice(-1) === ","))
    throw new Error("Invalid claim");
  const t = JSON.parse("{" + r.slice(0, -1) + "}");
  if (Object.keys(t).length !== 1)
    throw new Error("Invalid claim");
  const e = Object.keys(t)[0];
  return [e, t[e]];
}
function Fo(r, t) {
  const e = Yo(r.value, r.indexMod4), [s, o] = Wo(e);
  if (s !== t)
    throw new Error(`Invalid field name: found ${s} expected ${t}`);
  return o;
}
const Xo = v.struct("ZkLoginSignature", {
  inputs: v.struct("ZkLoginSignatureInputs", {
    proofPoints: v.struct("ZkLoginSignatureInputsProofPoints", {
      a: v.vector(v.string()),
      b: v.vector(v.vector(v.string())),
      c: v.vector(v.string())
    }),
    issBase64Details: v.struct("ZkLoginSignatureInputsClaim", {
      value: v.string(),
      indexMod4: v.u8()
    }),
    headerBase64: v.string(),
    addressSeed: v.string()
  }),
  maxEpoch: v.u64(),
  userSignature: v.vector(v.u8())
});
function Jo(r) {
  return Xo.parse(typeof r == "string" ? ge(r) : r);
}
function Je(r) {
  const t = ge(r), e = Ks[t[0]];
  switch (e) {
    case "MultiSig":
      const s = ye.MultiSig.parse(t.slice(1));
      return {
        serializedSignature: r,
        signatureScheme: e,
        multisig: s,
        bytes: t
      };
    case "ZkLogin":
      const o = t.slice(1), { inputs: u, maxEpoch: g, userSignature: h } = Jo(o), { issBase64Details: l, addressSeed: y } = u, S = Fo(l, "iss"), p = Ho(BigInt(y), S);
      return {
        serializedSignature: r,
        signatureScheme: e,
        zkLogin: {
          inputs: u,
          maxEpoch: g,
          userSignature: h,
          iss: S,
          address: p,
          addressSeed: BigInt(y)
        },
        signature: t
      };
    case "ED25519":
    case "Secp256k1":
    case "Secp256r1":
      const N = Vo[e], I = t.slice(1, t.length - N), U = t.slice(1 + I.length);
      return {
        serializedSignature: r,
        signatureScheme: e,
        signature: I,
        publicKey: U,
        bytes: t
      };
    default:
      throw new Error("Unsupported signature scheme");
  }
}
class Hs extends Xn {
  constructor(t, e) {
    super(), this.finished = !1, this.destroyed = !1, io(t);
    const s = Oe(e);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const o = this.blockLen, u = new Uint8Array(o);
    u.set(s.length > o ? t.create().update(s).digest() : s);
    for (let g = 0; g < u.length; g++)
      u[g] ^= 54;
    this.iHash.update(u), this.oHash = t.create();
    for (let g = 0; g < u.length; g++)
      u[g] ^= 106;
    this.oHash.update(u), u.fill(0);
  }
  update(t) {
    return Xe(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    Xe(this), vr(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: e, iHash: s, finished: o, destroyed: u, blockLen: g, outputLen: h } = this;
    return t = t, t.finished = o, t.destroyed = u, t.blockLen = g, t.outputLen = h, t.oHash = e._cloneInto(t.oHash), t.iHash = s._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const Gs = (r, t, e) => new Hs(r, t).update(e).digest();
Gs.create = (r, t) => new Hs(r, t);
function Qo(r, t, e, s) {
  if (typeof r.setBigUint64 == "function")
    return r.setBigUint64(t, e, s);
  const o = BigInt(32), u = BigInt(4294967295), g = Number(e >> o & u), h = Number(e & u), l = s ? 4 : 0, y = s ? 0 : 4;
  r.setUint32(t + l, g, s), r.setUint32(t + y, h, s);
}
const ta = (r, t, e) => r & t ^ ~r & e, ea = (r, t, e) => r & t ^ r & e ^ t & e;
class ra extends Xn {
  constructor(t, e, s, o) {
    super(), this.blockLen = t, this.outputLen = e, this.padOffset = s, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = hn(this.buffer);
  }
  update(t) {
    Xe(this);
    const { view: e, buffer: s, blockLen: o } = this;
    t = Oe(t);
    const u = t.length;
    for (let g = 0; g < u; ) {
      const h = Math.min(o - this.pos, u - g);
      if (h === o) {
        const l = hn(t);
        for (; o <= u - g; g += o)
          this.process(l, g);
        continue;
      }
      s.set(t.subarray(g, g + h), this.pos), this.pos += h, g += h, this.pos === o && (this.process(e, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Xe(this), qs(t, this), this.finished = !0;
    const { buffer: e, view: s, blockLen: o, isLE: u } = this;
    let { pos: g } = this;
    e[g++] = 128, this.buffer.subarray(g).fill(0), this.padOffset > o - g && (this.process(s, 0), g = 0);
    for (let p = g; p < o; p++)
      e[p] = 0;
    Qo(s, o - 8, BigInt(this.length * 8), u), this.process(s, 0);
    const h = hn(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const y = l / 4, S = this.get();
    if (y > S.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let p = 0; p < y; p++)
      h.setUint32(4 * p, S[p], u);
  }
  digest() {
    const { buffer: t, outputLen: e } = this;
    this.digestInto(t);
    const s = t.slice(0, e);
    return this.destroy(), s;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: e, buffer: s, length: o, finished: u, destroyed: g, pos: h } = this;
    return t.length = o, t.pos = h, t.finished = u, t.destroyed = g, o % e && t.buffer.set(s), t;
  }
}
const na = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Te = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Ie = /* @__PURE__ */ new Uint32Array(64);
class sa extends ra {
  constructor() {
    super(64, 32, 8, !1), this.A = Te[0] | 0, this.B = Te[1] | 0, this.C = Te[2] | 0, this.D = Te[3] | 0, this.E = Te[4] | 0, this.F = Te[5] | 0, this.G = Te[6] | 0, this.H = Te[7] | 0;
  }
  get() {
    const { A: t, B: e, C: s, D: o, E: u, F: g, G: h, H: l } = this;
    return [t, e, s, o, u, g, h, l];
  }
  // prettier-ignore
  set(t, e, s, o, u, g, h, l) {
    this.A = t | 0, this.B = e | 0, this.C = s | 0, this.D = o | 0, this.E = u | 0, this.F = g | 0, this.G = h | 0, this.H = l | 0;
  }
  process(t, e) {
    for (let p = 0; p < 16; p++, e += 4)
      Ie[p] = t.getUint32(e, !1);
    for (let p = 16; p < 64; p++) {
      const N = Ie[p - 15], I = Ie[p - 2], U = xe(N, 7) ^ xe(N, 18) ^ N >>> 3, E = xe(I, 17) ^ xe(I, 19) ^ I >>> 10;
      Ie[p] = E + Ie[p - 7] + U + Ie[p - 16] | 0;
    }
    let { A: s, B: o, C: u, D: g, E: h, F: l, G: y, H: S } = this;
    for (let p = 0; p < 64; p++) {
      const N = xe(h, 6) ^ xe(h, 11) ^ xe(h, 25), I = S + N + ta(h, l, y) + na[p] + Ie[p] | 0, E = (xe(s, 2) ^ xe(s, 13) ^ xe(s, 22)) + ea(s, o, u) | 0;
      S = y, y = l, l = h, h = g + I | 0, g = u, u = o, o = s, s = I + E | 0;
    }
    s = s + this.A | 0, o = o + this.B | 0, u = u + this.C | 0, g = g + this.D | 0, h = h + this.E | 0, l = l + this.F | 0, y = y + this.G | 0, S = S + this.H | 0, this.set(s, o, u, g, h, l, y, S);
  }
  roundClean() {
    Ie.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Gr = /* @__PURE__ */ uo(() => new sa());
var mn = /* @__PURE__ */ ((r) => (r[r.TransactionData = 0] = "TransactionData", r[r.TransactionEffects = 1] = "TransactionEffects", r[r.CheckpointSummary = 2] = "CheckpointSummary", r[r.PersonalMessage = 3] = "PersonalMessage", r))(mn || {});
function ia(r) {
  return [
    r,
    0,
    0
    /* Sui */
  ];
}
function oa(r, t) {
  const e = ia(r), s = new Uint8Array(e.length + t.length);
  return s.set(e), s.set(t, e.length), s;
}
function Qe(r, t) {
  if (r === t)
    return !0;
  if (r.length !== t.length)
    return !1;
  for (let e = 0; e < r.length; e++)
    if (r[e] !== t[e])
      return !1;
  return !0;
}
class Sr {
  /**
   * Checks if two public keys are equal
   */
  equals(t) {
    return Qe(this.toRawBytes(), t.toRawBytes());
  }
  /**
   * Return the base-64 representation of the public key
   */
  toBase64() {
    return se(this.toRawBytes());
  }
  toString() {
    throw new Error(
      "`toString` is not implemented on public keys. Use `toBase64()` or `toRawBytes()` instead."
    );
  }
  /**
   * Return the Sui representation of the public key encoded in
   * base-64. A Sui public key is formed by the concatenation
   * of the scheme flag with the raw bytes of the public key
   */
  toSuiPublicKey() {
    const t = this.toSuiBytes();
    return se(t);
  }
  verifyWithIntent(t, e, s) {
    const o = oa(s, t), u = Kr(o, { dkLen: 32 });
    return this.verify(u, e);
  }
  /**
   * Verifies that the signature is valid for for the provided PersonalMessage
   */
  verifyPersonalMessage(t, e) {
    return this.verifyWithIntent(
      ye.vector(ye.u8()).serialize(t).toBytes(),
      e,
      mn.PersonalMessage
    );
  }
  /**
   * Verifies that the signature is valid for for the provided TransactionBlock
   */
  verifyTransactionBlock(t, e) {
    return this.verifyWithIntent(t, e, mn.TransactionData);
  }
  /**
   * Returns the bytes representation of the public key
   * prefixed with the signature scheme flag
   */
  toSuiBytes() {
    const t = this.toRawBytes(), e = new Uint8Array(t.length + 1);
    return e.set([this.flag()]), e.set(t, 1), e;
  }
  /**
   * Return the Sui address associated with this Ed25519 public key
   */
  toSuiAddress() {
    return Xt(
      Fn(Kr(this.toSuiBytes(), { dkLen: 32 })).slice(0, Er * 2)
    );
  }
}
function aa(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Zs = { exports: {} };
const fa = {}, ca = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fa
}, Symbol.toStringTag, { value: "Module" })), ua = /* @__PURE__ */ Ui(ca);
(function(r) {
  (function(t) {
    var e = function(i) {
      var f, a = new Float64Array(16);
      if (i)
        for (f = 0; f < i.length; f++)
          a[f] = i[f];
      return a;
    }, s = function() {
      throw new Error("no PRNG");
    }, o = new Uint8Array(16), u = new Uint8Array(32);
    u[0] = 9;
    var g = e(), h = e([1]), l = e([56129, 1]), y = e([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), S = e([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), p = e([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), N = e([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), I = e([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function U(i, f, a, n) {
      i[f] = a >> 24 & 255, i[f + 1] = a >> 16 & 255, i[f + 2] = a >> 8 & 255, i[f + 3] = a & 255, i[f + 4] = n >> 24 & 255, i[f + 5] = n >> 16 & 255, i[f + 6] = n >> 8 & 255, i[f + 7] = n & 255;
    }
    function E(i, f, a, n, c) {
      var x, w = 0;
      for (x = 0; x < c; x++)
        w |= i[f + x] ^ a[n + x];
      return (1 & w - 1 >>> 8) - 1;
    }
    function k(i, f, a, n) {
      return E(i, f, a, n, 16);
    }
    function L(i, f, a, n) {
      return E(i, f, a, n, 32);
    }
    function H(i, f, a, n) {
      for (var c = n[0] & 255 | (n[1] & 255) << 8 | (n[2] & 255) << 16 | (n[3] & 255) << 24, x = a[0] & 255 | (a[1] & 255) << 8 | (a[2] & 255) << 16 | (a[3] & 255) << 24, w = a[4] & 255 | (a[5] & 255) << 8 | (a[6] & 255) << 16 | (a[7] & 255) << 24, _ = a[8] & 255 | (a[9] & 255) << 8 | (a[10] & 255) << 16 | (a[11] & 255) << 24, M = a[12] & 255 | (a[13] & 255) << 8 | (a[14] & 255) << 16 | (a[15] & 255) << 24, Z = n[4] & 255 | (n[5] & 255) << 8 | (n[6] & 255) << 16 | (n[7] & 255) << 24, P = f[0] & 255 | (f[1] & 255) << 8 | (f[2] & 255) << 16 | (f[3] & 255) << 24, bt = f[4] & 255 | (f[5] & 255) << 8 | (f[6] & 255) << 16 | (f[7] & 255) << 24, V = f[8] & 255 | (f[9] & 255) << 8 | (f[10] & 255) << 16 | (f[11] & 255) << 24, Q = f[12] & 255 | (f[13] & 255) << 8 | (f[14] & 255) << 16 | (f[15] & 255) << 24, tt = n[8] & 255 | (n[9] & 255) << 8 | (n[10] & 255) << 16 | (n[11] & 255) << 24, ft = a[16] & 255 | (a[17] & 255) << 8 | (a[18] & 255) << 16 | (a[19] & 255) << 24, at = a[20] & 255 | (a[21] & 255) << 8 | (a[22] & 255) << 16 | (a[23] & 255) << 24, et = a[24] & 255 | (a[25] & 255) << 8 | (a[26] & 255) << 16 | (a[27] & 255) << 24, st = a[28] & 255 | (a[29] & 255) << 8 | (a[30] & 255) << 16 | (a[31] & 255) << 24, rt = n[12] & 255 | (n[13] & 255) << 8 | (n[14] & 255) << 16 | (n[15] & 255) << 24, K = c, Y = x, q = w, D = _, G = M, C = Z, b = P, m = bt, T = V, B = Q, A = tt, O = ft, X = at, ct = et, lt = st, ut = rt, d, gt = 0; gt < 20; gt += 2)
        d = K + X | 0, G ^= d << 7 | d >>> 25, d = G + K | 0, T ^= d << 9 | d >>> 23, d = T + G | 0, X ^= d << 13 | d >>> 19, d = X + T | 0, K ^= d << 18 | d >>> 14, d = C + Y | 0, B ^= d << 7 | d >>> 25, d = B + C | 0, ct ^= d << 9 | d >>> 23, d = ct + B | 0, Y ^= d << 13 | d >>> 19, d = Y + ct | 0, C ^= d << 18 | d >>> 14, d = A + b | 0, lt ^= d << 7 | d >>> 25, d = lt + A | 0, q ^= d << 9 | d >>> 23, d = q + lt | 0, b ^= d << 13 | d >>> 19, d = b + q | 0, A ^= d << 18 | d >>> 14, d = ut + O | 0, D ^= d << 7 | d >>> 25, d = D + ut | 0, m ^= d << 9 | d >>> 23, d = m + D | 0, O ^= d << 13 | d >>> 19, d = O + m | 0, ut ^= d << 18 | d >>> 14, d = K + D | 0, Y ^= d << 7 | d >>> 25, d = Y + K | 0, q ^= d << 9 | d >>> 23, d = q + Y | 0, D ^= d << 13 | d >>> 19, d = D + q | 0, K ^= d << 18 | d >>> 14, d = C + G | 0, b ^= d << 7 | d >>> 25, d = b + C | 0, m ^= d << 9 | d >>> 23, d = m + b | 0, G ^= d << 13 | d >>> 19, d = G + m | 0, C ^= d << 18 | d >>> 14, d = A + B | 0, O ^= d << 7 | d >>> 25, d = O + A | 0, T ^= d << 9 | d >>> 23, d = T + O | 0, B ^= d << 13 | d >>> 19, d = B + T | 0, A ^= d << 18 | d >>> 14, d = ut + lt | 0, X ^= d << 7 | d >>> 25, d = X + ut | 0, ct ^= d << 9 | d >>> 23, d = ct + X | 0, lt ^= d << 13 | d >>> 19, d = lt + ct | 0, ut ^= d << 18 | d >>> 14;
      K = K + c | 0, Y = Y + x | 0, q = q + w | 0, D = D + _ | 0, G = G + M | 0, C = C + Z | 0, b = b + P | 0, m = m + bt | 0, T = T + V | 0, B = B + Q | 0, A = A + tt | 0, O = O + ft | 0, X = X + at | 0, ct = ct + et | 0, lt = lt + st | 0, ut = ut + rt | 0, i[0] = K >>> 0 & 255, i[1] = K >>> 8 & 255, i[2] = K >>> 16 & 255, i[3] = K >>> 24 & 255, i[4] = Y >>> 0 & 255, i[5] = Y >>> 8 & 255, i[6] = Y >>> 16 & 255, i[7] = Y >>> 24 & 255, i[8] = q >>> 0 & 255, i[9] = q >>> 8 & 255, i[10] = q >>> 16 & 255, i[11] = q >>> 24 & 255, i[12] = D >>> 0 & 255, i[13] = D >>> 8 & 255, i[14] = D >>> 16 & 255, i[15] = D >>> 24 & 255, i[16] = G >>> 0 & 255, i[17] = G >>> 8 & 255, i[18] = G >>> 16 & 255, i[19] = G >>> 24 & 255, i[20] = C >>> 0 & 255, i[21] = C >>> 8 & 255, i[22] = C >>> 16 & 255, i[23] = C >>> 24 & 255, i[24] = b >>> 0 & 255, i[25] = b >>> 8 & 255, i[26] = b >>> 16 & 255, i[27] = b >>> 24 & 255, i[28] = m >>> 0 & 255, i[29] = m >>> 8 & 255, i[30] = m >>> 16 & 255, i[31] = m >>> 24 & 255, i[32] = T >>> 0 & 255, i[33] = T >>> 8 & 255, i[34] = T >>> 16 & 255, i[35] = T >>> 24 & 255, i[36] = B >>> 0 & 255, i[37] = B >>> 8 & 255, i[38] = B >>> 16 & 255, i[39] = B >>> 24 & 255, i[40] = A >>> 0 & 255, i[41] = A >>> 8 & 255, i[42] = A >>> 16 & 255, i[43] = A >>> 24 & 255, i[44] = O >>> 0 & 255, i[45] = O >>> 8 & 255, i[46] = O >>> 16 & 255, i[47] = O >>> 24 & 255, i[48] = X >>> 0 & 255, i[49] = X >>> 8 & 255, i[50] = X >>> 16 & 255, i[51] = X >>> 24 & 255, i[52] = ct >>> 0 & 255, i[53] = ct >>> 8 & 255, i[54] = ct >>> 16 & 255, i[55] = ct >>> 24 & 255, i[56] = lt >>> 0 & 255, i[57] = lt >>> 8 & 255, i[58] = lt >>> 16 & 255, i[59] = lt >>> 24 & 255, i[60] = ut >>> 0 & 255, i[61] = ut >>> 8 & 255, i[62] = ut >>> 16 & 255, i[63] = ut >>> 24 & 255;
    }
    function W(i, f, a, n) {
      for (var c = n[0] & 255 | (n[1] & 255) << 8 | (n[2] & 255) << 16 | (n[3] & 255) << 24, x = a[0] & 255 | (a[1] & 255) << 8 | (a[2] & 255) << 16 | (a[3] & 255) << 24, w = a[4] & 255 | (a[5] & 255) << 8 | (a[6] & 255) << 16 | (a[7] & 255) << 24, _ = a[8] & 255 | (a[9] & 255) << 8 | (a[10] & 255) << 16 | (a[11] & 255) << 24, M = a[12] & 255 | (a[13] & 255) << 8 | (a[14] & 255) << 16 | (a[15] & 255) << 24, Z = n[4] & 255 | (n[5] & 255) << 8 | (n[6] & 255) << 16 | (n[7] & 255) << 24, P = f[0] & 255 | (f[1] & 255) << 8 | (f[2] & 255) << 16 | (f[3] & 255) << 24, bt = f[4] & 255 | (f[5] & 255) << 8 | (f[6] & 255) << 16 | (f[7] & 255) << 24, V = f[8] & 255 | (f[9] & 255) << 8 | (f[10] & 255) << 16 | (f[11] & 255) << 24, Q = f[12] & 255 | (f[13] & 255) << 8 | (f[14] & 255) << 16 | (f[15] & 255) << 24, tt = n[8] & 255 | (n[9] & 255) << 8 | (n[10] & 255) << 16 | (n[11] & 255) << 24, ft = a[16] & 255 | (a[17] & 255) << 8 | (a[18] & 255) << 16 | (a[19] & 255) << 24, at = a[20] & 255 | (a[21] & 255) << 8 | (a[22] & 255) << 16 | (a[23] & 255) << 24, et = a[24] & 255 | (a[25] & 255) << 8 | (a[26] & 255) << 16 | (a[27] & 255) << 24, st = a[28] & 255 | (a[29] & 255) << 8 | (a[30] & 255) << 16 | (a[31] & 255) << 24, rt = n[12] & 255 | (n[13] & 255) << 8 | (n[14] & 255) << 16 | (n[15] & 255) << 24, K = c, Y = x, q = w, D = _, G = M, C = Z, b = P, m = bt, T = V, B = Q, A = tt, O = ft, X = at, ct = et, lt = st, ut = rt, d, gt = 0; gt < 20; gt += 2)
        d = K + X | 0, G ^= d << 7 | d >>> 25, d = G + K | 0, T ^= d << 9 | d >>> 23, d = T + G | 0, X ^= d << 13 | d >>> 19, d = X + T | 0, K ^= d << 18 | d >>> 14, d = C + Y | 0, B ^= d << 7 | d >>> 25, d = B + C | 0, ct ^= d << 9 | d >>> 23, d = ct + B | 0, Y ^= d << 13 | d >>> 19, d = Y + ct | 0, C ^= d << 18 | d >>> 14, d = A + b | 0, lt ^= d << 7 | d >>> 25, d = lt + A | 0, q ^= d << 9 | d >>> 23, d = q + lt | 0, b ^= d << 13 | d >>> 19, d = b + q | 0, A ^= d << 18 | d >>> 14, d = ut + O | 0, D ^= d << 7 | d >>> 25, d = D + ut | 0, m ^= d << 9 | d >>> 23, d = m + D | 0, O ^= d << 13 | d >>> 19, d = O + m | 0, ut ^= d << 18 | d >>> 14, d = K + D | 0, Y ^= d << 7 | d >>> 25, d = Y + K | 0, q ^= d << 9 | d >>> 23, d = q + Y | 0, D ^= d << 13 | d >>> 19, d = D + q | 0, K ^= d << 18 | d >>> 14, d = C + G | 0, b ^= d << 7 | d >>> 25, d = b + C | 0, m ^= d << 9 | d >>> 23, d = m + b | 0, G ^= d << 13 | d >>> 19, d = G + m | 0, C ^= d << 18 | d >>> 14, d = A + B | 0, O ^= d << 7 | d >>> 25, d = O + A | 0, T ^= d << 9 | d >>> 23, d = T + O | 0, B ^= d << 13 | d >>> 19, d = B + T | 0, A ^= d << 18 | d >>> 14, d = ut + lt | 0, X ^= d << 7 | d >>> 25, d = X + ut | 0, ct ^= d << 9 | d >>> 23, d = ct + X | 0, lt ^= d << 13 | d >>> 19, d = lt + ct | 0, ut ^= d << 18 | d >>> 14;
      i[0] = K >>> 0 & 255, i[1] = K >>> 8 & 255, i[2] = K >>> 16 & 255, i[3] = K >>> 24 & 255, i[4] = C >>> 0 & 255, i[5] = C >>> 8 & 255, i[6] = C >>> 16 & 255, i[7] = C >>> 24 & 255, i[8] = A >>> 0 & 255, i[9] = A >>> 8 & 255, i[10] = A >>> 16 & 255, i[11] = A >>> 24 & 255, i[12] = ut >>> 0 & 255, i[13] = ut >>> 8 & 255, i[14] = ut >>> 16 & 255, i[15] = ut >>> 24 & 255, i[16] = b >>> 0 & 255, i[17] = b >>> 8 & 255, i[18] = b >>> 16 & 255, i[19] = b >>> 24 & 255, i[20] = m >>> 0 & 255, i[21] = m >>> 8 & 255, i[22] = m >>> 16 & 255, i[23] = m >>> 24 & 255, i[24] = T >>> 0 & 255, i[25] = T >>> 8 & 255, i[26] = T >>> 16 & 255, i[27] = T >>> 24 & 255, i[28] = B >>> 0 & 255, i[29] = B >>> 8 & 255, i[30] = B >>> 16 & 255, i[31] = B >>> 24 & 255;
    }
    function nt(i, f, a, n) {
      H(i, f, a, n);
    }
    function J(i, f, a, n) {
      W(i, f, a, n);
    }
    var j = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function F(i, f, a, n, c, x, w) {
      var _ = new Uint8Array(16), M = new Uint8Array(64), Z, P;
      for (P = 0; P < 16; P++)
        _[P] = 0;
      for (P = 0; P < 8; P++)
        _[P] = x[P];
      for (; c >= 64; ) {
        for (nt(M, _, w, j), P = 0; P < 64; P++)
          i[f + P] = a[n + P] ^ M[P];
        for (Z = 1, P = 8; P < 16; P++)
          Z = Z + (_[P] & 255) | 0, _[P] = Z & 255, Z >>>= 8;
        c -= 64, f += 64, n += 64;
      }
      if (c > 0)
        for (nt(M, _, w, j), P = 0; P < c; P++)
          i[f + P] = a[n + P] ^ M[P];
      return 0;
    }
    function it(i, f, a, n, c) {
      var x = new Uint8Array(16), w = new Uint8Array(64), _, M;
      for (M = 0; M < 16; M++)
        x[M] = 0;
      for (M = 0; M < 8; M++)
        x[M] = n[M];
      for (; a >= 64; ) {
        for (nt(w, x, c, j), M = 0; M < 64; M++)
          i[f + M] = w[M];
        for (_ = 1, M = 8; M < 16; M++)
          _ = _ + (x[M] & 255) | 0, x[M] = _ & 255, _ >>>= 8;
        a -= 64, f += 64;
      }
      if (a > 0)
        for (nt(w, x, c, j), M = 0; M < a; M++)
          i[f + M] = w[M];
      return 0;
    }
    function Zt(i, f, a, n, c) {
      var x = new Uint8Array(32);
      J(x, n, c, j);
      for (var w = new Uint8Array(8), _ = 0; _ < 8; _++)
        w[_] = n[_ + 16];
      return it(i, f, a, w, x);
    }
    function Bt(i, f, a, n, c, x, w) {
      var _ = new Uint8Array(32);
      J(_, x, w, j);
      for (var M = new Uint8Array(8), Z = 0; Z < 8; Z++)
        M[Z] = x[Z + 16];
      return F(i, f, a, n, c, M, _);
    }
    var xt = function(i) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var f, a, n, c, x, w, _, M;
      f = i[0] & 255 | (i[1] & 255) << 8, this.r[0] = f & 8191, a = i[2] & 255 | (i[3] & 255) << 8, this.r[1] = (f >>> 13 | a << 3) & 8191, n = i[4] & 255 | (i[5] & 255) << 8, this.r[2] = (a >>> 10 | n << 6) & 7939, c = i[6] & 255 | (i[7] & 255) << 8, this.r[3] = (n >>> 7 | c << 9) & 8191, x = i[8] & 255 | (i[9] & 255) << 8, this.r[4] = (c >>> 4 | x << 12) & 255, this.r[5] = x >>> 1 & 8190, w = i[10] & 255 | (i[11] & 255) << 8, this.r[6] = (x >>> 14 | w << 2) & 8191, _ = i[12] & 255 | (i[13] & 255) << 8, this.r[7] = (w >>> 11 | _ << 5) & 8065, M = i[14] & 255 | (i[15] & 255) << 8, this.r[8] = (_ >>> 8 | M << 8) & 8191, this.r[9] = M >>> 5 & 127, this.pad[0] = i[16] & 255 | (i[17] & 255) << 8, this.pad[1] = i[18] & 255 | (i[19] & 255) << 8, this.pad[2] = i[20] & 255 | (i[21] & 255) << 8, this.pad[3] = i[22] & 255 | (i[23] & 255) << 8, this.pad[4] = i[24] & 255 | (i[25] & 255) << 8, this.pad[5] = i[26] & 255 | (i[27] & 255) << 8, this.pad[6] = i[28] & 255 | (i[29] & 255) << 8, this.pad[7] = i[30] & 255 | (i[31] & 255) << 8;
    };
    xt.prototype.blocks = function(i, f, a) {
      for (var n = this.fin ? 0 : 2048, c, x, w, _, M, Z, P, bt, V, Q, tt, ft, at, et, st, rt, K, Y, q, D = this.h[0], G = this.h[1], C = this.h[2], b = this.h[3], m = this.h[4], T = this.h[5], B = this.h[6], A = this.h[7], O = this.h[8], X = this.h[9], ct = this.r[0], lt = this.r[1], ut = this.r[2], d = this.r[3], gt = this.r[4], mt = this.r[5], Et = this.r[6], dt = this.r[7], wt = this.r[8], pt = this.r[9]; a >= 16; )
        c = i[f + 0] & 255 | (i[f + 1] & 255) << 8, D += c & 8191, x = i[f + 2] & 255 | (i[f + 3] & 255) << 8, G += (c >>> 13 | x << 3) & 8191, w = i[f + 4] & 255 | (i[f + 5] & 255) << 8, C += (x >>> 10 | w << 6) & 8191, _ = i[f + 6] & 255 | (i[f + 7] & 255) << 8, b += (w >>> 7 | _ << 9) & 8191, M = i[f + 8] & 255 | (i[f + 9] & 255) << 8, m += (_ >>> 4 | M << 12) & 8191, T += M >>> 1 & 8191, Z = i[f + 10] & 255 | (i[f + 11] & 255) << 8, B += (M >>> 14 | Z << 2) & 8191, P = i[f + 12] & 255 | (i[f + 13] & 255) << 8, A += (Z >>> 11 | P << 5) & 8191, bt = i[f + 14] & 255 | (i[f + 15] & 255) << 8, O += (P >>> 8 | bt << 8) & 8191, X += bt >>> 5 | n, V = 0, Q = V, Q += D * ct, Q += G * (5 * pt), Q += C * (5 * wt), Q += b * (5 * dt), Q += m * (5 * Et), V = Q >>> 13, Q &= 8191, Q += T * (5 * mt), Q += B * (5 * gt), Q += A * (5 * d), Q += O * (5 * ut), Q += X * (5 * lt), V += Q >>> 13, Q &= 8191, tt = V, tt += D * lt, tt += G * ct, tt += C * (5 * pt), tt += b * (5 * wt), tt += m * (5 * dt), V = tt >>> 13, tt &= 8191, tt += T * (5 * Et), tt += B * (5 * mt), tt += A * (5 * gt), tt += O * (5 * d), tt += X * (5 * ut), V += tt >>> 13, tt &= 8191, ft = V, ft += D * ut, ft += G * lt, ft += C * ct, ft += b * (5 * pt), ft += m * (5 * wt), V = ft >>> 13, ft &= 8191, ft += T * (5 * dt), ft += B * (5 * Et), ft += A * (5 * mt), ft += O * (5 * gt), ft += X * (5 * d), V += ft >>> 13, ft &= 8191, at = V, at += D * d, at += G * ut, at += C * lt, at += b * ct, at += m * (5 * pt), V = at >>> 13, at &= 8191, at += T * (5 * wt), at += B * (5 * dt), at += A * (5 * Et), at += O * (5 * mt), at += X * (5 * gt), V += at >>> 13, at &= 8191, et = V, et += D * gt, et += G * d, et += C * ut, et += b * lt, et += m * ct, V = et >>> 13, et &= 8191, et += T * (5 * pt), et += B * (5 * wt), et += A * (5 * dt), et += O * (5 * Et), et += X * (5 * mt), V += et >>> 13, et &= 8191, st = V, st += D * mt, st += G * gt, st += C * d, st += b * ut, st += m * lt, V = st >>> 13, st &= 8191, st += T * ct, st += B * (5 * pt), st += A * (5 * wt), st += O * (5 * dt), st += X * (5 * Et), V += st >>> 13, st &= 8191, rt = V, rt += D * Et, rt += G * mt, rt += C * gt, rt += b * d, rt += m * ut, V = rt >>> 13, rt &= 8191, rt += T * lt, rt += B * ct, rt += A * (5 * pt), rt += O * (5 * wt), rt += X * (5 * dt), V += rt >>> 13, rt &= 8191, K = V, K += D * dt, K += G * Et, K += C * mt, K += b * gt, K += m * d, V = K >>> 13, K &= 8191, K += T * ut, K += B * lt, K += A * ct, K += O * (5 * pt), K += X * (5 * wt), V += K >>> 13, K &= 8191, Y = V, Y += D * wt, Y += G * dt, Y += C * Et, Y += b * mt, Y += m * gt, V = Y >>> 13, Y &= 8191, Y += T * d, Y += B * ut, Y += A * lt, Y += O * ct, Y += X * (5 * pt), V += Y >>> 13, Y &= 8191, q = V, q += D * pt, q += G * wt, q += C * dt, q += b * Et, q += m * mt, V = q >>> 13, q &= 8191, q += T * gt, q += B * d, q += A * ut, q += O * lt, q += X * ct, V += q >>> 13, q &= 8191, V = (V << 2) + V | 0, V = V + Q | 0, Q = V & 8191, V = V >>> 13, tt += V, D = Q, G = tt, C = ft, b = at, m = et, T = st, B = rt, A = K, O = Y, X = q, f += 16, a -= 16;
      this.h[0] = D, this.h[1] = G, this.h[2] = C, this.h[3] = b, this.h[4] = m, this.h[5] = T, this.h[6] = B, this.h[7] = A, this.h[8] = O, this.h[9] = X;
    }, xt.prototype.finish = function(i, f) {
      var a = new Uint16Array(10), n, c, x, w;
      if (this.leftover) {
        for (w = this.leftover, this.buffer[w++] = 1; w < 16; w++)
          this.buffer[w] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (n = this.h[1] >>> 13, this.h[1] &= 8191, w = 2; w < 10; w++)
        this.h[w] += n, n = this.h[w] >>> 13, this.h[w] &= 8191;
      for (this.h[0] += n * 5, n = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += n, n = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += n, a[0] = this.h[0] + 5, n = a[0] >>> 13, a[0] &= 8191, w = 1; w < 10; w++)
        a[w] = this.h[w] + n, n = a[w] >>> 13, a[w] &= 8191;
      for (a[9] -= 8192, c = (n ^ 1) - 1, w = 0; w < 10; w++)
        a[w] &= c;
      for (c = ~c, w = 0; w < 10; w++)
        this.h[w] = this.h[w] & c | a[w];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, x = this.h[0] + this.pad[0], this.h[0] = x & 65535, w = 1; w < 8; w++)
        x = (this.h[w] + this.pad[w] | 0) + (x >>> 16) | 0, this.h[w] = x & 65535;
      i[f + 0] = this.h[0] >>> 0 & 255, i[f + 1] = this.h[0] >>> 8 & 255, i[f + 2] = this.h[1] >>> 0 & 255, i[f + 3] = this.h[1] >>> 8 & 255, i[f + 4] = this.h[2] >>> 0 & 255, i[f + 5] = this.h[2] >>> 8 & 255, i[f + 6] = this.h[3] >>> 0 & 255, i[f + 7] = this.h[3] >>> 8 & 255, i[f + 8] = this.h[4] >>> 0 & 255, i[f + 9] = this.h[4] >>> 8 & 255, i[f + 10] = this.h[5] >>> 0 & 255, i[f + 11] = this.h[5] >>> 8 & 255, i[f + 12] = this.h[6] >>> 0 & 255, i[f + 13] = this.h[6] >>> 8 & 255, i[f + 14] = this.h[7] >>> 0 & 255, i[f + 15] = this.h[7] >>> 8 & 255;
    }, xt.prototype.update = function(i, f, a) {
      var n, c;
      if (this.leftover) {
        for (c = 16 - this.leftover, c > a && (c = a), n = 0; n < c; n++)
          this.buffer[this.leftover + n] = i[f + n];
        if (a -= c, f += c, this.leftover += c, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (a >= 16 && (c = a - a % 16, this.blocks(i, f, c), f += c, a -= c), a) {
        for (n = 0; n < a; n++)
          this.buffer[this.leftover + n] = i[f + n];
        this.leftover += a;
      }
    };
    function jt(i, f, a, n, c, x) {
      var w = new xt(x);
      return w.update(a, n, c), w.finish(i, f), 0;
    }
    function Kt(i, f, a, n, c, x) {
      var w = new Uint8Array(16);
      return jt(w, 0, a, n, c, x), k(i, f, w, 0);
    }
    function Qt(i, f, a, n, c) {
      var x;
      if (a < 32)
        return -1;
      for (Bt(i, 0, f, 0, a, n, c), jt(i, 16, i, 32, a - 32, i), x = 0; x < 16; x++)
        i[x] = 0;
      return 0;
    }
    function $(i, f, a, n, c) {
      var x, w = new Uint8Array(32);
      if (a < 32 || (Zt(w, 0, 32, n, c), Kt(f, 16, f, 32, a - 32, w) !== 0))
        return -1;
      for (Bt(i, 0, f, 0, a, n, c), x = 0; x < 32; x++)
        i[x] = 0;
      return 0;
    }
    function z(i, f) {
      var a;
      for (a = 0; a < 16; a++)
        i[a] = f[a] | 0;
    }
    function ht(i) {
      var f, a, n = 1;
      for (f = 0; f < 16; f++)
        a = i[f] + n + 65535, n = Math.floor(a / 65536), i[f] = a - n * 65536;
      i[0] += n - 1 + 37 * (n - 1);
    }
    function vt(i, f, a) {
      for (var n, c = ~(a - 1), x = 0; x < 16; x++)
        n = c & (i[x] ^ f[x]), i[x] ^= n, f[x] ^= n;
    }
    function yt(i, f) {
      var a, n, c, x = e(), w = e();
      for (a = 0; a < 16; a++)
        w[a] = f[a];
      for (ht(w), ht(w), ht(w), n = 0; n < 2; n++) {
        for (x[0] = w[0] - 65517, a = 1; a < 15; a++)
          x[a] = w[a] - 65535 - (x[a - 1] >> 16 & 1), x[a - 1] &= 65535;
        x[15] = w[15] - 32767 - (x[14] >> 16 & 1), c = x[15] >> 16 & 1, x[14] &= 65535, vt(w, x, 1 - c);
      }
      for (a = 0; a < 16; a++)
        i[2 * a] = w[a] & 255, i[2 * a + 1] = w[a] >> 8;
    }
    function Mt(i, f) {
      var a = new Uint8Array(32), n = new Uint8Array(32);
      return yt(a, i), yt(n, f), L(a, 0, n, 0);
    }
    function Vt(i) {
      var f = new Uint8Array(32);
      return yt(f, i), f[0] & 1;
    }
    function Pt(i, f) {
      var a;
      for (a = 0; a < 16; a++)
        i[a] = f[2 * a] + (f[2 * a + 1] << 8);
      i[15] &= 32767;
    }
    function $t(i, f, a) {
      for (var n = 0; n < 16; n++)
        i[n] = f[n] + a[n];
    }
    function Tt(i, f, a) {
      for (var n = 0; n < 16; n++)
        i[n] = f[n] - a[n];
    }
    function ot(i, f, a) {
      var n, c, x = 0, w = 0, _ = 0, M = 0, Z = 0, P = 0, bt = 0, V = 0, Q = 0, tt = 0, ft = 0, at = 0, et = 0, st = 0, rt = 0, K = 0, Y = 0, q = 0, D = 0, G = 0, C = 0, b = 0, m = 0, T = 0, B = 0, A = 0, O = 0, X = 0, ct = 0, lt = 0, ut = 0, d = a[0], gt = a[1], mt = a[2], Et = a[3], dt = a[4], wt = a[5], pt = a[6], Nt = a[7], St = a[8], It = a[9], Ut = a[10], kt = a[11], Ct = a[12], Dt = a[13], Ht = a[14], Gt = a[15];
      n = f[0], x += n * d, w += n * gt, _ += n * mt, M += n * Et, Z += n * dt, P += n * wt, bt += n * pt, V += n * Nt, Q += n * St, tt += n * It, ft += n * Ut, at += n * kt, et += n * Ct, st += n * Dt, rt += n * Ht, K += n * Gt, n = f[1], w += n * d, _ += n * gt, M += n * mt, Z += n * Et, P += n * dt, bt += n * wt, V += n * pt, Q += n * Nt, tt += n * St, ft += n * It, at += n * Ut, et += n * kt, st += n * Ct, rt += n * Dt, K += n * Ht, Y += n * Gt, n = f[2], _ += n * d, M += n * gt, Z += n * mt, P += n * Et, bt += n * dt, V += n * wt, Q += n * pt, tt += n * Nt, ft += n * St, at += n * It, et += n * Ut, st += n * kt, rt += n * Ct, K += n * Dt, Y += n * Ht, q += n * Gt, n = f[3], M += n * d, Z += n * gt, P += n * mt, bt += n * Et, V += n * dt, Q += n * wt, tt += n * pt, ft += n * Nt, at += n * St, et += n * It, st += n * Ut, rt += n * kt, K += n * Ct, Y += n * Dt, q += n * Ht, D += n * Gt, n = f[4], Z += n * d, P += n * gt, bt += n * mt, V += n * Et, Q += n * dt, tt += n * wt, ft += n * pt, at += n * Nt, et += n * St, st += n * It, rt += n * Ut, K += n * kt, Y += n * Ct, q += n * Dt, D += n * Ht, G += n * Gt, n = f[5], P += n * d, bt += n * gt, V += n * mt, Q += n * Et, tt += n * dt, ft += n * wt, at += n * pt, et += n * Nt, st += n * St, rt += n * It, K += n * Ut, Y += n * kt, q += n * Ct, D += n * Dt, G += n * Ht, C += n * Gt, n = f[6], bt += n * d, V += n * gt, Q += n * mt, tt += n * Et, ft += n * dt, at += n * wt, et += n * pt, st += n * Nt, rt += n * St, K += n * It, Y += n * Ut, q += n * kt, D += n * Ct, G += n * Dt, C += n * Ht, b += n * Gt, n = f[7], V += n * d, Q += n * gt, tt += n * mt, ft += n * Et, at += n * dt, et += n * wt, st += n * pt, rt += n * Nt, K += n * St, Y += n * It, q += n * Ut, D += n * kt, G += n * Ct, C += n * Dt, b += n * Ht, m += n * Gt, n = f[8], Q += n * d, tt += n * gt, ft += n * mt, at += n * Et, et += n * dt, st += n * wt, rt += n * pt, K += n * Nt, Y += n * St, q += n * It, D += n * Ut, G += n * kt, C += n * Ct, b += n * Dt, m += n * Ht, T += n * Gt, n = f[9], tt += n * d, ft += n * gt, at += n * mt, et += n * Et, st += n * dt, rt += n * wt, K += n * pt, Y += n * Nt, q += n * St, D += n * It, G += n * Ut, C += n * kt, b += n * Ct, m += n * Dt, T += n * Ht, B += n * Gt, n = f[10], ft += n * d, at += n * gt, et += n * mt, st += n * Et, rt += n * dt, K += n * wt, Y += n * pt, q += n * Nt, D += n * St, G += n * It, C += n * Ut, b += n * kt, m += n * Ct, T += n * Dt, B += n * Ht, A += n * Gt, n = f[11], at += n * d, et += n * gt, st += n * mt, rt += n * Et, K += n * dt, Y += n * wt, q += n * pt, D += n * Nt, G += n * St, C += n * It, b += n * Ut, m += n * kt, T += n * Ct, B += n * Dt, A += n * Ht, O += n * Gt, n = f[12], et += n * d, st += n * gt, rt += n * mt, K += n * Et, Y += n * dt, q += n * wt, D += n * pt, G += n * Nt, C += n * St, b += n * It, m += n * Ut, T += n * kt, B += n * Ct, A += n * Dt, O += n * Ht, X += n * Gt, n = f[13], st += n * d, rt += n * gt, K += n * mt, Y += n * Et, q += n * dt, D += n * wt, G += n * pt, C += n * Nt, b += n * St, m += n * It, T += n * Ut, B += n * kt, A += n * Ct, O += n * Dt, X += n * Ht, ct += n * Gt, n = f[14], rt += n * d, K += n * gt, Y += n * mt, q += n * Et, D += n * dt, G += n * wt, C += n * pt, b += n * Nt, m += n * St, T += n * It, B += n * Ut, A += n * kt, O += n * Ct, X += n * Dt, ct += n * Ht, lt += n * Gt, n = f[15], K += n * d, Y += n * gt, q += n * mt, D += n * Et, G += n * dt, C += n * wt, b += n * pt, m += n * Nt, T += n * St, B += n * It, A += n * Ut, O += n * kt, X += n * Ct, ct += n * Dt, lt += n * Ht, ut += n * Gt, x += 38 * Y, w += 38 * q, _ += 38 * D, M += 38 * G, Z += 38 * C, P += 38 * b, bt += 38 * m, V += 38 * T, Q += 38 * B, tt += 38 * A, ft += 38 * O, at += 38 * X, et += 38 * ct, st += 38 * lt, rt += 38 * ut, c = 1, n = x + c + 65535, c = Math.floor(n / 65536), x = n - c * 65536, n = w + c + 65535, c = Math.floor(n / 65536), w = n - c * 65536, n = _ + c + 65535, c = Math.floor(n / 65536), _ = n - c * 65536, n = M + c + 65535, c = Math.floor(n / 65536), M = n - c * 65536, n = Z + c + 65535, c = Math.floor(n / 65536), Z = n - c * 65536, n = P + c + 65535, c = Math.floor(n / 65536), P = n - c * 65536, n = bt + c + 65535, c = Math.floor(n / 65536), bt = n - c * 65536, n = V + c + 65535, c = Math.floor(n / 65536), V = n - c * 65536, n = Q + c + 65535, c = Math.floor(n / 65536), Q = n - c * 65536, n = tt + c + 65535, c = Math.floor(n / 65536), tt = n - c * 65536, n = ft + c + 65535, c = Math.floor(n / 65536), ft = n - c * 65536, n = at + c + 65535, c = Math.floor(n / 65536), at = n - c * 65536, n = et + c + 65535, c = Math.floor(n / 65536), et = n - c * 65536, n = st + c + 65535, c = Math.floor(n / 65536), st = n - c * 65536, n = rt + c + 65535, c = Math.floor(n / 65536), rt = n - c * 65536, n = K + c + 65535, c = Math.floor(n / 65536), K = n - c * 65536, x += c - 1 + 37 * (c - 1), c = 1, n = x + c + 65535, c = Math.floor(n / 65536), x = n - c * 65536, n = w + c + 65535, c = Math.floor(n / 65536), w = n - c * 65536, n = _ + c + 65535, c = Math.floor(n / 65536), _ = n - c * 65536, n = M + c + 65535, c = Math.floor(n / 65536), M = n - c * 65536, n = Z + c + 65535, c = Math.floor(n / 65536), Z = n - c * 65536, n = P + c + 65535, c = Math.floor(n / 65536), P = n - c * 65536, n = bt + c + 65535, c = Math.floor(n / 65536), bt = n - c * 65536, n = V + c + 65535, c = Math.floor(n / 65536), V = n - c * 65536, n = Q + c + 65535, c = Math.floor(n / 65536), Q = n - c * 65536, n = tt + c + 65535, c = Math.floor(n / 65536), tt = n - c * 65536, n = ft + c + 65535, c = Math.floor(n / 65536), ft = n - c * 65536, n = at + c + 65535, c = Math.floor(n / 65536), at = n - c * 65536, n = et + c + 65535, c = Math.floor(n / 65536), et = n - c * 65536, n = st + c + 65535, c = Math.floor(n / 65536), st = n - c * 65536, n = rt + c + 65535, c = Math.floor(n / 65536), rt = n - c * 65536, n = K + c + 65535, c = Math.floor(n / 65536), K = n - c * 65536, x += c - 1 + 37 * (c - 1), i[0] = x, i[1] = w, i[2] = _, i[3] = M, i[4] = Z, i[5] = P, i[6] = bt, i[7] = V, i[8] = Q, i[9] = tt, i[10] = ft, i[11] = at, i[12] = et, i[13] = st, i[14] = rt, i[15] = K;
    }
    function zt(i, f) {
      ot(i, f, f);
    }
    function ie(i, f) {
      var a = e(), n;
      for (n = 0; n < 16; n++)
        a[n] = f[n];
      for (n = 253; n >= 0; n--)
        zt(a, a), n !== 2 && n !== 4 && ot(a, a, f);
      for (n = 0; n < 16; n++)
        i[n] = a[n];
    }
    function De(i, f) {
      var a = e(), n;
      for (n = 0; n < 16; n++)
        a[n] = f[n];
      for (n = 250; n >= 0; n--)
        zt(a, a), n !== 1 && ot(a, a, f);
      for (n = 0; n < 16; n++)
        i[n] = a[n];
    }
    function te(i, f, a) {
      var n = new Uint8Array(32), c = new Float64Array(80), x, w, _ = e(), M = e(), Z = e(), P = e(), bt = e(), V = e();
      for (w = 0; w < 31; w++)
        n[w] = f[w];
      for (n[31] = f[31] & 127 | 64, n[0] &= 248, Pt(c, a), w = 0; w < 16; w++)
        M[w] = c[w], P[w] = _[w] = Z[w] = 0;
      for (_[0] = P[0] = 1, w = 254; w >= 0; --w)
        x = n[w >>> 3] >>> (w & 7) & 1, vt(_, M, x), vt(Z, P, x), $t(bt, _, Z), Tt(_, _, Z), $t(Z, M, P), Tt(M, M, P), zt(P, bt), zt(V, _), ot(_, Z, _), ot(Z, M, bt), $t(bt, _, Z), Tt(_, _, Z), zt(M, _), Tt(Z, P, V), ot(_, Z, l), $t(_, _, P), ot(Z, Z, _), ot(_, P, V), ot(P, M, c), zt(M, bt), vt(_, M, x), vt(Z, P, x);
      for (w = 0; w < 16; w++)
        c[w + 16] = _[w], c[w + 32] = Z[w], c[w + 48] = M[w], c[w + 64] = P[w];
      var Q = c.subarray(32), tt = c.subarray(16);
      return ie(Q, Q), ot(tt, tt, Q), yt(i, tt), 0;
    }
    function oe(i, f) {
      return te(i, f, u);
    }
    function ir(i, f) {
      return s(f, 32), oe(i, f);
    }
    function ae(i, f, a) {
      var n = new Uint8Array(32);
      return te(n, a, f), J(i, o, n, j);
    }
    var Wt = Qt, Se = $;
    function Ar(i, f, a, n, c, x) {
      var w = new Uint8Array(32);
      return ae(w, c, x), Wt(i, f, a, n, w);
    }
    function Tr(i, f, a, n, c, x) {
      var w = new Uint8Array(32);
      return ae(w, c, x), Se(i, f, a, n, w);
    }
    var ns = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function ss(i, f, a, n) {
      for (var c = new Int32Array(16), x = new Int32Array(16), w, _, M, Z, P, bt, V, Q, tt, ft, at, et, st, rt, K, Y, q, D, G, C, b, m, T, B, A, O, X = i[0], ct = i[1], lt = i[2], ut = i[3], d = i[4], gt = i[5], mt = i[6], Et = i[7], dt = f[0], wt = f[1], pt = f[2], Nt = f[3], St = f[4], It = f[5], Ut = f[6], kt = f[7], Ct = 0; n >= 128; ) {
        for (G = 0; G < 16; G++)
          C = 8 * G + Ct, c[G] = a[C + 0] << 24 | a[C + 1] << 16 | a[C + 2] << 8 | a[C + 3], x[G] = a[C + 4] << 24 | a[C + 5] << 16 | a[C + 6] << 8 | a[C + 7];
        for (G = 0; G < 80; G++)
          if (w = X, _ = ct, M = lt, Z = ut, P = d, bt = gt, V = mt, Q = Et, tt = dt, ft = wt, at = pt, et = Nt, st = St, rt = It, K = Ut, Y = kt, b = Et, m = kt, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = (d >>> 14 | St << 18) ^ (d >>> 18 | St << 14) ^ (St >>> 9 | d << 23), m = (St >>> 14 | d << 18) ^ (St >>> 18 | d << 14) ^ (d >>> 9 | St << 23), T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, b = d & gt ^ ~d & mt, m = St & It ^ ~St & Ut, T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, b = ns[G * 2], m = ns[G * 2 + 1], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, b = c[G % 16], m = x[G % 16], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, q = A & 65535 | O << 16, D = T & 65535 | B << 16, b = q, m = D, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = (X >>> 28 | dt << 4) ^ (dt >>> 2 | X << 30) ^ (dt >>> 7 | X << 25), m = (dt >>> 28 | X << 4) ^ (X >>> 2 | dt << 30) ^ (X >>> 7 | dt << 25), T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, b = X & ct ^ X & lt ^ ct & lt, m = dt & wt ^ dt & pt ^ wt & pt, T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, Q = A & 65535 | O << 16, Y = T & 65535 | B << 16, b = Z, m = et, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = q, m = D, T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, Z = A & 65535 | O << 16, et = T & 65535 | B << 16, ct = w, lt = _, ut = M, d = Z, gt = P, mt = bt, Et = V, X = Q, wt = tt, pt = ft, Nt = at, St = et, It = st, Ut = rt, kt = K, dt = Y, G % 16 === 15)
            for (C = 0; C < 16; C++)
              b = c[C], m = x[C], T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = c[(C + 9) % 16], m = x[(C + 9) % 16], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, q = c[(C + 1) % 16], D = x[(C + 1) % 16], b = (q >>> 1 | D << 31) ^ (q >>> 8 | D << 24) ^ q >>> 7, m = (D >>> 1 | q << 31) ^ (D >>> 8 | q << 24) ^ (D >>> 7 | q << 25), T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, q = c[(C + 14) % 16], D = x[(C + 14) % 16], b = (q >>> 19 | D << 13) ^ (D >>> 29 | q << 3) ^ q >>> 6, m = (D >>> 19 | q << 13) ^ (q >>> 29 | D << 3) ^ (D >>> 6 | q << 26), T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, c[C] = A & 65535 | O << 16, x[C] = T & 65535 | B << 16;
        b = X, m = dt, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[0], m = f[0], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[0] = X = A & 65535 | O << 16, f[0] = dt = T & 65535 | B << 16, b = ct, m = wt, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[1], m = f[1], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[1] = ct = A & 65535 | O << 16, f[1] = wt = T & 65535 | B << 16, b = lt, m = pt, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[2], m = f[2], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[2] = lt = A & 65535 | O << 16, f[2] = pt = T & 65535 | B << 16, b = ut, m = Nt, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[3], m = f[3], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[3] = ut = A & 65535 | O << 16, f[3] = Nt = T & 65535 | B << 16, b = d, m = St, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[4], m = f[4], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[4] = d = A & 65535 | O << 16, f[4] = St = T & 65535 | B << 16, b = gt, m = It, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[5], m = f[5], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[5] = gt = A & 65535 | O << 16, f[5] = It = T & 65535 | B << 16, b = mt, m = Ut, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[6], m = f[6], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[6] = mt = A & 65535 | O << 16, f[6] = Ut = T & 65535 | B << 16, b = Et, m = kt, T = m & 65535, B = m >>> 16, A = b & 65535, O = b >>> 16, b = i[7], m = f[7], T += m & 65535, B += m >>> 16, A += b & 65535, O += b >>> 16, B += T >>> 16, A += B >>> 16, O += A >>> 16, i[7] = Et = A & 65535 | O << 16, f[7] = kt = T & 65535 | B << 16, Ct += 128, n -= 128;
      }
      return n;
    }
    function Ne(i, f, a) {
      var n = new Int32Array(8), c = new Int32Array(8), x = new Uint8Array(256), w, _ = a;
      for (n[0] = 1779033703, n[1] = 3144134277, n[2] = 1013904242, n[3] = 2773480762, n[4] = 1359893119, n[5] = 2600822924, n[6] = 528734635, n[7] = 1541459225, c[0] = 4089235720, c[1] = 2227873595, c[2] = 4271175723, c[3] = 1595750129, c[4] = 2917565137, c[5] = 725511199, c[6] = 4215389547, c[7] = 327033209, ss(n, c, f, a), a %= 128, w = 0; w < a; w++)
        x[w] = f[_ - a + w];
      for (x[a] = 128, a = 256 - 128 * (a < 112 ? 1 : 0), x[a - 9] = 0, U(x, a - 8, _ / 536870912 | 0, _ << 3), ss(n, c, x, a), w = 0; w < 8; w++)
        U(i, 8 * w, n[w], c[w]);
      return 0;
    }
    function Ir(i, f) {
      var a = e(), n = e(), c = e(), x = e(), w = e(), _ = e(), M = e(), Z = e(), P = e();
      Tt(a, i[1], i[0]), Tt(P, f[1], f[0]), ot(a, a, P), $t(n, i[0], i[1]), $t(P, f[0], f[1]), ot(n, n, P), ot(c, i[3], f[3]), ot(c, c, S), ot(x, i[2], f[2]), $t(x, x, x), Tt(w, n, a), Tt(_, x, c), $t(M, x, c), $t(Z, n, a), ot(i[0], w, _), ot(i[1], Z, M), ot(i[2], M, _), ot(i[3], w, Z);
    }
    function is(i, f, a) {
      var n;
      for (n = 0; n < 4; n++)
        vt(i[n], f[n], a);
    }
    function Wr(i, f) {
      var a = e(), n = e(), c = e();
      ie(c, f[2]), ot(a, f[0], c), ot(n, f[1], c), yt(i, n), i[31] ^= Vt(a) << 7;
    }
    function Fr(i, f, a) {
      var n, c;
      for (z(i[0], g), z(i[1], h), z(i[2], h), z(i[3], g), c = 255; c >= 0; --c)
        n = a[c / 8 | 0] >> (c & 7) & 1, is(i, f, n), Ir(f, i), Ir(i, i), is(i, f, n);
    }
    function Ur(i, f) {
      var a = [e(), e(), e(), e()];
      z(a[0], p), z(a[1], N), z(a[2], h), ot(a[3], p, N), Fr(i, a, f);
    }
    function Xr(i, f, a) {
      var n = new Uint8Array(64), c = [e(), e(), e(), e()], x;
      for (a || s(f, 32), Ne(n, f, 32), n[0] &= 248, n[31] &= 127, n[31] |= 64, Ur(c, n), Wr(i, c), x = 0; x < 32; x++)
        f[x + 32] = i[x];
      return 0;
    }
    var kr = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function Jr(i, f) {
      var a, n, c, x;
      for (n = 63; n >= 32; --n) {
        for (a = 0, c = n - 32, x = n - 12; c < x; ++c)
          f[c] += a - 16 * f[n] * kr[c - (n - 32)], a = Math.floor((f[c] + 128) / 256), f[c] -= a * 256;
        f[c] += a, f[n] = 0;
      }
      for (a = 0, c = 0; c < 32; c++)
        f[c] += a - (f[31] >> 4) * kr[c], a = f[c] >> 8, f[c] &= 255;
      for (c = 0; c < 32; c++)
        f[c] -= a * kr[c];
      for (n = 0; n < 32; n++)
        f[n + 1] += f[n] >> 8, i[n] = f[n] & 255;
    }
    function Qr(i) {
      var f = new Float64Array(64), a;
      for (a = 0; a < 64; a++)
        f[a] = i[a];
      for (a = 0; a < 64; a++)
        i[a] = 0;
      Jr(i, f);
    }
    function os(i, f, a, n) {
      var c = new Uint8Array(64), x = new Uint8Array(64), w = new Uint8Array(64), _, M, Z = new Float64Array(64), P = [e(), e(), e(), e()];
      Ne(c, n, 32), c[0] &= 248, c[31] &= 127, c[31] |= 64;
      var bt = a + 64;
      for (_ = 0; _ < a; _++)
        i[64 + _] = f[_];
      for (_ = 0; _ < 32; _++)
        i[32 + _] = c[32 + _];
      for (Ne(w, i.subarray(32), a + 32), Qr(w), Ur(P, w), Wr(i, P), _ = 32; _ < 64; _++)
        i[_] = n[_];
      for (Ne(x, i, a + 64), Qr(x), _ = 0; _ < 64; _++)
        Z[_] = 0;
      for (_ = 0; _ < 32; _++)
        Z[_] = w[_];
      for (_ = 0; _ < 32; _++)
        for (M = 0; M < 32; M++)
          Z[_ + M] += x[_] * c[M];
      return Jr(i.subarray(32), Z), bt;
    }
    function hi(i, f) {
      var a = e(), n = e(), c = e(), x = e(), w = e(), _ = e(), M = e();
      return z(i[2], h), Pt(i[1], f), zt(c, i[1]), ot(x, c, y), Tt(c, c, i[2]), $t(x, i[2], x), zt(w, x), zt(_, w), ot(M, _, w), ot(a, M, c), ot(a, a, x), De(a, a), ot(a, a, c), ot(a, a, x), ot(a, a, x), ot(i[0], a, x), zt(n, i[0]), ot(n, n, x), Mt(n, c) && ot(i[0], i[0], I), zt(n, i[0]), ot(n, n, x), Mt(n, c) ? -1 : (Vt(i[0]) === f[31] >> 7 && Tt(i[0], g, i[0]), ot(i[3], i[0], i[1]), 0);
    }
    function tn(i, f, a, n) {
      var c, x = new Uint8Array(32), w = new Uint8Array(64), _ = [e(), e(), e(), e()], M = [e(), e(), e(), e()];
      if (a < 64 || hi(M, n))
        return -1;
      for (c = 0; c < a; c++)
        i[c] = f[c];
      for (c = 0; c < 32; c++)
        i[c + 32] = n[c];
      if (Ne(w, i, a), Qr(w), Fr(_, M, w), Ur(M, f.subarray(32)), Ir(_, M), Wr(x, _), a -= 64, L(f, 0, x, 0)) {
        for (c = 0; c < a; c++)
          i[c] = 0;
        return -1;
      }
      for (c = 0; c < a; c++)
        i[c] = f[c + 64];
      return a;
    }
    var en = 32, Or = 24, or = 32, He = 16, ar = 32, Mr = 32, fr = 32, cr = 32, rn = 32, as = Or, li = or, di = He, we = 64, Le = 32, Ge = 64, nn = 32, sn = 64;
    t.lowlevel = {
      crypto_core_hsalsa20: J,
      crypto_stream_xor: Bt,
      crypto_stream: Zt,
      crypto_stream_salsa20_xor: F,
      crypto_stream_salsa20: it,
      crypto_onetimeauth: jt,
      crypto_onetimeauth_verify: Kt,
      crypto_verify_16: k,
      crypto_verify_32: L,
      crypto_secretbox: Qt,
      crypto_secretbox_open: $,
      crypto_scalarmult: te,
      crypto_scalarmult_base: oe,
      crypto_box_beforenm: ae,
      crypto_box_afternm: Wt,
      crypto_box: Ar,
      crypto_box_open: Tr,
      crypto_box_keypair: ir,
      crypto_hash: Ne,
      crypto_sign: os,
      crypto_sign_keypair: Xr,
      crypto_sign_open: tn,
      crypto_secretbox_KEYBYTES: en,
      crypto_secretbox_NONCEBYTES: Or,
      crypto_secretbox_ZEROBYTES: or,
      crypto_secretbox_BOXZEROBYTES: He,
      crypto_scalarmult_BYTES: ar,
      crypto_scalarmult_SCALARBYTES: Mr,
      crypto_box_PUBLICKEYBYTES: fr,
      crypto_box_SECRETKEYBYTES: cr,
      crypto_box_BEFORENMBYTES: rn,
      crypto_box_NONCEBYTES: as,
      crypto_box_ZEROBYTES: li,
      crypto_box_BOXZEROBYTES: di,
      crypto_sign_BYTES: we,
      crypto_sign_PUBLICKEYBYTES: Le,
      crypto_sign_SECRETKEYBYTES: Ge,
      crypto_sign_SEEDBYTES: nn,
      crypto_hash_BYTES: sn,
      gf: e,
      D: y,
      L: kr,
      pack25519: yt,
      unpack25519: Pt,
      M: ot,
      A: $t,
      S: zt,
      Z: Tt,
      pow2523: De,
      add: Ir,
      set25519: z,
      modL: Jr,
      scalarmult: Fr,
      scalarbase: Ur
    };
    function fs(i, f) {
      if (i.length !== en)
        throw new Error("bad key size");
      if (f.length !== Or)
        throw new Error("bad nonce size");
    }
    function gi(i, f) {
      if (i.length !== fr)
        throw new Error("bad public key size");
      if (f.length !== cr)
        throw new Error("bad secret key size");
    }
    function Jt() {
      for (var i = 0; i < arguments.length; i++)
        if (!(arguments[i] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function cs(i) {
      for (var f = 0; f < i.length; f++)
        i[f] = 0;
    }
    t.randomBytes = function(i) {
      var f = new Uint8Array(i);
      return s(f, i), f;
    }, t.secretbox = function(i, f, a) {
      Jt(i, f, a), fs(a, f);
      for (var n = new Uint8Array(or + i.length), c = new Uint8Array(n.length), x = 0; x < i.length; x++)
        n[x + or] = i[x];
      return Qt(c, n, n.length, f, a), c.subarray(He);
    }, t.secretbox.open = function(i, f, a) {
      Jt(i, f, a), fs(a, f);
      for (var n = new Uint8Array(He + i.length), c = new Uint8Array(n.length), x = 0; x < i.length; x++)
        n[x + He] = i[x];
      return n.length < 32 || $(c, n, n.length, f, a) !== 0 ? null : c.subarray(or);
    }, t.secretbox.keyLength = en, t.secretbox.nonceLength = Or, t.secretbox.overheadLength = He, t.scalarMult = function(i, f) {
      if (Jt(i, f), i.length !== Mr)
        throw new Error("bad n size");
      if (f.length !== ar)
        throw new Error("bad p size");
      var a = new Uint8Array(ar);
      return te(a, i, f), a;
    }, t.scalarMult.base = function(i) {
      if (Jt(i), i.length !== Mr)
        throw new Error("bad n size");
      var f = new Uint8Array(ar);
      return oe(f, i), f;
    }, t.scalarMult.scalarLength = Mr, t.scalarMult.groupElementLength = ar, t.box = function(i, f, a, n) {
      var c = t.box.before(a, n);
      return t.secretbox(i, f, c);
    }, t.box.before = function(i, f) {
      Jt(i, f), gi(i, f);
      var a = new Uint8Array(rn);
      return ae(a, i, f), a;
    }, t.box.after = t.secretbox, t.box.open = function(i, f, a, n) {
      var c = t.box.before(a, n);
      return t.secretbox.open(i, f, c);
    }, t.box.open.after = t.secretbox.open, t.box.keyPair = function() {
      var i = new Uint8Array(fr), f = new Uint8Array(cr);
      return ir(i, f), { publicKey: i, secretKey: f };
    }, t.box.keyPair.fromSecretKey = function(i) {
      if (Jt(i), i.length !== cr)
        throw new Error("bad secret key size");
      var f = new Uint8Array(fr);
      return oe(f, i), { publicKey: f, secretKey: new Uint8Array(i) };
    }, t.box.publicKeyLength = fr, t.box.secretKeyLength = cr, t.box.sharedKeyLength = rn, t.box.nonceLength = as, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function(i, f) {
      if (Jt(i, f), f.length !== Ge)
        throw new Error("bad secret key size");
      var a = new Uint8Array(we + i.length);
      return os(a, i, i.length, f), a;
    }, t.sign.open = function(i, f) {
      if (Jt(i, f), f.length !== Le)
        throw new Error("bad public key size");
      var a = new Uint8Array(i.length), n = tn(a, i, i.length, f);
      if (n < 0)
        return null;
      for (var c = new Uint8Array(n), x = 0; x < c.length; x++)
        c[x] = a[x];
      return c;
    }, t.sign.detached = function(i, f) {
      for (var a = t.sign(i, f), n = new Uint8Array(we), c = 0; c < n.length; c++)
        n[c] = a[c];
      return n;
    }, t.sign.detached.verify = function(i, f, a) {
      if (Jt(i, f, a), f.length !== we)
        throw new Error("bad signature size");
      if (a.length !== Le)
        throw new Error("bad public key size");
      var n = new Uint8Array(we + i.length), c = new Uint8Array(we + i.length), x;
      for (x = 0; x < we; x++)
        n[x] = f[x];
      for (x = 0; x < i.length; x++)
        n[x + we] = i[x];
      return tn(c, n, n.length, a) >= 0;
    }, t.sign.keyPair = function() {
      var i = new Uint8Array(Le), f = new Uint8Array(Ge);
      return Xr(i, f), { publicKey: i, secretKey: f };
    }, t.sign.keyPair.fromSecretKey = function(i) {
      if (Jt(i), i.length !== Ge)
        throw new Error("bad secret key size");
      for (var f = new Uint8Array(Le), a = 0; a < f.length; a++)
        f[a] = i[32 + a];
      return { publicKey: f, secretKey: new Uint8Array(i) };
    }, t.sign.keyPair.fromSeed = function(i) {
      if (Jt(i), i.length !== nn)
        throw new Error("bad seed size");
      for (var f = new Uint8Array(Le), a = new Uint8Array(Ge), n = 0; n < 32; n++)
        a[n] = i[n];
      return Xr(f, a, !0), { publicKey: f, secretKey: a };
    }, t.sign.publicKeyLength = Le, t.sign.secretKeyLength = Ge, t.sign.seedLength = nn, t.sign.signatureLength = we, t.hash = function(i) {
      Jt(i);
      var f = new Uint8Array(sn);
      return Ne(f, i, i.length), f;
    }, t.hash.hashLength = sn, t.verify = function(i, f) {
      return Jt(i, f), i.length === 0 || f.length === 0 || i.length !== f.length ? !1 : E(i, 0, f, 0, i.length) === 0;
    }, t.setPRNG = function(i) {
      s = i;
    }, function() {
      var i = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (i && i.getRandomValues) {
        var f = 65536;
        t.setPRNG(function(a, n) {
          var c, x = new Uint8Array(n);
          for (c = 0; c < n; c += f)
            i.getRandomValues(x.subarray(c, c + Math.min(n - c, f)));
          for (c = 0; c < n; c++)
            a[c] = x[c];
          cs(x);
        });
      } else
        typeof aa < "u" && (i = ua, i && i.randomBytes && t.setPRNG(function(a, n) {
          var c, x = i.randomBytes(n);
          for (c = 0; c < n; c++)
            a[c] = x[c];
          cs(x);
        }));
    }();
  })(r.exports ? r.exports : self.nacl = self.nacl || {});
})(Zs);
var ha = Zs.exports;
const la = /* @__PURE__ */ Us(ha), En = 32;
class Ys extends Sr {
  /**
   * Create a new Ed25519PublicKey object
   * @param value ed25519 public key as buffer or base-64 encoded string
   */
  constructor(t) {
    if (super(), typeof t == "string" ? this.data = ge(t) : t instanceof Uint8Array ? this.data = t : this.data = Uint8Array.from(t), this.data.length !== En)
      throw new Error(
        `Invalid public key input. Expected ${En} bytes, got ${this.data.length}`
      );
  }
  /**
   * Checks if two Ed25519 public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the Ed25519 public key
   */
  toRawBytes() {
    return this.data;
  }
  /**
   * Return the Sui address associated with this Ed25519 public key
   */
  flag() {
    return Me.ED25519;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, e) {
    let s;
    if (typeof e == "string") {
      const o = Je(e);
      if (o.signatureScheme !== "ED25519")
        throw new Error("Invalid signature scheme");
      if (!Qe(this.toRawBytes(), o.publicKey))
        throw new Error("Signature does not match public key");
      s = o.signature;
    } else
      s = e;
    return la.sign.detached.verify(t, s, this.toRawBytes());
  }
}
Ys.SIZE = En;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ws = BigInt(0), Zr = BigInt(1), da = BigInt(2);
function Ke(r) {
  return r instanceof Uint8Array || r != null && typeof r == "object" && r.constructor.name === "Uint8Array";
}
function Br(r) {
  if (!Ke(r))
    throw new Error("Uint8Array expected");
}
const ga = /* @__PURE__ */ Array.from({ length: 256 }, (r, t) => t.toString(16).padStart(2, "0"));
function tr(r) {
  Br(r);
  let t = "";
  for (let e = 0; e < r.length; e++)
    t += ga[r[e]];
  return t;
}
function Fs(r) {
  const t = r.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function Jn(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  return BigInt(r === "" ? "0" : `0x${r}`);
}
const be = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function ls(r) {
  if (r >= be._0 && r <= be._9)
    return r - be._0;
  if (r >= be._A && r <= be._F)
    return r - (be._A - 10);
  if (r >= be._a && r <= be._f)
    return r - (be._a - 10);
}
function er(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  const t = r.length, e = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const s = new Uint8Array(e);
  for (let o = 0, u = 0; o < e; o++, u += 2) {
    const g = ls(r.charCodeAt(u)), h = ls(r.charCodeAt(u + 1));
    if (g === void 0 || h === void 0) {
      const l = r[u] + r[u + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + u);
    }
    s[o] = g * 16 + h;
  }
  return s;
}
function Ve(r) {
  return Jn(tr(r));
}
function Qn(r) {
  return Br(r), Jn(tr(Uint8Array.from(r).reverse()));
}
function rr(r, t) {
  return er(r.toString(16).padStart(t * 2, "0"));
}
function ts(r, t) {
  return rr(r, t).reverse();
}
function xa(r) {
  return er(Fs(r));
}
function ce(r, t, e) {
  let s;
  if (typeof t == "string")
    try {
      s = er(t);
    } catch (u) {
      throw new Error(`${r} must be valid hex string, got "${t}". Cause: ${u}`);
    }
  else if (Ke(t))
    s = Uint8Array.from(t);
  else
    throw new Error(`${r} must be hex string or Uint8Array`);
  const o = s.length;
  if (typeof e == "number" && o !== e)
    throw new Error(`${r} expected ${e} bytes, got ${o}`);
  return s;
}
function br(...r) {
  let t = 0;
  for (let s = 0; s < r.length; s++) {
    const o = r[s];
    Br(o), t += o.length;
  }
  const e = new Uint8Array(t);
  for (let s = 0, o = 0; s < r.length; s++) {
    const u = r[s];
    e.set(u, o), o += u.length;
  }
  return e;
}
function ya(r, t) {
  if (r.length !== t.length)
    return !1;
  let e = 0;
  for (let s = 0; s < r.length; s++)
    e |= r[s] ^ t[s];
  return e === 0;
}
function wa(r) {
  if (typeof r != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof r}`);
  return new Uint8Array(new TextEncoder().encode(r));
}
function pa(r) {
  let t;
  for (t = 0; r > Ws; r >>= Zr, t += 1)
    ;
  return t;
}
function ba(r, t) {
  return r >> BigInt(t) & Zr;
}
function ma(r, t, e) {
  return r | (e ? Zr : Ws) << BigInt(t);
}
const es = (r) => (da << BigInt(r - 1)) - Zr, ln = (r) => new Uint8Array(r), ds = (r) => Uint8Array.from(r);
function Xs(r, t, e) {
  if (typeof r != "number" || r < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof e != "function")
    throw new Error("hmacFn must be a function");
  let s = ln(r), o = ln(r), u = 0;
  const g = () => {
    s.fill(1), o.fill(0), u = 0;
  }, h = (...p) => e(o, s, ...p), l = (p = ln()) => {
    o = h(ds([0]), p), s = h(), p.length !== 0 && (o = h(ds([1]), p), s = h());
  }, y = () => {
    if (u++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let p = 0;
    const N = [];
    for (; p < t; ) {
      s = h();
      const I = s.slice();
      N.push(I), p += s.length;
    }
    return br(...N);
  };
  return (p, N) => {
    g(), l(p);
    let I;
    for (; !(I = N(y())); )
      l();
    return g(), I;
  };
}
const Ea = {
  bigint: (r) => typeof r == "bigint",
  function: (r) => typeof r == "function",
  boolean: (r) => typeof r == "boolean",
  string: (r) => typeof r == "string",
  stringOrUint8Array: (r) => typeof r == "string" || Ke(r),
  isSafeInteger: (r) => Number.isSafeInteger(r),
  array: (r) => Array.isArray(r),
  field: (r, t) => t.Fp.isValid(r),
  hash: (r) => typeof r == "function" && Number.isSafeInteger(r.outputLen)
};
function _r(r, t, e = {}) {
  const s = (o, u, g) => {
    const h = Ea[u];
    if (typeof h != "function")
      throw new Error(`Invalid validator "${u}", expected function`);
    const l = r[o];
    if (!(g && l === void 0) && !h(l, r))
      throw new Error(`Invalid param ${String(o)}=${l} (${typeof l}), expected ${u}`);
  };
  for (const [o, u] of Object.entries(t))
    s(o, u, !1);
  for (const [o, u] of Object.entries(e))
    s(o, u, !0);
  return r;
}
const va = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abytes: Br,
  bitGet: ba,
  bitLen: pa,
  bitMask: es,
  bitSet: ma,
  bytesToHex: tr,
  bytesToNumberBE: Ve,
  bytesToNumberLE: Qn,
  concatBytes: br,
  createHmacDrbg: Xs,
  ensureBytes: ce,
  equalBytes: ya,
  hexToBytes: er,
  hexToNumber: Jn,
  isBytes: Ke,
  numberToBytesBE: rr,
  numberToBytesLE: ts,
  numberToHexUnpadded: Fs,
  numberToVarBytesBE: xa,
  utf8ToBytes: wa,
  validateObject: _r
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const qt = BigInt(0), Lt = BigInt(1), ze = BigInt(2), Sa = BigInt(3), vn = BigInt(4), gs = BigInt(5), xs = BigInt(8);
BigInt(9);
BigInt(16);
function Ft(r, t) {
  const e = r % t;
  return e >= qt ? e : t + e;
}
function Ba(r, t, e) {
  if (e <= qt || t < qt)
    throw new Error("Expected power/modulo > 0");
  if (e === Lt)
    return qt;
  let s = Lt;
  for (; t > qt; )
    t & Lt && (s = s * r % e), r = r * r % e, t >>= Lt;
  return s;
}
function ee(r, t, e) {
  let s = r;
  for (; t-- > qt; )
    s *= s, s %= e;
  return s;
}
function Sn(r, t) {
  if (r === qt || t <= qt)
    throw new Error(`invert: expected positive integers, got n=${r} mod=${t}`);
  let e = Ft(r, t), s = t, o = qt, u = Lt;
  for (; e !== qt; ) {
    const h = s / e, l = s % e, y = o - u * h;
    s = e, e = l, o = u, u = y;
  }
  if (s !== Lt)
    throw new Error("invert: does not exist");
  return Ft(o, t);
}
function _a(r) {
  const t = (r - Lt) / ze;
  let e, s, o;
  for (e = r - Lt, s = 0; e % ze === qt; e /= ze, s++)
    ;
  for (o = ze; o < r && Ba(o, t, r) !== r - Lt; o++)
    ;
  if (s === 1) {
    const g = (r + Lt) / vn;
    return function(l, y) {
      const S = l.pow(y, g);
      if (!l.eql(l.sqr(S), y))
        throw new Error("Cannot find square root");
      return S;
    };
  }
  const u = (e + Lt) / ze;
  return function(h, l) {
    if (h.pow(l, t) === h.neg(h.ONE))
      throw new Error("Cannot find square root");
    let y = s, S = h.pow(h.mul(h.ONE, o), e), p = h.pow(l, u), N = h.pow(l, e);
    for (; !h.eql(N, h.ONE); ) {
      if (h.eql(N, h.ZERO))
        return h.ZERO;
      let I = 1;
      for (let E = h.sqr(N); I < y && !h.eql(E, h.ONE); I++)
        E = h.sqr(E);
      const U = h.pow(S, Lt << BigInt(y - I - 1));
      S = h.sqr(U), p = h.mul(p, U), N = h.mul(N, S), y = I;
    }
    return p;
  };
}
function Aa(r) {
  if (r % vn === Sa) {
    const t = (r + Lt) / vn;
    return function(s, o) {
      const u = s.pow(o, t);
      if (!s.eql(s.sqr(u), o))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  if (r % xs === gs) {
    const t = (r - gs) / xs;
    return function(s, o) {
      const u = s.mul(o, ze), g = s.pow(u, t), h = s.mul(o, g), l = s.mul(s.mul(h, ze), g), y = s.mul(h, s.sub(l, s.ONE));
      if (!s.eql(s.sqr(y), o))
        throw new Error("Cannot find square root");
      return y;
    };
  }
  return _a(r);
}
const Ta = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Ia(r) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, e = Ta.reduce((s, o) => (s[o] = "function", s), t);
  return _r(r, e);
}
function Ua(r, t, e) {
  if (e < qt)
    throw new Error("Expected power > 0");
  if (e === qt)
    return r.ONE;
  if (e === Lt)
    return t;
  let s = r.ONE, o = t;
  for (; e > qt; )
    e & Lt && (s = r.mul(s, o)), o = r.sqr(o), e >>= Lt;
  return s;
}
function ka(r, t) {
  const e = new Array(t.length), s = t.reduce((u, g, h) => r.is0(g) ? u : (e[h] = u, r.mul(u, g)), r.ONE), o = r.inv(s);
  return t.reduceRight((u, g, h) => r.is0(g) ? u : (e[h] = r.mul(u, e[h]), r.mul(u, g)), o), e;
}
function Js(r, t) {
  const e = t !== void 0 ? t : r.toString(2).length, s = Math.ceil(e / 8);
  return { nBitLength: e, nByteLength: s };
}
function Qs(r, t, e = !1, s = {}) {
  if (r <= qt)
    throw new Error(`Expected Field ORDER > 0, got ${r}`);
  const { nBitLength: o, nByteLength: u } = Js(r, t);
  if (u > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const g = Aa(r), h = Object.freeze({
    ORDER: r,
    BITS: o,
    BYTES: u,
    MASK: es(o),
    ZERO: qt,
    ONE: Lt,
    create: (l) => Ft(l, r),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof l}`);
      return qt <= l && l < r;
    },
    is0: (l) => l === qt,
    isOdd: (l) => (l & Lt) === Lt,
    neg: (l) => Ft(-l, r),
    eql: (l, y) => l === y,
    sqr: (l) => Ft(l * l, r),
    add: (l, y) => Ft(l + y, r),
    sub: (l, y) => Ft(l - y, r),
    mul: (l, y) => Ft(l * y, r),
    pow: (l, y) => Ua(h, l, y),
    div: (l, y) => Ft(l * Sn(y, r), r),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, y) => l + y,
    subN: (l, y) => l - y,
    mulN: (l, y) => l * y,
    inv: (l) => Sn(l, r),
    sqrt: s.sqrt || ((l) => g(h, l)),
    invertBatch: (l) => ka(h, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, y, S) => S ? y : l,
    toBytes: (l) => e ? ts(l, u) : rr(l, u),
    fromBytes: (l) => {
      if (l.length !== u)
        throw new Error(`Fp.fromBytes: expected ${u}, got ${l.length}`);
      return e ? Qn(l) : Ve(l);
    }
  });
  return Object.freeze(h);
}
function ti(r) {
  if (typeof r != "bigint")
    throw new Error("field order must be bigint");
  const t = r.toString(2).length;
  return Math.ceil(t / 8);
}
function ei(r) {
  const t = ti(r);
  return t + Math.ceil(t / 2);
}
function Oa(r, t, e = !1) {
  const s = r.length, o = ti(t), u = ei(t);
  if (s < 16 || s < u || s > 1024)
    throw new Error(`expected ${u}-1024 bytes of input, got ${s}`);
  const g = e ? Ve(r) : Qn(r), h = Ft(g, t - Lt) + Lt;
  return e ? ts(h, o) : rr(h, o);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ma = BigInt(0), dn = BigInt(1);
function Na(r, t) {
  const e = (o, u) => {
    const g = u.negate();
    return o ? g : u;
  }, s = (o) => {
    const u = Math.ceil(t / o) + 1, g = 2 ** (o - 1);
    return { windows: u, windowSize: g };
  };
  return {
    constTimeNegate: e,
    // non-const time multiplication ladder
    unsafeLadder(o, u) {
      let g = r.ZERO, h = o;
      for (; u > Ma; )
        u & dn && (g = g.add(h)), h = h.double(), u >>= dn;
      return g;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(o, u) {
      const { windows: g, windowSize: h } = s(u), l = [];
      let y = o, S = y;
      for (let p = 0; p < g; p++) {
        S = y, l.push(S);
        for (let N = 1; N < h; N++)
          S = S.add(y), l.push(S);
        y = S.double();
      }
      return l;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(o, u, g) {
      const { windows: h, windowSize: l } = s(o);
      let y = r.ZERO, S = r.BASE;
      const p = BigInt(2 ** o - 1), N = 2 ** o, I = BigInt(o);
      for (let U = 0; U < h; U++) {
        const E = U * l;
        let k = Number(g & p);
        g >>= I, k > l && (k -= N, g += dn);
        const L = E, H = E + Math.abs(k) - 1, W = U % 2 !== 0, nt = k < 0;
        k === 0 ? S = S.add(e(W, u[L])) : y = y.add(e(nt, u[H]));
      }
      return { p: y, f: S };
    },
    wNAFCached(o, u, g, h) {
      const l = o._WINDOW_SIZE || 1;
      let y = u.get(o);
      return y || (y = this.precomputeWindow(o, l), l !== 1 && u.set(o, h(y))), this.wNAF(l, y, g);
    }
  };
}
function ri(r) {
  return Ia(r.Fp), _r(r, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...Js(r.n, r.nBitLength),
    ...r,
    p: r.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function La(r) {
  const t = ri(r);
  _r(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: e, Fp: s, a: o } = t;
  if (e) {
    if (!s.eql(o, s.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof e != "object" || typeof e.beta != "bigint" || typeof e.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: $a, hexToBytes: Ca } = va, je = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(r) {
    const { Err: t } = je;
    if (r.length < 2 || r[0] !== 2)
      throw new t("Invalid signature integer tag");
    const e = r[1], s = r.subarray(2, e + 2);
    if (!e || s.length !== e)
      throw new t("Invalid signature integer: wrong length");
    if (s[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (s[0] === 0 && !(s[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: $a(s), l: r.subarray(e + 2) };
  },
  toSig(r) {
    const { Err: t } = je, e = typeof r == "string" ? Ca(r) : r;
    Br(e);
    let s = e.length;
    if (s < 2 || e[0] != 48)
      throw new t("Invalid signature tag");
    if (e[1] !== s - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: o, l: u } = je._parseInt(e.subarray(2)), { d: g, l: h } = je._parseInt(u);
    if (h.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: o, s: g };
  },
  hexFromSig(r) {
    const t = (y) => Number.parseInt(y[0], 16) & 8 ? "00" + y : y, e = (y) => {
      const S = y.toString(16);
      return S.length & 1 ? `0${S}` : S;
    }, s = t(e(r.s)), o = t(e(r.r)), u = s.length / 2, g = o.length / 2, h = e(u), l = e(g);
    return `30${e(g + u + 4)}02${l}${o}02${h}${s}`;
  }
}, ve = BigInt(0), re = BigInt(1);
BigInt(2);
const ys = BigInt(3);
BigInt(4);
function Ra(r) {
  const t = La(r), { Fp: e } = t, s = t.toBytes || ((U, E, k) => {
    const L = E.toAffine();
    return br(Uint8Array.from([4]), e.toBytes(L.x), e.toBytes(L.y));
  }), o = t.fromBytes || ((U) => {
    const E = U.subarray(1), k = e.fromBytes(E.subarray(0, e.BYTES)), L = e.fromBytes(E.subarray(e.BYTES, 2 * e.BYTES));
    return { x: k, y: L };
  });
  function u(U) {
    const { a: E, b: k } = t, L = e.sqr(U), H = e.mul(L, U);
    return e.add(e.add(H, e.mul(U, E)), k);
  }
  if (!e.eql(e.sqr(t.Gy), u(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function g(U) {
    return typeof U == "bigint" && ve < U && U < t.n;
  }
  function h(U) {
    if (!g(U))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function l(U) {
    const { allowedPrivateKeyLengths: E, nByteLength: k, wrapPrivateKey: L, n: H } = t;
    if (E && typeof U != "bigint") {
      if (Ke(U) && (U = tr(U)), typeof U != "string" || !E.includes(U.length))
        throw new Error("Invalid key");
      U = U.padStart(k * 2, "0");
    }
    let W;
    try {
      W = typeof U == "bigint" ? U : Ve(ce("private key", U, k));
    } catch {
      throw new Error(`private key must be ${k} bytes, hex or bigint, not ${typeof U}`);
    }
    return L && (W = Ft(W, H)), h(W), W;
  }
  const y = /* @__PURE__ */ new Map();
  function S(U) {
    if (!(U instanceof p))
      throw new Error("ProjectivePoint expected");
  }
  class p {
    constructor(E, k, L) {
      if (this.px = E, this.py = k, this.pz = L, E == null || !e.isValid(E))
        throw new Error("x required");
      if (k == null || !e.isValid(k))
        throw new Error("y required");
      if (L == null || !e.isValid(L))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(E) {
      const { x: k, y: L } = E || {};
      if (!E || !e.isValid(k) || !e.isValid(L))
        throw new Error("invalid affine point");
      if (E instanceof p)
        throw new Error("projective point not allowed");
      const H = (W) => e.eql(W, e.ZERO);
      return H(k) && H(L) ? p.ZERO : new p(k, L, e.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(E) {
      const k = e.invertBatch(E.map((L) => L.pz));
      return E.map((L, H) => L.toAffine(k[H])).map(p.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(E) {
      const k = p.fromAffine(o(ce("pointHex", E)));
      return k.assertValidity(), k;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(E) {
      return p.BASE.multiply(l(E));
    }
    // "Private method", don't use it directly
    _setWindowSize(E) {
      this._WINDOW_SIZE = E, y.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !e.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: E, y: k } = this.toAffine();
      if (!e.isValid(E) || !e.isValid(k))
        throw new Error("bad point: x or y not FE");
      const L = e.sqr(k), H = u(E);
      if (!e.eql(L, H))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: E } = this.toAffine();
      if (e.isOdd)
        return !e.isOdd(E);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(E) {
      S(E);
      const { px: k, py: L, pz: H } = this, { px: W, py: nt, pz: J } = E, j = e.eql(e.mul(k, J), e.mul(W, H)), F = e.eql(e.mul(L, J), e.mul(nt, H));
      return j && F;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new p(this.px, e.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: E, b: k } = t, L = e.mul(k, ys), { px: H, py: W, pz: nt } = this;
      let J = e.ZERO, j = e.ZERO, F = e.ZERO, it = e.mul(H, H), Zt = e.mul(W, W), Bt = e.mul(nt, nt), xt = e.mul(H, W);
      return xt = e.add(xt, xt), F = e.mul(H, nt), F = e.add(F, F), J = e.mul(E, F), j = e.mul(L, Bt), j = e.add(J, j), J = e.sub(Zt, j), j = e.add(Zt, j), j = e.mul(J, j), J = e.mul(xt, J), F = e.mul(L, F), Bt = e.mul(E, Bt), xt = e.sub(it, Bt), xt = e.mul(E, xt), xt = e.add(xt, F), F = e.add(it, it), it = e.add(F, it), it = e.add(it, Bt), it = e.mul(it, xt), j = e.add(j, it), Bt = e.mul(W, nt), Bt = e.add(Bt, Bt), it = e.mul(Bt, xt), J = e.sub(J, it), F = e.mul(Bt, Zt), F = e.add(F, F), F = e.add(F, F), new p(J, j, F);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(E) {
      S(E);
      const { px: k, py: L, pz: H } = this, { px: W, py: nt, pz: J } = E;
      let j = e.ZERO, F = e.ZERO, it = e.ZERO;
      const Zt = t.a, Bt = e.mul(t.b, ys);
      let xt = e.mul(k, W), jt = e.mul(L, nt), Kt = e.mul(H, J), Qt = e.add(k, L), $ = e.add(W, nt);
      Qt = e.mul(Qt, $), $ = e.add(xt, jt), Qt = e.sub(Qt, $), $ = e.add(k, H);
      let z = e.add(W, J);
      return $ = e.mul($, z), z = e.add(xt, Kt), $ = e.sub($, z), z = e.add(L, H), j = e.add(nt, J), z = e.mul(z, j), j = e.add(jt, Kt), z = e.sub(z, j), it = e.mul(Zt, $), j = e.mul(Bt, Kt), it = e.add(j, it), j = e.sub(jt, it), it = e.add(jt, it), F = e.mul(j, it), jt = e.add(xt, xt), jt = e.add(jt, xt), Kt = e.mul(Zt, Kt), $ = e.mul(Bt, $), jt = e.add(jt, Kt), Kt = e.sub(xt, Kt), Kt = e.mul(Zt, Kt), $ = e.add($, Kt), xt = e.mul(jt, $), F = e.add(F, xt), xt = e.mul(z, $), j = e.mul(Qt, j), j = e.sub(j, xt), xt = e.mul(Qt, jt), it = e.mul(z, it), it = e.add(it, xt), new p(j, F, it);
    }
    subtract(E) {
      return this.add(E.negate());
    }
    is0() {
      return this.equals(p.ZERO);
    }
    wNAF(E) {
      return I.wNAFCached(this, y, E, (k) => {
        const L = e.invertBatch(k.map((H) => H.pz));
        return k.map((H, W) => H.toAffine(L[W])).map(p.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(E) {
      const k = p.ZERO;
      if (E === ve)
        return k;
      if (h(E), E === re)
        return this;
      const { endo: L } = t;
      if (!L)
        return I.unsafeLadder(this, E);
      let { k1neg: H, k1: W, k2neg: nt, k2: J } = L.splitScalar(E), j = k, F = k, it = this;
      for (; W > ve || J > ve; )
        W & re && (j = j.add(it)), J & re && (F = F.add(it)), it = it.double(), W >>= re, J >>= re;
      return H && (j = j.negate()), nt && (F = F.negate()), F = new p(e.mul(F.px, L.beta), F.py, F.pz), j.add(F);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(E) {
      h(E);
      let k = E, L, H;
      const { endo: W } = t;
      if (W) {
        const { k1neg: nt, k1: J, k2neg: j, k2: F } = W.splitScalar(k);
        let { p: it, f: Zt } = this.wNAF(J), { p: Bt, f: xt } = this.wNAF(F);
        it = I.constTimeNegate(nt, it), Bt = I.constTimeNegate(j, Bt), Bt = new p(e.mul(Bt.px, W.beta), Bt.py, Bt.pz), L = it.add(Bt), H = Zt.add(xt);
      } else {
        const { p: nt, f: J } = this.wNAF(k);
        L = nt, H = J;
      }
      return p.normalizeZ([L, H])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(E, k, L) {
      const H = p.BASE, W = (J, j) => j === ve || j === re || !J.equals(H) ? J.multiplyUnsafe(j) : J.multiply(j), nt = W(this, k).add(W(E, L));
      return nt.is0() ? void 0 : nt;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(E) {
      const { px: k, py: L, pz: H } = this, W = this.is0();
      E == null && (E = W ? e.ONE : e.inv(H));
      const nt = e.mul(k, E), J = e.mul(L, E), j = e.mul(H, E);
      if (W)
        return { x: e.ZERO, y: e.ZERO };
      if (!e.eql(j, e.ONE))
        throw new Error("invZ was invalid");
      return { x: nt, y: J };
    }
    isTorsionFree() {
      const { h: E, isTorsionFree: k } = t;
      if (E === re)
        return !0;
      if (k)
        return k(p, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: E, clearCofactor: k } = t;
      return E === re ? this : k ? k(p, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(E = !0) {
      return this.assertValidity(), s(p, this, E);
    }
    toHex(E = !0) {
      return tr(this.toRawBytes(E));
    }
  }
  p.BASE = new p(t.Gx, t.Gy, e.ONE), p.ZERO = new p(e.ZERO, e.ONE, e.ZERO);
  const N = t.nBitLength, I = Na(p, t.endo ? Math.ceil(N / 2) : N);
  return {
    CURVE: t,
    ProjectivePoint: p,
    normPrivateKeyToScalar: l,
    weierstrassEquation: u,
    isWithinCurveOrder: g
  };
}
function Pa(r) {
  const t = ri(r);
  return _r(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function za(r) {
  const t = Pa(r), { Fp: e, n: s } = t, o = e.BYTES + 1, u = 2 * e.BYTES + 1;
  function g($) {
    return ve < $ && $ < e.ORDER;
  }
  function h($) {
    return Ft($, s);
  }
  function l($) {
    return Sn($, s);
  }
  const { ProjectivePoint: y, normPrivateKeyToScalar: S, weierstrassEquation: p, isWithinCurveOrder: N } = Ra({
    ...t,
    toBytes($, z, ht) {
      const vt = z.toAffine(), yt = e.toBytes(vt.x), Mt = br;
      return ht ? Mt(Uint8Array.from([z.hasEvenY() ? 2 : 3]), yt) : Mt(Uint8Array.from([4]), yt, e.toBytes(vt.y));
    },
    fromBytes($) {
      const z = $.length, ht = $[0], vt = $.subarray(1);
      if (z === o && (ht === 2 || ht === 3)) {
        const yt = Ve(vt);
        if (!g(yt))
          throw new Error("Point is not on curve");
        const Mt = p(yt);
        let Vt;
        try {
          Vt = e.sqrt(Mt);
        } catch (Tt) {
          const ot = Tt instanceof Error ? ": " + Tt.message : "";
          throw new Error("Point is not on curve" + ot);
        }
        const Pt = (Vt & re) === re;
        return (ht & 1) === 1 !== Pt && (Vt = e.neg(Vt)), { x: yt, y: Vt };
      } else if (z === u && ht === 4) {
        const yt = e.fromBytes(vt.subarray(0, e.BYTES)), Mt = e.fromBytes(vt.subarray(e.BYTES, 2 * e.BYTES));
        return { x: yt, y: Mt };
      } else
        throw new Error(`Point of length ${z} was invalid. Expected ${o} compressed bytes or ${u} uncompressed bytes`);
    }
  }), I = ($) => tr(rr($, t.nByteLength));
  function U($) {
    const z = s >> re;
    return $ > z;
  }
  function E($) {
    return U($) ? h(-$) : $;
  }
  const k = ($, z, ht) => Ve($.slice(z, ht));
  class L {
    constructor(z, ht, vt) {
      this.r = z, this.s = ht, this.recovery = vt, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(z) {
      const ht = t.nByteLength;
      return z = ce("compactSignature", z, ht * 2), new L(k(z, 0, ht), k(z, ht, 2 * ht));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(z) {
      const { r: ht, s: vt } = je.toSig(ce("DER", z));
      return new L(ht, vt);
    }
    assertValidity() {
      if (!N(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!N(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(z) {
      return new L(this.r, this.s, z);
    }
    recoverPublicKey(z) {
      const { r: ht, s: vt, recovery: yt } = this, Mt = F(ce("msgHash", z));
      if (yt == null || ![0, 1, 2, 3].includes(yt))
        throw new Error("recovery id invalid");
      const Vt = yt === 2 || yt === 3 ? ht + t.n : ht;
      if (Vt >= e.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Pt = yt & 1 ? "03" : "02", $t = y.fromHex(Pt + I(Vt)), Tt = l(Vt), ot = h(-Mt * Tt), zt = h(vt * Tt), ie = y.BASE.multiplyAndAddUnsafe($t, ot, zt);
      if (!ie)
        throw new Error("point at infinify");
      return ie.assertValidity(), ie;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return U(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new L(this.r, h(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return er(this.toDERHex());
    }
    toDERHex() {
      return je.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return er(this.toCompactHex());
    }
    toCompactHex() {
      return I(this.r) + I(this.s);
    }
  }
  const H = {
    isValidPrivateKey($) {
      try {
        return S($), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: S,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const $ = ei(t.n);
      return Oa(t.randomBytes($), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute($ = 8, z = y.BASE) {
      return z._setWindowSize($), z.multiply(BigInt(3)), z;
    }
  };
  function W($, z = !0) {
    return y.fromPrivateKey($).toRawBytes(z);
  }
  function nt($) {
    const z = Ke($), ht = typeof $ == "string", vt = (z || ht) && $.length;
    return z ? vt === o || vt === u : ht ? vt === 2 * o || vt === 2 * u : $ instanceof y;
  }
  function J($, z, ht = !0) {
    if (nt($))
      throw new Error("first arg must be private key");
    if (!nt(z))
      throw new Error("second arg must be public key");
    return y.fromHex(z).multiply(S($)).toRawBytes(ht);
  }
  const j = t.bits2int || function($) {
    const z = Ve($), ht = $.length * 8 - t.nBitLength;
    return ht > 0 ? z >> BigInt(ht) : z;
  }, F = t.bits2int_modN || function($) {
    return h(j($));
  }, it = es(t.nBitLength);
  function Zt($) {
    if (typeof $ != "bigint")
      throw new Error("bigint expected");
    if (!(ve <= $ && $ < it))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return rr($, t.nByteLength);
  }
  function Bt($, z, ht = xt) {
    if (["recovered", "canonical"].some((te) => te in ht))
      throw new Error("sign() legacy options not supported");
    const { hash: vt, randomBytes: yt } = t;
    let { lowS: Mt, prehash: Vt, extraEntropy: Pt } = ht;
    Mt == null && (Mt = !0), $ = ce("msgHash", $), Vt && ($ = ce("prehashed msgHash", vt($)));
    const $t = F($), Tt = S(z), ot = [Zt(Tt), Zt($t)];
    if (Pt != null && Pt !== !1) {
      const te = Pt === !0 ? yt(e.BYTES) : Pt;
      ot.push(ce("extraEntropy", te));
    }
    const zt = br(...ot), ie = $t;
    function De(te) {
      const oe = j(te);
      if (!N(oe))
        return;
      const ir = l(oe), ae = y.BASE.multiply(oe).toAffine(), Wt = h(ae.x);
      if (Wt === ve)
        return;
      const Se = h(ir * h(ie + Wt * Tt));
      if (Se === ve)
        return;
      let Ar = (ae.x === Wt ? 0 : 2) | Number(ae.y & re), Tr = Se;
      return Mt && U(Se) && (Tr = E(Se), Ar ^= 1), new L(Wt, Tr, Ar);
    }
    return { seed: zt, k2sig: De };
  }
  const xt = { lowS: t.lowS, prehash: !1 }, jt = { lowS: t.lowS, prehash: !1 };
  function Kt($, z, ht = xt) {
    const { seed: vt, k2sig: yt } = Bt($, z, ht), Mt = t;
    return Xs(Mt.hash.outputLen, Mt.nByteLength, Mt.hmac)(vt, yt);
  }
  y.BASE._setWindowSize(8);
  function Qt($, z, ht, vt = jt) {
    var ae;
    const yt = $;
    if (z = ce("msgHash", z), ht = ce("publicKey", ht), "strict" in vt)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Mt, prehash: Vt } = vt;
    let Pt, $t;
    try {
      if (typeof yt == "string" || Ke(yt))
        try {
          Pt = L.fromDER(yt);
        } catch (Wt) {
          if (!(Wt instanceof je.Err))
            throw Wt;
          Pt = L.fromCompact(yt);
        }
      else if (typeof yt == "object" && typeof yt.r == "bigint" && typeof yt.s == "bigint") {
        const { r: Wt, s: Se } = yt;
        Pt = new L(Wt, Se);
      } else
        throw new Error("PARSE");
      $t = y.fromHex(ht);
    } catch (Wt) {
      if (Wt.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Mt && Pt.hasHighS())
      return !1;
    Vt && (z = t.hash(z));
    const { r: Tt, s: ot } = Pt, zt = F(z), ie = l(ot), De = h(zt * ie), te = h(Tt * ie), oe = (ae = y.BASE.multiplyAndAddUnsafe($t, De, te)) == null ? void 0 : ae.toAffine();
    return oe ? h(oe.x) === Tt : !1;
  }
  return {
    CURVE: t,
    getPublicKey: W,
    getSharedSecret: J,
    sign: Kt,
    verify: Qt,
    ProjectivePoint: y,
    Signature: L,
    utils: H
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function qa(r) {
  return {
    hash: r,
    hmac: (t, ...e) => Gs(r, t, co(...e)),
    randomBytes: lo
  };
}
function ni(r, t) {
  const e = (s) => za({ ...r, ...qa(s) });
  return Object.freeze({ ...e(t), create: e });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const si = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), ws = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), ja = BigInt(1), Bn = BigInt(2), ps = (r, t) => (r + t / Bn) / t;
function Va(r) {
  const t = si, e = BigInt(3), s = BigInt(6), o = BigInt(11), u = BigInt(22), g = BigInt(23), h = BigInt(44), l = BigInt(88), y = r * r * r % t, S = y * y * r % t, p = ee(S, e, t) * S % t, N = ee(p, e, t) * S % t, I = ee(N, Bn, t) * y % t, U = ee(I, o, t) * I % t, E = ee(U, u, t) * U % t, k = ee(E, h, t) * E % t, L = ee(k, l, t) * k % t, H = ee(L, h, t) * E % t, W = ee(H, e, t) * S % t, nt = ee(W, g, t) * U % t, J = ee(nt, s, t) * y % t, j = ee(J, Bn, t);
  if (!_n.eql(_n.sqr(j), r))
    throw new Error("Cannot find square root");
  return j;
}
const _n = Qs(si, void 0, void 0, { sqrt: Va }), An = ni({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp: _n,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: ws,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (r) => {
      const t = ws, e = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), s = -ja * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), o = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), u = e, g = BigInt("0x100000000000000000000000000000000"), h = ps(u * r, t), l = ps(-s * r, t);
      let y = Ft(r - h * e - l * o, t), S = Ft(-h * s - l * u, t);
      const p = y > g, N = S > g;
      if (p && (y = t - y), N && (S = t - S), y > g || S > g)
        throw new Error("splitScalar: Endomorphism failed, k=" + r);
      return { k1neg: p, k1: y, k2neg: N, k2: S };
    }
  }
}, Gr);
BigInt(0);
An.ProjectivePoint;
const Tn = 33;
class ii extends Sr {
  /**
   * Create a new Secp256k1PublicKey object
   * @param value secp256k1 public key as buffer or base-64 encoded string
   */
  constructor(t) {
    if (super(), typeof t == "string" ? this.data = ge(t) : t instanceof Uint8Array ? this.data = t : this.data = Uint8Array.from(t), this.data.length !== Tn)
      throw new Error(
        `Invalid public key input. Expected ${Tn} bytes, got ${this.data.length}`
      );
  }
  /**
   * Checks if two Secp256k1 public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the Secp256k1 public key
   */
  toRawBytes() {
    return this.data;
  }
  /**
   * Return the Sui address associated with this Secp256k1 public key
   */
  flag() {
    return Me.Secp256k1;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, e) {
    let s;
    if (typeof e == "string") {
      const o = Je(e);
      if (o.signatureScheme !== "Secp256k1")
        throw new Error("Invalid signature scheme");
      if (!Qe(this.toRawBytes(), o.publicKey))
        throw new Error("Signature does not match public key");
      s = o.signature;
    } else
      s = e;
    return An.verify(
      An.Signature.fromCompact(s),
      Gr(t),
      this.toRawBytes()
    );
  }
}
ii.SIZE = Tn;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const oi = Qs(BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff")), Ka = oi.create(BigInt("-3")), Da = BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"), Ha = ni({
  a: Ka,
  // Equation params: a, b
  b: Da,
  Fp: oi,
  // Field: 2n**224n * (2n**32n-1n) + 2n**192n + 2n**96n-1n
  // Curve order, total count of valid points in the field
  n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"),
  // Base (generator) point (x, y)
  Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"),
  Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),
  h: BigInt(1),
  lowS: !1
}, Gr), bs = Ha, In = 33;
class ai extends Sr {
  /**
   * Create a new Secp256r1PublicKey object
   * @param value secp256r1 public key as buffer or base-64 encoded string
   */
  constructor(t) {
    if (super(), typeof t == "string" ? this.data = ge(t) : t instanceof Uint8Array ? this.data = t : this.data = Uint8Array.from(t), this.data.length !== In)
      throw new Error(
        `Invalid public key input. Expected ${In} bytes, got ${this.data.length}`
      );
  }
  /**
   * Checks if two Secp256r1 public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the Secp256r1 public key
   */
  toRawBytes() {
    return this.data;
  }
  /**
   * Return the Sui address associated with this Secp256r1 public key
   */
  flag() {
    return Me.Secp256r1;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, e) {
    let s;
    if (typeof e == "string") {
      const o = Je(e);
      if (o.signatureScheme !== "Secp256r1")
        throw new Error("Invalid signature scheme");
      if (!Qe(this.toRawBytes(), o.publicKey))
        throw new Error("Signature does not match public key");
      s = o.signature;
    } else
      s = e;
    return bs.verify(
      bs.Signature.fromCompact(s),
      Gr(t),
      this.toRawBytes()
    );
  }
}
ai.SIZE = In;
class fi extends Sr {
  /**
   * Create a new ZkLoginPublicIdentifier object
   * @param value zkLogin public identifier as buffer or base-64 encoded string
   */
  constructor(t) {
    super(), typeof t == "string" ? this.data = ge(t) : t instanceof Uint8Array ? this.data = t : this.data = Uint8Array.from(t);
  }
  /**
   * Checks if two zkLogin public identifiers are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the zkLogin public identifier
   */
  toRawBytes() {
    return this.data;
  }
  /**
   * Return the Sui address associated with this ZkLogin public identifier
   */
  flag() {
    return Me.ZkLogin;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, e) {
    throw Error("does not support");
  }
}
function Ga(r, t) {
  const e = Ds(r, 32), s = new TextEncoder().encode(t), o = new Uint8Array(1 + s.length + e.length);
  return o.set([s.length], 0), o.set(s, 1), o.set(e, 1 + s.length), new fi(o);
}
const ur = 10, ms = 1;
class Yr extends Sr {
  /**
   * Create a new MultiSigPublicKey object
   */
  constructor(t) {
    if (super(), typeof t == "string" ? (this.rawBytes = ge(t), this.multisigPublicKey = ye.MultiSigPublicKey.parse(this.rawBytes)) : t instanceof Uint8Array ? (this.rawBytes = t, this.multisigPublicKey = ye.MultiSigPublicKey.parse(this.rawBytes)) : (this.multisigPublicKey = t, this.rawBytes = ye.MultiSigPublicKey.serialize(t).toBytes()), this.multisigPublicKey.threshold < 1)
      throw new Error("Invalid threshold");
    const e = /* @__PURE__ */ new Set();
    this.publicKeys = this.multisigPublicKey.pk_map.map(({ pubKey: o, weight: u }) => {
      const [g, h] = Object.entries(o)[0], l = Uint8Array.from(h).toString();
      if (e.has(l))
        throw new Error("Multisig does not support duplicate public keys");
      if (e.add(l), u < 1)
        throw new Error("Invalid weight");
      return {
        publicKey: rs(g, Uint8Array.from(h)),
        weight: u
      };
    });
    const s = this.publicKeys.reduce((o, { weight: u }) => o + u, 0);
    if (this.multisigPublicKey.threshold > s)
      throw new Error("Unreachable threshold");
    if (this.publicKeys.length > ur)
      throw new Error(`Max number of signers in a multisig is ${ur}`);
    if (this.publicKeys.length < ms)
      throw new Error(`Min number of signers in a multisig is ${ms}`);
  }
  /**
   * 	A static method to create a new MultiSig publickey instance from a set of public keys and their associated weights pairs and threshold.
   */
  static fromPublicKeys({
    threshold: t,
    publicKeys: e
  }) {
    return new Yr({
      pk_map: e.map(({ publicKey: s, weight: o }) => ({
        pubKey: { [Ks[s.flag()]]: Array.from(s.toRawBytes()) },
        weight: o
      })),
      threshold: t
    });
  }
  /**
   * Checks if two MultiSig public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the MultiSig public key
   */
  toRawBytes() {
    return this.rawBytes;
  }
  getPublicKeys() {
    return this.publicKeys;
  }
  /**
   * Return the Sui address associated with this MultiSig public key
   */
  toSuiAddress() {
    const t = 1 + 65 * ur + 2, e = new Uint8Array(t);
    e.set([Me.MultiSig]), e.set(ye.u16().serialize(this.multisigPublicKey.threshold).toBytes(), 1);
    let s = 3;
    for (const { publicKey: o, weight: u } of this.publicKeys) {
      const g = o.toSuiBytes();
      e.set(g, s), s += g.length, e.set([u], s++);
    }
    return Xt(Fn(Kr(e.slice(0, s), { dkLen: 32 })));
  }
  /**
   * Return the Sui address associated with this MultiSig public key
   */
  flag() {
    return Me.MultiSig;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, e) {
    const { signatureScheme: s, multisig: o } = Je(e);
    if (s !== "MultiSig")
      throw new Error("Invalid signature scheme");
    let u = 0;
    if (!Qe(
      ye.MultiSigPublicKey.serialize(this.multisigPublicKey).toBytes(),
      ye.MultiSigPublicKey.serialize(o.multisig_pk).toBytes()
    ))
      return !1;
    for (const { publicKey: g, weight: h, signature: l } of Za(o)) {
      if (!await g.verify(t, l))
        return !1;
      u += h;
    }
    return u >= this.multisigPublicKey.threshold;
  }
  /**
   * Combines multiple partial signatures into a single multisig, ensuring that each public key signs only once
   * and that all the public keys involved are known and valid, and then serializes multisig into the standard format
   */
  combinePartialSignatures(t) {
    var h, l;
    if (t.length > ur)
      throw new Error(`Max number of signatures in a multisig is ${ur}`);
    let e = 0;
    const s = new Array(t.length);
    for (let y = 0; y < t.length; y++) {
      let S = Je(t[y]);
      if (S.signatureScheme === "MultiSig")
        throw new Error("MultiSig is not supported inside MultiSig");
      let p;
      S.signatureScheme === "ZkLogin" ? p = Ga(
        (h = S.zkLogin) == null ? void 0 : h.addressSeed,
        (l = S.zkLogin) == null ? void 0 : l.iss
      ).toRawBytes() : p = S.publicKey, s[y] = {
        [S.signatureScheme]: Array.from(S.signature.map((I) => Number(I)))
      };
      let N;
      for (let I = 0; I < this.publicKeys.length; I++)
        if (Qe(p, this.publicKeys[I].publicKey.toRawBytes())) {
          if (e & 1 << I)
            throw new Error("Received multiple signatures from the same public key");
          N = I;
          break;
        }
      if (N === void 0)
        throw new Error("Received signature from unknown public key");
      e |= 1 << N;
    }
    let o = {
      sigs: s,
      bitmap: e,
      multisig_pk: this.multisigPublicKey
    };
    const u = ye.MultiSig.serialize(o, { maxSize: 8192 }).toBytes();
    let g = new Uint8Array(u.length + 1);
    return g.set([Me.MultiSig]), g.set(u, 1), se(g);
  }
}
function Za(r) {
  let t = new Array(r.sigs.length);
  for (let e = 0; e < r.sigs.length; e++) {
    const [s, o] = Object.entries(r.sigs[e])[0], u = Ya(r.bitmap).at(e), g = r.multisig_pk.pk_map[u], h = Uint8Array.from(Object.values(g.pubKey)[0]);
    if (s === "MultiSig")
      throw new Error("MultiSig is not supported inside MultiSig");
    const l = rs(s, h);
    t[e] = {
      signatureScheme: s,
      signature: Uint8Array.from(o),
      publicKey: l,
      weight: g.weight
    };
  }
  return t;
}
function Ya(r) {
  if (r < 0 || r > 1024)
    throw new Error("Invalid bitmap");
  let t = [];
  for (let e = 0; e < 10; e++)
    r & 1 << e && t.push(e);
  return Uint8Array.from(t);
}
async function Wa(r, t) {
  const e = ci(t);
  if (!await e.publicKey.verifyPersonalMessage(
    r,
    e.serializedSignature
  ))
    throw new Error("Signature is not valid for the provided message");
  return e.publicKey;
}
async function Fa(r, t) {
  const e = ci(t);
  if (!await e.publicKey.verifyTransactionBlock(
    r,
    e.serializedSignature
  ))
    throw new Error("Signature is not valid for the provided TransactionBlock");
  return e.publicKey;
}
function ci(r) {
  const t = Je(r);
  if (t.signatureScheme === "MultiSig")
    return {
      ...t,
      publicKey: new Yr(t.multisig.multisig_pk)
    };
  if (t.signatureScheme === "ZkLogin")
    throw new Error("ZkLogin is not supported yet");
  const e = rs(
    t.signatureScheme,
    t.publicKey
  );
  return {
    ...t,
    publicKey: e
  };
}
function rs(r, t) {
  switch (r) {
    case "ED25519":
      return new Ys(t);
    case "Secp256k1":
      return new ii(t);
    case "Secp256r1":
      return new ai(t);
    case "MultiSig":
      return new Yr(t);
    case "ZkLogin":
      return new fi(t);
    default:
      throw new Error(`Unsupported signature scheme ${r}`);
  }
}
const gn = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, xn = {
  PROD: "https://sui.credenza3.com",
  STAGING: "https://sui.staging.credenza3.com",
  LOCAL: "http://localhost:8083"
};
function ui(r) {
  switch (r.env) {
    case gn.LOCAL:
      return xn.LOCAL;
    case gn.STAGING:
      return xn.STAGING;
    case gn.PROD:
      return xn.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
async function Xa(r) {
  try {
    const t = await fetch(`${ui(r)}/accounts/address`, {
      headers: {
        Authorization: `Bearer ${r.getAccessToken()}`
      }
    });
    if (!t.ok)
      throw new Error(t.statusText);
    return await t.json();
  } catch (t) {
    throw new Error(`Error requesting SUI address: ${t.message}`);
  }
}
async function Es(r, t) {
  try {
    const e = await fetch(`${ui(r)}/accounts/sign`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${r.getAccessToken()}`,
        "Content-type": "application/json"
      },
      body: JSON.stringify(t)
    });
    if (!e.ok)
      throw new Error(e.statusText);
    return await await e.json();
  } catch (e) {
    throw new Error(`Error Signing SUI data: ${e.message}`);
  }
}
const vs = {
  LOCALNET: "localnet",
  DEVNET: "devnet",
  TESTNET: "testnet",
  MAINNET: "mainnet"
}, Ja = {
  ERROR: "ERROR",
  INIT: "INIT",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT"
};
class Qa {
  constructor({ suiNetwork: t = vs.MAINNET }) {
    $e(this, "name", "sui");
    $e(this, "sdk");
    $e(this, "client");
    $e(this, "suiAddress");
    $e(this, "currentSuiNetwork");
    this.switchNetwork(t);
  }
  async _initialize(t) {
    this.sdk = t, this.sdk.on(Ja.LOGOUT, () => {
      this.suiAddress = void 0;
    });
  }
  _assureLogin() {
    const t = this.sdk.getAccessToken();
    if (!t)
      throw new Error("User is not logged in");
    return t;
  }
  switchNetwork(t) {
    if (this.client && this.currentSuiNetwork === t)
      throw new Error(`Already on sui ${t}`);
    return this.client = new jo({ url: Ii(t) }), this.currentSuiNetwork = t, this.suiAddress = void 0, { client: this.getSuiClient(), network: this.getNetworkName() };
  }
  getSuiClient() {
    return this.client;
  }
  getNetworkName() {
    return this.currentSuiNetwork;
  }
  async getAddress() {
    if (this._assureLogin(), !this.suiAddress) {
      const { address: t } = await Xa(this.sdk);
      this.suiAddress = t;
    }
    return this.suiAddress;
  }
  async signPersonalMessage(t) {
    this._assureLogin();
    const e = await Es(this.sdk, {
      method: this.signPersonalMessage.name,
      param: Buffer.from(t).toString("base64")
    });
    return await Wa(new TextEncoder().encode(t), e.signature), e;
  }
  async signTransactionBlock(t) {
    this._assureLogin(), t.setSenderIfNotSet(await this.getAddress());
    const e = await t.build({ client: this.client }), { signature: s } = await Es(this.sdk, {
      method: this.signTransactionBlock.name,
      param: Buffer.from(e).toString("base64")
    });
    return await Fa(e, s), { signature: s, transactionBlock: e };
  }
  async signAndExecuteTransactionBlock(t) {
    const e = await this.signTransactionBlock(t);
    return await this.client.executeTransactionBlock(e);
  }
}
$e(Qa, "SUI_NETWORK", vs);
export {
  Qa as SuiExtension
};
